import React, { useState, useEffect } from 'react';
import { genereazaContiut, parseazaRezultat, extrageTextDinWord } from './aiCompositor';
import { supabase } from './supabaseClient';
import Auth from './Auth';
import './App.css';
import Onboarding from './Onboarding';
import GdprOnboarding from './GdprOnboarding';
import SetarePassword from './SetarePassword';
import { invitaCont } from './invitatie';
import CompozitorV2, { compozitorV2Vizibil, grupDinAdresa } from './CompozitorV2';
import { useAlerte, ClopotelAlerte } from './ClopotelAlerte';
import InboxV3, { inboxV3Vizibil } from './InboxV3';
import { IconRetea } from './IconRetea';
import { GRUPE_DREPTURI, ETICHETE_DREPTURI, CHEI_DOAR_SUPER_ADMIN, comutaDrept, dreptBlocat } from './DrepturiClient';

import AlegePagina, { idListaDinAdresa } from './AlegePagina';
import PaginaClient, { PostariAprobate, stergeGrupPostari } from './PaginaClient';
import { PaginaAcasa, ProfilVoce } from './Acasa';
import {
  conecteazaFacebook as pornesteFacebook,
  conecteazaTikTok as pornesteTikTok,
  conecteazaLinkedIn as pornesteLinkedIn,
  deconecteazaRetea,
} from './conectare';
import { t, tArr, getLocale } from './i18n';
import { legal } from './legal';
import OraMinut from './OraMinut';
import CheiPriza from './CheiPriza';
import { CostAILunaScurt } from './CostAI';
import { ReguliModerare } from './Moderare';
import { RapoarteLunare } from './Raport';
import { TemeleZilei } from './Teme';
import BaraJosMobil, { IconLinie, IconMeniu } from './BaraJosMobil';
// Ecranul de asteptare. Supabase n-are termen propriu: cand serverul tace, cererea
// atarna la nesfarsit, iar pana pe 19 septembrie 2026 „Se incarca..." se invartea
// la infinit, fara sa spuna nimic. Dupa 15 secunde spune ce se intampla si da un
// buton. E aceeasi plasa ca la intrare (`cuTermen` din `Auth.js`), in celalalt loc.
const ASTEPTARE_ECRAN = 15000;

function EcranAsteptare({ text }) {
  const [expirat, setExpirat] = useState(false);
  useEffect(() => {
    const ceas = setTimeout(() => setExpirat(true), ASTEPTARE_ECRAN);
    return () => clearTimeout(ceas);
  }, []);
  const cadru = { minHeight: '100vh', background: '#F2F8F4', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'DM Sans', sans-serif", color: '#6B7280', padding: 20, boxSizing: 'border-box' };
  if (!expirat) return <div style={cadru}>{text}</div>;
  return (
    <div style={cadru}>
      <div style={{ textAlign: 'center', maxWidth: 340 }}>
        <div style={{ fontSize: 34, marginBottom: 12 }}>🔌</div>
        <div style={{ fontSize: 15, fontWeight: 600, color: '#0F3D22', marginBottom: 6 }}>{t('stare', 'serverMut')}</div>
        <div style={{ fontSize: 13, lineHeight: 1.5, marginBottom: 20 }}>{t('stare', 'serverMutDetaliu')}</div>
        <button onClick={() => window.location.reload()} style={{ background: '#1A6B3C', color: 'white', border: 'none', borderRadius: 10, padding: '10px 18px', fontFamily: "'DM Sans', sans-serif", fontSize: 14, cursor: 'pointer' }}>
          {t('stare', 'incearcaDinNou')}
        </button>
      </div>
    </div>
  );
}

// Ecranul de conectare la prima logare a clientului, oprit (INTERFATA_CLIENT_PLAN.md).
const ECRAN_CONECTARE_CLIENT = false;

const bibliotecaDemo = {
  1: [
    { id: 1, clientId: 1, numeEveniment: 'Inaugurare drum DN1A', data: '2026-03-28', taguri: ['inaugurare', 'drum', 'berceni', 'prahova'], fisiere: [
      { id: 1, nume: 'IMG_001.jpg', tip: 'imagine', url: null, marime: '2.4 MB' },
      { id: 2, nume: 'IMG_002.jpg', tip: 'imagine', url: null, marime: '3.1 MB' },
      { id: 3, nume: 'VIDEO_01.mp4', tip: 'video', url: null, marime: '45 MB' },
    ]},
    { id: 2, clientId: 1, numeEveniment: 'Ședință consiliu local', data: '2026-03-15', taguri: ['sedinta', 'consiliu', 'berceni'], fisiere: [
      { id: 4, nume: 'IMG_sedinta_01.jpg', tip: 'imagine', url: null, marime: '1.8 MB' },
      { id: 5, nume: 'IMG_sedinta_02.jpg', tip: 'imagine', url: null, marime: '2.2 MB' },
    ]},
  ],
  2: [
    { id: 3, clientId: 2, numeEveniment: 'Lansare transport electric', data: '2026-03-20', taguri: ['transport', 'electric', 'cluj', 'inovatie'], fisiere: [
      { id: 6, nume: 'transport_01.jpg', tip: 'imagine', url: null, marime: '3.5 MB' },
      { id: 7, nume: 'transport_02.jpg', tip: 'imagine', url: null, marime: '2.9 MB' },
    ]},
  ],
};

// Singura harta a publicarii, folosita de compositor SI de aprobare. O retea
// care nu e aici nu se publica: pana acum Instagram lipsea din verificari si
// postarile erau marcate "publicat" fara sa plece nicaieri.
const FUNCTIE_PUBLICARE = {
  facebook: 'facebook-publish',
  instagram: 'instagram-publish',
  tiktok: 'tiktok-publish',
  linkedin: 'linkedin-publish',
};

const RETELE = [
  { id: 'facebook',  label: 'Facebook',  culoare: '#1877F2', bg: '#EBF3FF' },
  { id: 'instagram', label: 'Instagram', culoare: '#E1306C', bg: '#FFF0F5' },
  { id: 'tiktok',    label: 'TikTok',    culoare: '#010101', bg: '#F0F0F0' },
  { id: 'youtube',   label: 'YouTube',   culoare: '#FF0000', bg: '#FFF0F0' },
  { id: 'twitter',   label: 'Twitter/X', culoare: '#000000', bg: '#F5F5F5' },
  { id: 'linkedin',  label: 'LinkedIn',  culoare: '#0A66C2', bg: '#E8F0FB' },
  { id: 'threads',   label: 'Threads',   culoare: '#000000', bg: '#F5F5F5' },
  { id: 'x',         label: 'X',         culoare: '#000000', bg: '#F5F5F5' },
];

const FORMATE = {
  facebook:  ['Feed', 'Reel', 'Story', 'Event'],
  instagram: ['Feed', 'Reel', 'Story', 'Carusel'],
  tiktok:    ['Video', 'Photo Mode'],
  youtube:   ['Video', 'Short', 'Premiere'],
  twitter:   ['Tweet', 'Thread'],
  linkedin:  ['Post', 'Articol', 'Document'],
};

// Instagram accepta DOAR JPEG la publicare — PNG si WebP sunt refuzate de API.
// Convertim la incarcare, ca sa nu descopere omul abia la publicare ca poza lui
// nu e buna. JPEG nu are canal de transparenta, deci zonele transparente se umplu
// cu ALB: graficele sunt aproape intotdeauna gandite pe fundal alb, negrul ar
// surprinde mai tare. Fisierele deja JPEG nu se ating, ca sa nu piarda calitate
// printr-o recodare inutila.
function laJpeg(fisier) {
  if (fisier.type === 'image/jpeg') return Promise.resolve({ fisier, convertit: false });
  return new Promise((rezolva, respinge) => {
    const obiectUrl = URL.createObjectURL(fisier);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(obiectUrl);
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#FFFFFF';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);
      canvas.toBlob(blob => {
        if (!blob) { respinge(new Error('conversie esuata')); return; }
        const nume = fisier.name.replace(/\.[^.]+$/, '') + '.jpg';
        rezolva({ fisier: new File([blob], nume, { type: 'image/jpeg' }), convertit: true });
      }, 'image/jpeg', 0.92);
    };
    img.onerror = () => { URL.revokeObjectURL(obiectUrl); respinge(new Error('imagine ilizibila')); };
    img.src = obiectUrl;
  });
}

const LIMITE_CARACTERE = {
  facebook:  { Feed: 63206, Reel: 2200, Story: 0, Event: 63206 },
  instagram: { Feed: 2200, Reel: 2200, Story: 0, Carusel: 2200 },
  tiktok:    { Video: 2200, 'Photo Mode': 2200 },
  youtube:   { Video: 5000, Short: 5000, Premiere: 5000 },
  twitter:   { Tweet: 280, Thread: 280 },
  linkedin:  { Post: 3000, Articol: 110000, Document: 3000 },
};

const LIMITE_VIDEO = {
  facebook: 4096, instagram: 100, tiktok: 287, youtube: 128000, twitter: 512, linkedin: 5120
};

const PREVIEW_RATIO = {
  facebook:  { Feed: 52.5, Reel: 177, Story: 177, Event: 52.5 },
  instagram: { Feed: 100, Reel: 177, Story: 177, Carusel: 100 },
  tiktok:    { Video: 177, 'Photo Mode': 100 },
  youtube:   { Video: 56.25, Short: 177, Premiere: 56.25 },
  twitter:   { Tweet: 56.25, Thread: 56.25 },
  linkedin:  { Post: 52.5, Articol: 52.5, Document: 52.5 },
};

const PREVIEW_LABEL = {
  facebook:  { Feed: '1200×630', Reel: '1080×1920', Story: '1080×1920', Event: '1200×630' },
  instagram: { Feed: '1080×1080', Reel: '1080×1920', Story: '1080×1920', Carusel: '1080×1080' },
  tiktok:    { Video: '1080×1920', 'Photo Mode': '1080×1080' },
  youtube:   { Video: '1280×720', Short: '1080×1920', Premiere: '1280×720' },
  twitter:   { Tweet: '1200×675', Thread: '1200×675' },
  linkedin:  { Post: '1200×627', Articol: '1200×627', Document: '1200×627' },
};

const ORE_RECOMANDATE = {
  facebook:  ['09:00', '13:00', '18:00', '20:00'],
  instagram: ['11:00', '17:00', '19:00', '21:00'],
  tiktok:    ['17:00', '19:00', '21:00', '22:00'],
  youtube:   ['10:00', '14:00', '17:00', '20:00'],
  twitter:   ['08:00', '12:00', '17:00', '21:00'],
  linkedin:  ['08:00', '10:00', '12:00', '17:00'],
};

function ziLocala(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
function oraLocala(d) {
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

// Calendarul aseaza postarea pe data programata. Publicarile imediate n-au una,
// deci cad pe ziua publicarii — altfel tot ce publici pe loc devine invizibil in
// calendar, si ramane vizibil doar ce ai amanat.
// publicat_la e o marca de timp UTC; o trecem prin Date ca ziua sa fie cea
// locala, altfel o postare de dupa miezul noptii apare cu o zi inainte.
// `publicat_la` NU e dovada ca postarea a plecat. Un declansator din baza,
// `trg_set_publicat_la`, pune marca in clipa in care randul devine „publicat", si
// nimeni nu o sterge daca randul se intoarce pe draft. Dovada plecarii e
// `external_post_id`. De aceea marca se citeste doar cand statusul o sustine:
// altfel drafturile ramase dintr-o incercare esuata apar in calendar, cu ora cu
// tot, desi n-au nici data programata, nici postare reala.
function dataPentruCalendar(row) {
  if (row.data_programata) return row.data_programata;
  if (row.status !== 'publicat' || !row.publicat_la) return null;
  const d = new Date(row.publicat_la);
  if (isNaN(d.getTime())) return null;
  return ziLocala(d);
}

// Perechea orei, si e nevoie de ea din acelasi motiv. `ora_programata` nu e goala
// cand nu programezi nimic: compozitorul porneste campul pe 10:00 si il salveaza
// asa si la publicarea pe loc, deci ora din rand e ora implicita a formularului,
// nu ora la care a plecat postarea. Ora conteaza doar impreuna cu data: fara
// `data_programata` nu exista programare, deci ora adevarata e cea a publicarii.
function oraPentruCalendar(row) {
  if (row.data_programata) return row.ora_programata || '';
  if (row.status !== 'publicat' || !row.publicat_la) return row.ora_programata || '';
  const d = new Date(row.publicat_la);
  if (isNaN(d.getTime())) return row.ora_programata || '';
  return oraLocala(d);
}

// Dupa o publicare pe loc randul se schimba in state, fara reincarcare din baza.
// Campurile de calendar trebuie sa iasa dupa aceleasi reguli ca la citire, altfel
// ecranul arata altceva inainte si dupa un refresh.
function campuriDupaPublicare(p, acumIso) {
  const d = new Date(acumIso);
  return {
    publicatLa: acumIso,
    dataCalendar: p.dataProgramata || ziLocala(d),
    oraCalendar: p.dataProgramata ? (p.ora || '') : oraLocala(d),
  };
}

// Cifrele din Analize, din profilul clientului si din pagina lui de acasa trebuie
// sa vina din acelasi loc, altfel cele trei ecrane se contrazic. Functia aduna
// raspunsurile celor doua retele intr-unul singur, de aceeasi forma.
// Un raspuns lipsa (client fara Instagram, de exemplu) nu goleste rezultatul,
// doar nu adauga nimic. Null se intoarce doar cand lipsesc AMANDOUA.
// Variatia fata de perioada anterioara. Null cand nu se poate calcula: daca
// inainte era zero, orice crestere ar da infinit, iar "+Infinity%" nu e o
// informatie. Atunci aratam doar cifra, fara sageata.
function variatie(acum, inainte) {
  if (typeof acum !== 'number' || typeof inainte !== 'number') return null;
  if (inainte === 0) return null;
  const p = ((acum - inainte) / Math.abs(inainte)) * 100;
  return { procent: Math.round(p), urca: p >= 0 };
}

function Sageata({ v }) {
  if (!v) return null;
  // Zero nu e crestere. O sageata verde in sus la 0% ar spune ca merge bine
  // cand de fapt nu s-a schimbat nimic.
  if (v.procent === 0) {
    return (
      <span style={{ fontSize: 11, color: '#9CA3AF', marginLeft: 6, whiteSpace: 'nowrap' }}>
        {'\u2192'} 0%
      </span>
    );
  }
  const culoare = v.urca ? '#1A6B3C' : '#B91C1C';
  return (
    <span style={{ fontSize: 11, color: culoare, marginLeft: 6, whiteSpace: 'nowrap' }}>
      {v.urca ? '\u2191' : '\u2193'}{Math.abs(v.procent)}%
    </span>
  );
}

// Grafic desenat direct in SVG. Fara biblioteci: proiectul n-are niciuna, iar
// pentru o linie pe zile nu merita adaugata una intreaga.
function GraficZile({ serie, cheie, culoare }) {
  const valori = (serie || []).map(p => p[cheie] ?? 0);
  if (valori.length < 2) return null;

  const L = 640, I = 160, sus = 12, jos = 24, stanga = 4, dreapta = 4;
  const maxim = Math.max(...valori, 1);
  const latime = L - stanga - dreapta;
  const inaltime = I - sus - jos;
  const pas = latime / (valori.length - 1);

  const puncte = valori.map((v, i) => [
    stanga + i * pas,
    sus + inaltime - (v / maxim) * inaltime,
  ]);
  const linie = puncte.map(([x, y], i) => `${i ? 'L' : 'M'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const arie = `${linie} L${puncte[puncte.length - 1][0].toFixed(1)},${(sus + inaltime).toFixed(1)} L${puncte[0][0].toFixed(1)},${(sus + inaltime).toFixed(1)} Z`;

  const primaZi = serie[0].zi;
  const ultimaZi = serie[serie.length - 1].zi;
  const ziScurt = z => { const [, l, zi] = z.split('-'); return `${zi}.${l}`; };

  return (
    <div style={{ marginTop: 8 }}>
      {/* Inaltime fixa, nu proportionala: pe un monitor lat, o inaltime calculata
          din latime transforma graficul intr-un perete. preserveAspectRatio="none"
          il lasa sa se intinda pe orizontala cat trebuie. */}
      <svg viewBox={`0 0 ${L} ${I}`} style={{ width: '100%', height: 170, display: 'block' }} preserveAspectRatio="none">
        <path d={arie} fill={culoare} opacity="0.10" />
        <path d={linie} fill="none" stroke={culoare} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
      </svg>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#9CA3AF', marginTop: 2 }}>
        <span>{ziScurt(primaZi)}</span>
        <span style={{ color: '#6B7280' }}>max {formatNr(maxim)}</span>
        <span>{ziScurt(ultimaZi)}</span>
      </div>
    </div>
  );
}

function adunaStatistici(intrari) {
  // Reteaua se da explicit, nu se ghiceste din randuri: un cont conectat dar fara
  // postari in perioada n-ar putea fi recunoscut altfel, si i-am pierde urmaritorii.
  const bune = intrari
    .map(i => {
      const r = i.raspuns;
      const d = (r && !r.error && r.data && !r.data.error) ? r.data : null;
      return d ? { retea: i.retea, d } : null;
    })
    .filter(Boolean);
  if (!bune.length) return null;
  const postari = bune.flatMap(({ retea, d }) => (d.postari || []).map(x => ({ ...x, retea: x.retea || retea })));
  const total = postari.reduce((a, x) => ({
    reactii: a.reactii + (x.reactii || 0),
    comentarii: a.comentarii + (x.comentarii || 0),
    distribuiri: a.distribuiri + (x.distribuiri || 0),
    engagement: a.engagement + (x.engagement || 0),
  }), { reactii: 0, comentarii: 0, distribuiri: 0, engagement: 0 });
  postari.sort((a, b) => b.engagement - a.engagement);
  // Urmaritorii se aduna intre retele: e o cifra de moment, nu pe perioada, deci
  // nu se compara cu nimic, doar se insumeaza. Null inseamna "nu stim", nu zero.
  const cuUrmaritori = bune.filter(({ d }) => typeof d.urmaritori === 'number');
  // Defalcarea pe retea: doar retelele care chiar au ceva. Una neconectata nu
  // apare deloc, in loc sa apara cu zerouri — un zero arata a prabusire, nu a
  // absenta.
  const peRetea = {};
  for (const { retea, d } of bune) {
    const ale = postari.filter(x => x.retea === retea);
    const urm = typeof d.urmaritori === 'number' ? d.urmaritori : null;
    if (!ale.length && urm === null) continue;
    peRetea[retea] = {
      postari: ale.length,
      reactii: ale.reduce((a, x) => a + (x.reactii || 0), 0),
      comentarii: ale.reduce((a, x) => a + (x.comentarii || 0), 0),
      distribuiri: ale.reduce((a, x) => a + (x.distribuiri || 0), 0),
      engagement: ale.reduce((a, x) => a + (x.engagement || 0), 0),
      urmaritori: urm,
    };
  }
  return {
    ok: true,
    peRetea,
    urmaritori: cuUrmaritori.length ? cuUrmaritori.reduce((a, { d }) => a + d.urmaritori, 0) : null,
    total: {
      ...total,
      postari: postari.length,
      medie_engagement: postari.length ? Math.round(total.engagement / postari.length * 10) / 10 : 0,
    },
    postari,
  };
}

const STATUS_INFO = {
  draft:           { label: 'Draft',               culoare: '#9CA3AF', bg: '#F3F4F6' },
  intern:          { label: 'În așteptare intern', culoare: '#D97706', bg: '#FEF3C7' },
  aprobare_finala: { label: 'Așteaptă aprobare',   culoare: '#2563EB', bg: '#EFF6FF' },
  aprobat:         { label: 'Aprobat',             culoare: '#1A6B3C', bg: '#D4EDE0' },
  programat:       { label: 'Programat',           culoare: '#7C3AED', bg: '#EDE9FE' },
  publicat:        { label: 'Publicat',            culoare: '#059669', bg: '#D1FAE5' },
  respins:         { label: 'Respins',             culoare: '#DC2626', bg: '#FEE2E2' },
};
// ── Unicode Bold / Italic ────────────────────────────────────
const UNICODE_MAP = {
  bold: {
    a:'𝗮',b:'𝗯',c:'𝗰',d:'𝗱',e:'𝗲',f:'𝗳',g:'𝗴',h:'𝗵',i:'𝗶',j:'𝗷',k:'𝗸',l:'𝗹',m:'𝗺',
    n:'𝗻',o:'𝗼',p:'𝗽',q:'𝗾',r:'𝗿',s:'𝘀',t:'𝘁',u:'𝘂',v:'𝘃',w:'𝘄',x:'𝘅',y:'𝘆',z:'𝘇',
    A:'𝗔',B:'𝗕',C:'𝗖',D:'𝗗',E:'𝗘',F:'𝗙',G:'𝗚',H:'𝗛',I:'𝗜',J:'𝗝',K:'𝗞',L:'𝗟',M:'𝗠',
    N:'𝗡',O:'𝗢',P:'𝗣',Q:'𝗤',R:'𝗥',S:'𝗦',T:'𝗧',U:'𝗨',V:'𝗩',W:'𝗪',X:'𝗫',Y:'𝗬',Z:'𝗭',
    '0':'𝟬','1':'𝟭','2':'𝟮','3':'𝟯','4':'𝟰','5':'𝟱','6':'𝟲','7':'𝟳','8':'𝟴','9':'𝟵',
  },
  italic: {
    a:'𝘢',b:'𝘣',c:'𝘤',d:'𝘥',e:'𝘦',f:'𝘧',g:'𝘨',h:'𝘩',i:'𝘪',j:'𝘫',k:'𝘬',l:'𝘭',m:'𝘮',
    n:'𝘯',o:'𝘰',p:'𝘱',q:'𝘲',r:'𝘳',s:'𝘴',t:'𝘵',u:'𝘶',v:'𝘷',w:'𝘸',x:'𝘹',y:'𝘺',z:'𝘻',
    A:'𝘈',B:'𝘉',C:'𝘊',D:'𝘋',E:'𝘌',F:'𝘍',G:'𝘎',H:'𝘏',I:'𝘐',J:'𝘑',K:'𝘒',L:'𝘓',M:'𝘔',
    N:'𝘕',O:'𝘖',P:'𝘗',Q:'𝘘',R:'𝘙',S:'𝘚',T:'𝘛',U:'𝘜',V:'𝘝',W:'𝘞',X:'𝘟',Y:'𝘠',Z:'𝘡',
  },
};

function convertesteUnicode(text, tip) {
  const map = UNICODE_MAP[tip];
  return text.split('').map(c => map[c] || c).join('');
}

// ── Categorii emoji pentru picker ───────────────────────────
const EMOJI_CATEGORII = [
  { label: '⭐ Frecvente', emoji: ['👍','❤️','🙏','📢','🏗️','🌱','✅','🎉','💪','🤝','📊','🏛️','🚀','💡','🔑','📌','⚡','🌟','👏','🎯'] },
  { label: '😊 Fețe', emoji: ['😀','😊','🙂','😄','😁','🥰','😍','🤩','😎','🤗','🙏','👋','👍','👎','✌️','🤞','💪','🫶','❤️','💚'] },
  { label: '🏙️ Locuri', emoji: ['🏛️','🏗️','🏘️','🏫','🏥','🌆','🌇','🌉','🗺️','📍','🏡','🌳','🌱','🌿','🏞️','🛣️','🚧','⛪','🕌','🌐'] },
  { label: '📋 Activitate', emoji: ['📊','📈','📉','📋','📌','📎','✅','❌','⚡','💡','🔑','🔒','📢','📣','🎯','🚀','⭐','🌟','💫','✨'] },
  { label: '🎉 Evenimente', emoji: ['🎉','🎊','🎈','🎁','🏆','🥇','🎖️','🏅','🎗️','🎀','🎂','🎆','🎇','✨','💥','🔥','⚡','🌈','🌸','🌺'] },
];

function EmojiPicker({ onSelectEmoji, onClose }) {
  const [catActiva, setCatActiva] = useState(0);
  const [cautare, setCautare] = useState('');
  const ref = React.useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [onClose]);

  const emojiFiltrate = cautare
    ? EMOJI_CATEGORII.flatMap(c => c.emoji).filter(e => e.includes(cautare))
    : EMOJI_CATEGORII[catActiva].emoji;

  return (
    <div ref={ref} style={{
      position: 'absolute', zIndex: 1000, bottom: '110%', left: 0,
      background: 'white', border: '1.5px solid #D1E8DA', borderRadius: 14,
      boxShadow: '0 8px 32px rgba(0,0,0,0.12)', width: 320, padding: 12,
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <input
        autoFocus
        placeholder="Caută emoji..."
        value={cautare}
        onChange={e => setCautare(e.target.value)}
        style={{
          width: '100%', border: '1.5px solid #D1E8DA', borderRadius: 8,
          padding: '7px 12px', fontSize: 13, marginBottom: 10,
          fontFamily: "'DM Sans', sans-serif", outline: 'none', boxSizing: 'border-box',
        }}
      />
      {!cautare && (
        <div style={{ display: 'flex', gap: 4, marginBottom: 10, flexWrap: 'wrap' }}>
          {EMOJI_CATEGORII.map((cat, i) => (
            <button key={i} onClick={() => setCatActiva(i)} style={{
              border: 'none', borderRadius: 6, padding: '4px 8px', cursor: 'pointer',
              fontSize: 12, background: catActiva === i ? '#D4EDE0' : '#F3F4F6',
              color: catActiva === i ? '#1A6B3C' : '#6B7280', fontWeight: catActiva === i ? 600 : 400,
            }}>{cat.label}</button>
          ))}
        </div>
      )}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: 2 }}>
        {emojiFiltrate.map((emoji, i) => (
          <button key={i} onClick={() => onSelectEmoji(emoji)} style={{
            border: 'none', background: 'none', cursor: 'pointer', fontSize: 20,
            padding: '4px 2px', borderRadius: 6, lineHeight: 1,
            transition: 'background 0.1s',
          }}
          onMouseEnter={e => e.target.style.background = '#F2F8F4'}
          onMouseLeave={e => e.target.style.background = 'none'}
          >{emoji}</button>
        ))}
      </div>
    </div>
  );
}

function TextToolbar({ textareaRef, value, onChange }) {
  const [showEmoji, setShowEmoji] = useState(false);

  function aplicaFormatare(tip) {
    const el = textareaRef.current;
    if (!el) return;
    const start = el.selectionStart;
    const end = el.selectionEnd;
    const selectat = value.slice(start, end);
    if (!selectat) return;
    const convertit = convertesteUnicode(selectat, tip);
    const nouText = value.slice(0, start) + convertit + value.slice(end);
    onChange(nouText);
    // Restaurăm selecția după render
    setTimeout(() => {
      el.focus();
      el.setSelectionRange(start, start + convertit.length);
    }, 0);
  }

  function insereazăEmoji(emoji) {
    const el = textareaRef.current;
    if (!el) return;
    const pos = el.selectionStart ?? value.length;
    const nouText = value.slice(0, pos) + emoji + value.slice(pos);
    onChange(nouText);
    setTimeout(() => { el.focus(); el.setSelectionRange(pos + emoji.length, pos + emoji.length); }, 0);
    setShowEmoji(false);
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 6, position: 'relative' }}>
      <button
        type="button"
        title="Bold (selectează text mai întâi)"
        onClick={() => aplicaFormatare('bold')}
        style={{
          border: '1.5px solid #D1E8DA', borderRadius: 7, background: 'white',
          padding: '5px 10px', cursor: 'pointer', fontWeight: 700, fontSize: 14,
          color: '#1A6B3C', lineHeight: 1, transition: 'all 0.15s',
        }}
        onMouseEnter={e => { e.target.style.background = '#D4EDE0'; }}
        onMouseLeave={e => { e.target.style.background = 'white'; }}
      >𝗕</button>
      <button
        type="button"
        title="Italic (selectează text mai întâi)"
        onClick={() => aplicaFormatare('italic')}
        style={{
          border: '1.5px solid #D1E8DA', borderRadius: 7, background: 'white',
          padding: '5px 10px', cursor: 'pointer', fontSize: 14, fontStyle: 'italic',
          color: '#1A6B3C', lineHeight: 1, fontWeight: 600, transition: 'all 0.15s',
        }}
        onMouseEnter={e => { e.target.style.background = '#D4EDE0'; }}
        onMouseLeave={e => { e.target.style.background = 'white'; }}
      >𝘐</button>
      <div style={{ width: 1, height: 20, background: '#D1E8DA', margin: '0 2px' }} />
      <button
        type="button"
        title="Inserează emoji"
        onClick={() => setShowEmoji(v => !v)}
        style={{
          border: '1.5px solid #D1E8DA', borderRadius: 7, background: showEmoji ? '#D4EDE0' : 'white',
          padding: '5px 10px', cursor: 'pointer', fontSize: 16, lineHeight: 1,
          transition: 'all 0.15s',
        }}
        onMouseEnter={e => { if (!showEmoji) e.target.style.background = '#F2F8F4'; }}
        onMouseLeave={e => { if (!showEmoji) e.target.style.background = 'white'; }}
      >😊</button>
      <span style={{ fontSize: 12, color: '#9CA3AF', marginLeft: 4 }}>
        {t('compositor', 'selecteazaTextBI')}
      </span>
      {showEmoji && (
        <EmojiPicker
          onSelectEmoji={insereazăEmoji}
          onClose={() => setShowEmoji(false)}
        />
      )}
    </div>
  );
}
const TIP_INFO = {
  comentariu: { label: 'Comentariu', icon: '💬' },
  mesaj:      { label: 'Mesaj',      icon: '✉️' },
  mentiune:   { label: 'Mențiune',   icon: '📢' },
};

function formatNr(n) {
  if (n >= 1000) return (n / 1000).toFixed(1) + 'K';
  return n.toString();
}

// Aprobarea respecta data (decizia Luminitei, 15 septembrie 2026, FAZA6_PLAN.md):
// o postare cu data si ora in viitor se PROGRAMEAZA la aprobare, nu pleaca pe loc.
// Ora se compara cu ceasul calculatorului; cronul numara in ora Romaniei.
function areProgramareInViitor(postare) {
  if (!postare || !postare.data_programata || !postare.ora_programata) return false;
  return new Date(`${postare.data_programata}T${String(postare.ora_programata).slice(0, 5)}:00`) > new Date();
}

// Faza 6, Pasul 8: o postare scrisa in compozitorul nou (are grup) se deschide
// acolo, cu toate cardurile grupului. Grupul se pune in adresa, iar compozitorul il
// citeste cand se deschide, exact ca dupa F5. Postarile vechi (fara grup) raman pe
// compozitorul vechi pana la Faza 7.
function deschidePostarea(postare, setPaginaActiva, setPostareEdit) {
  if (postare && postare.grupId && compozitorV2Vizibil) {
    const adresa = new URL(window.location.href);
    adresa.searchParams.set('grup', postare.grupId);
    window.history.replaceState(window.history.state, '', adresa.pathname + adresa.search + adresa.hash);
    if (setPostareEdit) setPostareEdit(null);
    setPaginaActiva('compositor2');
    return;
  }
  if (setPostareEdit) setPostareEdit(postare);
  setPaginaActiva('compositor');
}

// Alerta de aprobare (19 octombrie 2026): grupul in adresa si compozitorul deschis din nou,
// chiar daca era deja deschis pe alt grup (compozitorul citeste grupul doar cand porneste).
function deschideGrupul(grupId, setPaginaActiva, setCheieCompozitor, postareId = null) {
  const adresa = new URL(window.location.href);
  adresa.searchParams.set('grup', grupId);
  // Compozitorul duce ecranul la cartonul acesta si il lumineaza o clipa (`postareDinAdresa`).
  if (postareId) adresa.searchParams.set('postare', postareId);
  else adresa.searchParams.delete('postare');
  window.history.replaceState(window.history.state, '', adresa.pathname + adresa.search + adresa.hash);
  setCheieCompozitor(n => n + 1);
  setPaginaActiva('compositor2');
}

function normalizeazaPostare(row) {
  return {
    id: row.id,
    clientId: row.client_id,
    client: row.client_nume,
    retea: row.retea,
    // De unde vine postarea: 'nativ' = facuta de client direct pe retea, adusa de
    // `facebook-postari` pentru Inbox. Vezi filtrul din `incarcaPostari`.
    source: row.source || null,
    format: row.format,
    text: row.text,
    hashtags: row.hashtags,
    status: row.status,
    creatDe: row.creat_de_nume,
    dataProgramata: row.data_programata,
    ora: row.ora_programata,
    feedback: row.feedback,
    publicatLa: row.publicat_la,
    // Cand a fost scrisa. Fila de ciorne se aseaza dupa ea (PaginaClient.js, `momentulCrearii`).
    creatLa: row.created_at || null,
    externalPostId: row.external_post_id,
    dataCalendar: dataPentruCalendar(row),
    oraCalendar: oraPentruCalendar(row),
    imagineUrl: row.imagine_url,
    imaginiUrl: row.imagini_url || null,
    videoUrl: row.video_url,
    // Coperta aleasa pentru film (19 sept 2026); calendarul o arata ca miniatura.
    copertaUrl: row.coperta_url || null,
    // Ce pleaca odata cu postarea, dar nu sta in text. Ecranul de aprobare le arata (13 oct 2026).
    titluTikTok: row.tiktok_titlu || null,
    primComentariu: row.prim_comentariu || null,
    // Compozitorul nou: cardurile scrise impreuna au acelasi grup. Null la postarile vechi.
    grupId: row.grup_id || null,
    // Motivul ultimei publicari picate (pasul 3). Fara el, banda „De stiut" de pe
    // pagina clientului n-ar avea ce arata: motivul era scris in baza si nu ajungea
    // niciodata in interfata.
    eroarePublicare: row.eroare_publicare || null,
    eroareLa: row.eroare_la || null,
    // Cand a aprobat clientul (scris de trigger in baza, 16 sept 2026).
    aprobatLa: row.aprobat_la || null,
    // Primul comentariu care n-a plecat, desi postarea a plecat (Faza 3).
    comentariuEroare: row.comentariu_eroare || null,
  };
}

// Ramane pentru Inboxul vechi (pastrat in cod, neafisat); de la 12 octombrie 2026 nu o mai cheama nimeni.
// eslint-disable-next-line no-unused-vars
function normalizeazaMesaj(row) {
  return {
    id: row.id,
    clientId: row.client_id,
    client: row.client,
    retea: row.retea,
    tip: row.tip,
    autor: row.autor,
    text: row.text,
    timp: row.timp,
    citit: row.citit,
    postare: row.postare,
    // Adresa pe rețea (mențiuni, 17 sept 2026). Rândurile culese înainte n-au
    // coloana completată, dar `external_id` e chiar id-ul obiectului de pe
    // Facebook, iar adresa se poate construi din el — deci și mențiunile vechi
    // primesc buton.
    link: row.link
      || (row.tip === 'mentiune' && row.retea === 'facebook' && row.external_id
        ? `https://www.facebook.com/${row.external_id}`
        : null),
    // Momentul in care a intrat randul. Webhook-ul insereaza in cateva secunde de
    // la mesaj, deci e destul de aproape ca sa masuram fereastra de raspuns.
    primitLa: row.created_at,
    raspunsTrimisLa: row.raspuns_trimis_la,
    raspunsText: row.raspuns_text,
    arhivat: row.arhivat,
    // Comentariul a fost ascuns din aplicatie (mesaje_ascuns.sql). Nu stie de ascunderile
    // facute direct in retea.
    ascuns: !!row.ascuns,
    mediaUrl: row.media_url,
    mediaTip: row.media_tip,
  };
}

function App() {
  const [sesiune, setSesiune] = useState(null);
  const [loading, setLoading] = useState(true);
  const [profilUtilizator, setProfilUtilizator] = useState(null);
  const [permisiuniClient, setPermisiuniClient] = useState(null);
  const [clientLogat, setClientLogat] = useState(null);
  const [onboardingComplet, setOnboardingComplet] = useState(false);
  const [conectareGata, setConectareGata] = useState(false);
  const [acordGdpr, setAcordGdpr] = useState(null);
  const [needsPasswordSetup, setNeedsPasswordSetup] = useState(false);
  // Un grup din compozitorul nou in adresa (?grup=) redeschide compozitorul dupa F5.
  const [paginaActiva, setPaginaActiva] = useState(() => (grupDinAdresa() ? 'compositor2' : 'acasa'));
  const [clientPagina, setClientPagina] = useState(null);
  const [postareEdit, setPostareEdit] = useState(null);
  const [profiluri, setProfiluri] = useState({});
  const [postari, setPostari] = useState([]);
  const [clienti, setClienti] = useState([]);
  const [mesaje, setMesaje] = useState([]);
  const [biblioteca, setBiblioteca] = useState(bibliotecaDemo);
  // Clientul ales, tinut minte intre vizite, separat pentru fiecare utilizator (vezi
  // `clientAlesDinBrowser`). Sesiunea nu e cunoscuta la prima randare, deci alegerea se
  // citeste abia cand se afla cine e logat — si se reciteste daca se schimba contul.
  const [clientAlesId, setClientAlesIdStare] = useState(null);
  const idUtilizatorLogat = sesiune?.user?.id || null;
  useEffect(() => { setClientAlesIdStare(clientAlesDinBrowser(idUtilizatorLogat)); }, [idUtilizatorLogat]);
  function setClientAles(id) { setClientAlesIdStare(id); scrieClientAles(idUtilizatorLogat, id); }
  // Daca clientul tinut minte nu mai exista (sters, sau lista inca se incarca),
  // ecranele arata tot, in loc sa arate gol. Valoarea din browser NU se sterge.
  const clientAlesObiect = clienti.find(c => c.id === clientAlesId) || null;
  const filtreazaDupaClient = (lista) => clientAlesObiect
    ? lista.filter(x => x.clientId === clientAlesObiect.id)
    : lista;
  const clientiVizibili = clientAlesObiect ? [clientAlesObiect] : clienti;
  const postariVizibile = filtreazaDupaClient(postari);
  const mesajeVizibile = filtreazaDupaClient(mesaje);
  // Cu ce tab se deschide pagina clientului, cand se intra din blocul din meniu.
  const [, setTabClient] = useState('postari');
  const profilUtilizatorRef = React.useRef(null);
  useEffect(() => { profilUtilizatorRef.current = profilUtilizator; }, [profilUtilizator]);

  // Detectare flux user invitat (Supabase emite SIGNED_IN cu type=signup în hash)
  useEffect(() => {
    const hash = window.location.hash || '';
    if (hash.includes('type=signup') || hash.includes('type=recovery') || hash.includes('type=invite')) {
      setNeedsPasswordSetup(true);
    }
  }, []);

  useEffect(() => {
  async function incarcaProfil(session) {
    if (!session) {
      setProfilUtilizator(null);
      setPermisiuniClient(null);
      setClientLogat(null);
      setOnboardingComplet(false);
      setAcordGdpr(null);
      setLoading(false);
      return;
    }
    const { data: profil, error: errProfil } = await supabase
      .from('profiluri')
      .select('rol, nume, client_id')
      .eq('user_id', session.user.id)
      .maybeSingle();
    // Un cont fara profil nu e al nimanui: vede „fara acces", nu interfata agentiei (9 octombrie
    // 2026, AUDIT_SECURITATE_PLAN.md). Pana atunci ecranul il trata drept super admin; baza nu-i
    // dadea nimic, dar omul vedea meniurile.
    // O citire picata (retea) nu e „fara profil": daca stiam deja cine e omul, ramane cum era.
    if (!profil && errProfil && profilUtilizatorRef.current) { setLoading(false); return; }
    setProfilUtilizator(profil || { rol: 'fara_acces', nume: '' });
    const { data: acord } = await supabase
      .from('acorduri_gdpr')
      .select('id')
      .eq('user_id', session.user.id)
      .maybeSingle();
    setAcordGdpr(!!acord);
    if (profil && profil.rol === 'client') {
      const { data: ob } = await supabase
        .from('onboarding')
        .select('completat')
        .eq('user_id', session.user.id)
        .single();
      setOnboardingComplet(ob ? ob.completat : false);
      if (profil.client_id) {
        const { data: clientRow } = await supabase
          .from('clienti')
          // `status` e necesar: compozitorul nou pune in lista doar clientii activi
          // (fara el, contul de client avea lista goala — gasit la proba din 16 sept).
          .select('id, nume, functie, localitate, status, permisiuni_client')
          .eq('id', profil.client_id)
          .single();
        setPermisiuniClient(clientRow ? clientRow.permisiuni_client : null);
        setClientLogat(clientRow || null);
      }
    } else {
      setOnboardingComplet(true);
    }
    setLoading(false);
  }

  supabase.auth.getSession().then(({ data: { session } }) => {
    setSesiune(session);
    incarcaProfil(session);
  });

  const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
    if (event === 'PASSWORD_RECOVERY') {
      setSesiune(session);
      setNeedsPasswordSetup(true);
      return;
    }
    setSesiune(session);
    if (event === 'TOKEN_REFRESHED') return;
    if (event === 'USER_UPDATED' && profilUtilizatorRef.current) return;
    incarcaProfil(session);
  });

  return () => subscription.unsubscribe();
}, []);

useEffect(() => {
  async function incarcaClienti() {
    if (!sesiune) return;
    const { data, error } = await supabase
      .from('clienti')
      .select('*')
      .order('created_at', { ascending: false });
    if (error) { console.error('Eroare clienti:', error); return; }
    if (!data || data.length === 0) return;
    const { data: prof } = await supabase
      .from('profiluri')
      .select('user_id, client_id')
      .eq('rol', 'client')
      .not('client_id', 'is', null);
    const userToClient = {};
    (prof || []).forEach(p => { userToClient[p.user_id] = p.client_id; });
    const userIds = (prof || []).map(p => p.user_id);
    const inrolat = new Set();
    if (userIds.length > 0) {
      const { data: ob } = await supabase
        .from('onboarding')
        .select('user_id, completat')
        .in('user_id', userIds);
      (ob || []).forEach(o => { if (o.completat && userToClient[o.user_id]) inrolat.add(userToClient[o.user_id]); });
    }
    // `are_cont` desparte „Fara cont" de „Invitat" (24 septembrie 2026). Inainte, orice client
    // neinrolat scria „Invitat", si Dan Neicu, care n-a primit niciodata vreo invitatie, parea
    // ca asteapta sa intre.
    const cuCont = new Set(Object.values(userToClient));
    setClienti(data.map(c => ({ ...c, inrolat: inrolat.has(c.id), are_cont: cuCont.has(c.id) })));
  }
  incarcaClienti();
}, [sesiune]);

useEffect(() => {
  async function incarcaPostari() {
    if (!sesiune) return;
    const { data, error } = await supabase
      .from('postari')
      .select('*')
      .order('created_at', { ascending: false });
    if (error) { console.error('Eroare postari:', error); return; }
    // Postarile native (facute de client direct pe retea, aduse de `facebook-postari` ca sa
    // aiba comentariile de ce sa se agate) NU sunt postari de redactie: n-au ce cauta in
    // Calendar, in De aprobat, in Drafturi, in fisa clientului sau in interfata clientului.
    // Se scot AICI, intr-un singur loc, nu in cele douazeci de filtre de mai jos. Inbox V3 le
    // cere separat din baza. (Inbox V3, reparatia 4 — 18 septembrie 2026.)
    if (data) setPostari(data.map(normalizeazaPostare).filter(p => p.source !== 'nativ'));
  }
  incarcaPostari();
}, [sesiune]);

// Mesajele NU se mai incarca la pornire (12 octombrie 2026). Pana azi, fiecare deschidere a
// aplicatiei descarca TOATA tabela `mesaje`, in pagini de 1.000, pentru Inboxul vechi — care din
// 18 septembrie nu mai e afisat nicaieri (Inbox V3 isi citeste singur ce-i trebuie). Citirea era
// si scumpa: regula de acces intreaba `este_super_admin()` pentru fiecare rand. In noaptea de
// 11 spre 12 octombrie, cateva zeci de deschideri apropiate au dus procesorul bazei la 84%,
// interogarile au inceput sa fie taiate („statement timeout") si nimeni nu s-a mai putut loga.
// `mesaje` ramane o lista goala, ca sa nu se strice interfetele care o primesc.
// Daca Inboxul vechi se repune vreodata pe ecran, isi incarca singur mesajele, la deschidere.

  // Clic pe un client din „Clienți" îl face clientul ales în toată aplicația
  // și îi deschide pagina (decizia 5a, 16 septembrie 2026).
  function deschideClient(client) { setClientAles(client.id); setTabClient('postari'); setClientPagina(client); setPaginaActiva('profil_client'); }

  // Blocul clientului, pasul 5: ce ține de clientul ales. „Conturi conectate" nu
  // are încă tab propriu — deschide pagina lui, unde stau butoanele de conectare;
  // primește secțiune adevărată la pasul 6.
  function deschideClientPeTab(tab) {
    if (!clientAlesObiect) return;
    setTabClient(tab);
    setClientPagina(clientAlesObiect);
    setPaginaActiva('profil_client');
  }
  const sectiuniClient = [
    { id: 'conturi',    icon: '🔌', label: t('sidebar', 'conturiConectate'), cereClient: true, onClick: () => deschideClientPeTab('postari') },
    { id: 'voce',       icon: '🗣️', label: t('sidebar', 'profilDeVoce'),     cereClient: true, onClick: () => { setClientPagina(null); setPaginaActiva('voce'); } },
    // Regulile de moderare ale clientului (etapa 7, bucata 2 — 14 oct 2026): langa Profilul de voce,
    // doar in interfata de super_admin. Managerul si clientul nu le au.
    { id: 'moderare',   icon: '🛡️', label: t('sidebar', 'reguliModerare'),   cereClient: true, onClick: () => { setClientPagina(null); setPaginaActiva('moderare'); } },
    // Raportul lunar pentru client (etapa 7, bucata 7 — 15 oct 2026): arhiva, doar super admin.
    { id: 'raport',     icon: '📄', label: t('sidebar', 'raportLunar'),      cereClient: true, onClick: () => { setClientPagina(null); setPaginaActiva('raport'); } },
    // Temele zilei (15 oct 2026, TEME_PLAN.md): propunerile de reactie pe clientul ales.
    { id: 'teme',       icon: '📰', label: t('sidebar', 'temeleZilei'),      cereClient: true, onClick: () => { setClientPagina(null); setPaginaActiva('teme'); } },
    { id: 'echipa',     icon: '👤', label: t('sidebar', 'echipa'),           onClick: () => { setClientPagina(null); setPaginaActiva('echipa'); } },
    { id: 'biblioteca', icon: '🖼️', label: t('sidebar', 'bibliotecaMedia'),  onClick: () => { setClientPagina(null); setPaginaActiva('biblioteca'); } },
    // Cheile prizei: doar aici, in interfata de super_admin (managerul si clientul au interfetele lor).
    { id: 'asistent',   icon: '🔑', label: t('sidebar', 'asistent'),         onClick: () => { setClientPagina(null); setPaginaActiva('asistent'); } },
  ];
  function inapoiLaClienti() { setClientPagina(null); setPaginaActiva('clienti'); }
  async function handleLogout() { await supabase.auth.signOut(); }
  // Analize si Profilul de voce cer un client ales; fara el, duc inapoi Acasa.
  const paginaCereClient = paginaActiva === 'analize' || paginaActiva === 'voce' || paginaActiva === 'moderare' || paginaActiva === 'raport' || paginaActiva === 'teme';
  useEffect(() => {
    if (paginaCereClient && !clientAlesObiect && clienti.length) setPaginaActiva('acasa');
  }, [paginaCereClient, clientAlesObiect, clienti.length]);
  // Navigarea din meniu: Acasa sterge clientul ales (inapoi la toti clientii).
  function mergiDinMeniu(p) { setClientPagina(null); setPostareEdit(null); if (p === 'acasa') setClientAles(null); setPaginaActiva(p); }

  // Clopotelul (aprobarea prin link, pasul 6): doar pentru super admin aici; managerul are
  // clopotelul lui in InterfataManager. Un singur `useAlerte` pentru calculator si telefon.
  const [cheieCompozitor, setCheieCompozitor] = useState(0);
  const alerte = useAlerte(!!(sesiune && profilUtilizator && profilUtilizator.rol === 'super_admin'));
  const clopotel = mobil => (
    <ClopotelAlerte alerte={alerte} mobil={mobil}
      onDeschide={(g, p) => { setClientPagina(null); setPostareEdit(null); deschideGrupul(g, setPaginaActiva, setCheieCompozitor, p); }} />
  );

  
  if (needsPasswordSetup) {
    return <SetarePassword onSuccess={() => setNeedsPasswordSetup(false)} />;
  }

  if (loading) return <EcranAsteptare text={t('stare', 'seIncarca')} />;

  if (!sesiune) return <Auth />;

  if (profilUtilizator && profilUtilizator.rol === 'fara_acces') {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '16px', padding: '24px', textAlign: 'center', color: '#1F2A24' }}>
        <div style={{ fontSize: '20px', fontWeight: 600 }}>{t('stare', 'faraAccesTitlu')}</div>
        <div style={{ maxWidth: '420px', lineHeight: 1.5 }}>{t('stare', 'faraAccesText')}</div>
        <button className="btn-secundar" onClick={handleLogout}>{t('stare', 'faraAccesIesire')}</button>
      </div>
    );
  }

  if (!profilUtilizator) return <EcranAsteptare text={t('stare', 'seIncarcaProfilul')} />;

  // GDPR pentru toți utilizatorii noi — înainte de orice altceva
  if (acordGdpr === false) return (
    <GdprOnboarding
      user={sesiune.user}
      rolUser={profilUtilizator.rol}
      onAccept={() => setAcordGdpr(true)}
    />
  );

  // Dupa conectarea Facebook, pagina se alege aici, oricare ar fi rolul si ecranul pe care
  // s-ar fi aterizat (15 septembrie 2026, PAGINA_PRINCIPALA_PLAN.md).
  if (idListaDinAdresa()) return <AlegePagina />;

  if (profilUtilizator.rol === 'client' && !onboardingComplet) return <Onboarding sesiune={sesiune} onComplet={() => setOnboardingComplet(true)} />;
  // Ecranul „Connect your pages / coming soon" iesit din drum (INTERFATA_CLIENT_PLAN.md, 16 sept
  // 2026): conturile se conecteaza din pagina clientului. Componenta ramane in cod.
  if (ECRAN_CONECTARE_CLIENT && profilUtilizator.rol === 'client' && !conectareGata) return <ConectareRetele clientId={profilUtilizator.client_id} nume={profilUtilizator.nume} onGata={() => setConectareGata(true)} onLogout={handleLogout} />;
  const numeCont = (profilUtilizator && profilUtilizator.nume) || 'Luminița K.';

if (profilUtilizator.rol === 'manager') return <InterfataManager sesiune={sesiune} profilUtilizator={profilUtilizator} onLogout={handleLogout} postari={postari} setPostari={setPostari} mesaje={mesaje} setMesaje={setMesaje} biblioteca={biblioteca} setBiblioteca={setBiblioteca} />;
  if (profilUtilizator.rol === 'client') return <InterfataClient nume={profilUtilizator.nume} clientId={profilUtilizator.client_id} onLogout={handleLogout} postari={postari} setPostari={setPostari} mesaje={mesaje} setMesaje={setMesaje} permisiuniClient={permisiuniClient} clientLogat={clientLogat} sesiune={sesiune} profilUtilizator={profilUtilizator} />;

  return (
    <div className="app">
      <Sidebar clopotel={clopotel(false)} nume={numeCont} rol={profilUtilizator ? profilUtilizator.rol : null} paginaActiva={paginaActiva} setPaginaActiva={mergiDinMeniu} postari={postariVizibile} mesaje={mesajeVizibile} onLogout={handleLogout} clienti={clienti} clientAles={clientAlesObiect} setClientAles={setClientAles} toatePostarile={postari} sectiuniClient={sectiuniClient} onDeschideClient={() => clientAlesObiect && deschideClient(clientAlesObiect)} />
      <BaraSusMobil onClick={() => mergiDinMeniu('acasa')} nume={numeCont} rol={t('sidebar', 'superAdmin')} clopotel={clopotel(true)} />
      <MobileNavbar paginaActiva={paginaActiva} setPaginaActiva={mergiDinMeniu} postari={postariVizibile} sectiuni={sectiuniClient} clientAles={clientAlesObiect} onLogout={handleLogout} />
      <div className="continut-principal">
        <div className="antet-sus">
          <AntetClientAles client={clientAlesObiect} pagina={paginaActiva} />
          <SemnCont nume={numeCont} rol={t('sidebar', 'superAdmin')} />
        </div>
        {paginaActiva === 'acasa' && <PaginaAcasa clienti={clienti} postari={postari} onStergeGrup={(grup) => stergeGrupPostari(grup, setPostari)} retele={RETELE} statusInfo={STATUS_INFO} iconRetea={(id, size) => <IconRetea id={id} size={size} />} deschideGrup={(p) => deschidePostarea(p, setPaginaActiva, setPostareEdit)} deschideClient={deschideClient} />}
        {paginaActiva === 'voce' && clientAlesObiect && <ProfilVoce client={clientAlesObiect} />}
        {paginaActiva === 'moderare' && clientAlesObiect && <ReguliModerare client={clientAlesObiect} />}
        {paginaActiva === 'raport' && clientAlesObiect && <RapoarteLunare client={clientAlesObiect} />}
        {paginaActiva === 'teme' && clientAlesObiect && <TemeleZilei client={clientAlesObiect} rol="super_admin" />}
       {paginaActiva === 'clienti' && <ListaClienti clienti={clienti} setClienti={setClienti} profiluri={profiluri} setProfiluri={setProfiluri} deschideClient={deschideClient} postari={postari} />}
        {paginaActiva === 'profil_client' && clientPagina && <PaginaClient client={clientPagina} inapoiLaClienti={inapoiLaClienti} iconRetea={(id, size) => <IconRetea id={id} size={size} />} postari={postari} statusInfo={STATUS_INFO} retele={RETELE} deschideGrup={(p) => deschidePostarea(p, setPaginaActiva, setPostareEdit)} setPostari={setPostari} onStergeGrup={(grup) => stergeGrupPostari(grup, setPostari)} onDrepturiSalvate={(perm) => { setClienti(prev => prev.map(c => (c.id === clientPagina.id ? { ...c, permisiuni_client: perm } : c))); setClientPagina(prev => (prev ? { ...prev, permisiuni_client: perm } : prev)); }} onInvitat={(adresa) => { const cu = c => ({ ...c, are_cont: true, email: c.email || adresa }); setClienti(prev => prev.map(c => (c.id === clientPagina.id ? cu(c) : c))); setClientPagina(prev => (prev ? cu(prev) : prev)); }} />}
        {paginaActiva === 'compositor' && <Compositor clienti={clienti} profiluri={profiluri} clientPreSelectat={clientPagina || clientAlesObiect} biblioteca={biblioteca} setPostari={setPostari} sesiune={sesiune} profilUtilizator={profilUtilizator} postareEdit={postareEdit} setPostareEdit={setPostareEdit} setPaginaActiva={setPaginaActiva} />}
        {/* Compozitoarele primesc TOTI clientii, cu cel ales doar preselectat: decizia
            Luminitei a fost ca „Postare noua" porneste cu el, nu ca ii ascunde pe ceilalti. */}
        {paginaActiva === 'compositor2' && compozitorV2Vizibil && <CompozitorV2 key={cheieCompozitor} clienti={clienti} clientPreSelectat={clientAlesObiect ? clientAlesObiect.id : null} sesiune={sesiune} profilUtilizator={profilUtilizator} setPostari={setPostari} normalizeaza={normalizeazaPostare} />}
        {paginaActiva === 'calendar' && <Calendar postari={postariVizibile} clienti={clientiVizibili} setPaginaActiva={setPaginaActiva} setPostareEdit={setPostareEdit} />}
        {/* Inbox V3 a luat locul celui vechi pe 18 septembrie 2026, ca la compozitor: comutarea e
            AICI, intr-un singur loc. `Inbox` (cel vechi) ramane in cod, neatins, dar nu se mai
            ajunge la el din meniu. Stratul de AI se vede doar la super_admin (`areAI`). */}
        {paginaActiva === 'inbox' && inboxV3Vizibil && <InboxV3 clientPreSelectat={clientAlesObiect ? clientAlesObiect.id : null} sesiune={sesiune} rol={profilUtilizator ? profilUtilizator.rol : null} />}
        {paginaActiva === 'aprobare' && <Aprobare postari={postariVizibile} setPostari={setPostari} />}
        {paginaActiva === 'aprobate' && <PostariAprobate postari={postariVizibile} retele={RETELE} statusInfo={STATUS_INFO} iconRetea={(id, size) => <IconRetea id={id} size={size} />} deschideGrup={(p) => deschidePostarea(p, setPaginaActiva, setPostareEdit)} />}
        {paginaActiva === 'drafturi' && <Drafturi postari={postariVizibile} setPostari={setPostari} setPaginaActiva={setPaginaActiva} />}
        {paginaActiva === 'analize' && <Analize clienti={clientiVizibili} />}
        {paginaActiva === 'echipa' && <Echipa clienti={clienti} clientFiltru={clientAlesObiect} />}
        {paginaActiva === 'biblioteca' && <Biblioteca clienti={clientiVizibili} biblioteca={biblioteca} setBiblioteca={setBiblioteca} />}
        {paginaActiva === 'asistent' && <CheiPriza clienti={clienti} />}
      </div>
    </div>
  );
}

// ============================================================
// Clientul ales (16 septembrie 2026, PAGINA_CLIENT_PLAN.md, Etapa 4, pasul 4).
//
// Decizia Luminitei: „cand lucrezi la Gaga, vezi numai Gaga peste tot si nu
// amesteci postarile intre clienti. Iar cand vrei ansamblul, alegi «Toti
// clientii»." Alegerea se tine minte intre vizite, ca limba (`nm_lang`).
//
// `null` inseamna „Toti clientii". Citirea si scrierea sunt in try/catch:
// intr-o fereastra privata localStorage poate arunca, si atunci aplicatia
// trebuie sa mearga mai departe, nu sa se opreasca.
// ============================================================
// SEPARAT PENTRU FIECARE UTILIZATOR (16 septembrie 2026). La inceput cheia era
// una singura pe browser, `nm_client_ales`: Luminita s-a logat ca manager, managerul
// a lucrat pe Client Test, iar dupa relogarea ca super_admin, in acelasi browser,
// alegerea managerului a trecut la ea — compozitorul nu-i mai arata ceilalti clienti.
// Cheia veche, comuna, se sterge la prima citire, ca sa nu mai poata trece de la un
// cont la altul.
function cheieClientAles(userId) {
  return userId ? `nm_client_ales_${userId}` : null;
}

function clientAlesDinBrowser(userId) {
  try {
    localStorage.removeItem('nm_client_ales');
    const cheie = cheieClientAles(userId);
    if (!cheie) return null;
    const v = localStorage.getItem(cheie);
    const n = v ? parseInt(v, 10) : NaN;
    return Number.isFinite(n) ? n : null;
  } catch (_e) { return null; }
}

function scrieClientAles(userId, id) {
  try {
    const cheie = cheieClientAles(userId);
    if (!cheie) return;
    if (id) localStorage.setItem(cheie, String(id));
    else localStorage.removeItem(cheie);
  } catch (_e) { /* fereastra privata: mergem mai departe fara sa tinem minte */ }
}

// Poza unui client in liste (16 septembrie 2026, Etapa 4, pasul 7): prima poza
// de cont pe care o are, adica a Paginii de Facebook cand exista — `conturi_client`
// intoarce Facebook primul. Fara poza, ramane initiala, ca pana acum.
//
// Cate o cerere pe client: cu o mana de clienti e in regula. Peste vreo douazeci
// ar trebui inlocuita cu o singura cerere pentru toti.
function AvatarClient({ clientId, nume }) {
  const [poza, setPoza] = useState(null);

  useEffect(() => {
    let activ = true;
    (async () => {
      const { data } = await supabase.rpc('conturi_client', { p_client_id: clientId });
      if (!activ) return;
      const cuPoza = (data || []).find(r => r.poza_url);
      setPoza(cuPoza ? cuPoza.poza_url : null);
    })();
    return () => { activ = false; };
  }, [clientId]);

  if (poza) return <img className="client-avatar client-avatar-poza" src={poza} alt="" />;
  return <div className="client-avatar">{(nume || '?').charAt(0)}</div>;
}

// Blocul din josul meniului: cine e clientul ales, cate postari are de aprobat
// si lista din care se schimba. Aceeasi componenta la super_admin si la manager.
// Numele clientului ales, sus pe paginile din meniu (ACASA_PLAN.md). Pagina clientului
// il are deja in antet; Acasa si Clienti sunt pe toti clientii.
// Cine esti, sus pe fiecare ecran (cerut de ea, 19 septembrie 2026). Pana acum numele si rolul
// stateau doar in josul barii din stanga, iar cand bara e derulata nu se vad deloc — cu trei
// conturi deschise in trei ferestre nu stiai in care esti. La DREAPTA, nu la stanga, fiindca
// stanga sus e titlul paginii. Pe telefon sta in banda de sus, langa logo (`BaraSusMobil`).
function SemnCont({ nume, rol }) {
  if (!nume) return null;
  return (
    <div className="semn-cont">
      <div className="user-avatar">{String(nume).trim().charAt(0).toUpperCase()}</div>
      <div>
        <div className="user-nume">{nume}</div>
        <div className="user-rol">{rol}</div>
      </div>
    </div>
  );
}

function AntetClientAles({ client, pagina }) {
  if (!client || ['acasa', 'clienti', 'profil_client'].includes(pagina)) return null;
  return (
    <div style={{ padding: '18px 40px 0', fontFamily: "'DM Serif Display', serif", fontSize: 22, color: '#0F3D22' }}>
      {client.nume}
      {(client.functie || client.localitate) && (
        <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: '#4B5563', marginLeft: 10 }}>
          {[client.functie, client.localitate].filter(Boolean).join(' · ')}
        </span>
      )}
    </div>
  );
}

// `fix`: contul de client are un singur client, deci blocul nu se deschide in lista.
// 16 sept 2026 (ACASA_PLAN.md): agentia nu mai schimba clientul din bloc; „Clienti" si
// „Acasa" fac asta. `onDeschide` deschide pagina clientului ales; fara client ales,
// blocul arata doar sectiunile.
function BlocClient({ clienti, clientAles, setClientAles, postari, sectiuni = [], fix = false, onDeschide = null }) {
  const [deschis, setDeschis] = useState(false);
  const [cautare, setCautare] = useState('');

  function deAprobat(clientId) {
    return postari.filter(p =>
      p.clientId === clientId && ['aprobare_finala', 'intern'].includes(p.status)
    ).length;
  }

  const gasiti = clienti.filter(c =>
    !cautare.trim() || (c.nume || '').toLowerCase().includes(cautare.trim().toLowerCase())
  );

  function alege(id) {
    setClientAles(id);
    setDeschis(false);
    setCautare('');
  }

  const initiale = clientAles ? (clientAles.nume || '?').charAt(0).toUpperCase() : '★';

  return (
    <div className="bloc-client">
      {deschis && (
        <div className="bloc-client-panou">
          <input
            className="bloc-client-cauta"
            placeholder={t('sidebar', 'cautaClient')}
            value={cautare}
            onChange={e => setCautare(e.target.value)}
            autoFocus
          />
          <button
            className={`bloc-client-optiune ${!clientAles ? 'activ' : ''}`}
            onClick={() => alege(null)}
          >
            <span>★</span><span>{t('sidebar', 'totiClientii')}</span>
          </button>
          {gasiti.length === 0 ? (
            <div className="bloc-client-gol">{t('sidebar', 'niciunClientGasit')}</div>
          ) : gasiti.map(c => {
            const n = deAprobat(c.id);
            return (
              <button
                key={c.id}
                className={`bloc-client-optiune ${clientAles && clientAles.id === c.id ? 'activ' : ''}`}
                onClick={() => alege(c.id)}
              >
                <span>{(c.nume || '?').charAt(0).toUpperCase()}</span>
                <span>{c.nume}</span>
                {n > 0 && <span className="bloc-client-badge">{n}</span>}
              </button>
            );
          })}
        </div>
      )}
      {(clientAles || !fix) && (
      <button
        className="bloc-client-buton"
        onClick={() => { if (onDeschide) onDeschide(); else if (!fix) setDeschis(d => !d); }}
        title={fix ? undefined : t('sidebar', 'schimbaClient')}
        style={fix && !onDeschide ? { cursor: 'default' } : undefined}
      >
        <div className="bloc-client-avatar">
          {clientAles && clientAles.poza_url
            ? <img src={clientAles.poza_url} alt="" />
            : initiale}
        </div>
        <div className="bloc-client-text">
          <div className="bloc-client-nume">
            {clientAles ? clientAles.nume : t('sidebar', 'totiClientii')}
          </div>
          <div className="bloc-client-sub">
            {clientAles
              // Super adminul vede aici costul AI al lunii (etapa 7, bucata 1); ceilalti, ce au de aprobat.
              ? <CostAILunaScurt clientId={clientAles.id} altfel={t('sidebar', 'deAprobatN', { n: deAprobat(clientAles.id) })} />
              : t('sidebar', 'totiClientiiSub')}
          </div>
        </div>
        {!fix && <span className="bloc-client-sageata">{deschis ? '▾' : '▸'}</span>}
      </button>
      )}

      {/* Sub numele clientului: ce ține de el (pasul 5). Intrările care cer un
          client anume nu apar pe „Toți clienții" — ar duce la un ecran gol. */}
      <div className="bloc-client-sectiuni">
        {sectiuni
          .filter(s => !s.cereClient || clientAles)
          .map(s => (
            <button key={s.id} className="bloc-client-sectiune" onClick={s.onClick}>
              <span className="bloc-client-sectiune-icon"><IconMeniu id={s.id} marime={16} /></span>
              <span>{s.label}</span>
            </button>
          ))}
      </div>
    </div>
  );
}

function Sidebar({ clopotel = null, paginaActiva, setPaginaActiva, postari, mesaje, onLogout, clienti, clientAles, setClientAles, toatePostarile, sectiuniClient = [], onDeschideClient = null, rol = null, nume = null }) {
  const nrAprobare = postari.filter(p => ['aprobare_finala', 'intern'].includes(p.status)).length;
  // `nrDrafturi` a disparut odata cu intrarea „Ciorne" din meniu (16 sept 2026).
  // Meniul nou (16 septembrie 2026, pasul 5): „Postare nouă" primul, „Aprobare"
  // devine „De aprobat", iar „Bibliotecă media" și „Echipă" coboară în blocul
  // clientului. „Ciorne" RĂMÂNE până la pasul 6: tabul care îi ia locul se face
  // acolo, iar până atunci ciornele n-ar mai fi de ajuns nicăieri.
  const meniu = [
    // Faza 7 (16 septembrie 2026): „Postare nouă" e compozitorul nou. Cel vechi nu mai
    // e in meniu (decizia Luminitei: nu se sterge); se deschide doar pentru editarea
    // postarilor vechi, fara grup (vezi `deschidePostarea`).
    // Acasa = toti clientii (ACASA_PLAN.md, 16 sept 2026).
    { id: 'acasa',      label: t('sidebar', 'acasa'),           icon: '🏠' },
    { id: 'compositor2', label: t('sidebar', 'postareNoua'),     icon: '✏️' },
    { id: 'clienti',    label: t('sidebar', 'clienti'),         icon: '👥' },
    { id: 'calendar',   label: t('sidebar', 'calendar'),         icon: '📅' },
    { id: 'inbox',      label: t('sidebar', 'inbox'),            icon: '💬' },
    { id: 'aprobare',   label: t('sidebar', 'deAprobat'),        icon: '✅', badge: nrAprobare },
    // Aprobate de client, de programat sau publicat (16 septembrie 2026).
    { id: 'aprobate',   label: t('sidebar', 'aprobate'),         icon: '👍', badge: postari.filter(p => p.status === 'aprobat').length },
    // „Ciorne" a iesit din meniu pe 16 septembrie 2026 (Etapa 4, pasul 6, repriza 3):
    // ciornele au acum tab propriu in pagina clientului. Ecranul vechi ramane in cod,
    // dar nu se mai ajunge la el din meniu.
    // Analize doar pe un client ales: nu se afiseaza analitice pentru toti (decizia Luminitei).
    clientAles && { id: 'analize',    label: t('sidebar', 'analize'),          icon: '📊' },
  ].filter(Boolean);
  return (
    <div className="sidebar">
      <div className="logo" style={clopotel ? { display: 'flex', alignItems: 'center' } : undefined}>
        <div className="logo-nm">NM</div><div className="logo-social">Social</div>
        {clopotel && <div style={{ marginLeft: 'auto' }}>{clopotel}</div>}
      </div>
      <nav className="nav">
        {meniu.map(item => (
          <button key={item.id} className={`nav-item ${paginaActiva === item.id ? 'activ' : ''}`} onClick={() => setPaginaActiva(item.id)}>
            <span className="nav-icon"><IconMeniu id={item.id} /></span><span>{item.label}</span>
            {item.badge > 0 && <span className="nav-badge">{item.badge}</span>}
          </button>
        ))}
      </nav>
      <BlocClient fix clienti={clienti} clientAles={clientAles} setClientAles={setClientAles} postari={toatePostarile} sectiuni={sectiuniClient} onDeschide={onDeschideClient} />
      <div className="user-info">
        {/* Numele omului logat, nu unul scris de mana. Pana pe 19 septembrie 2026 aici scria
            „Luminița K." la orice super_admin si „Manager" la orice manager — deci primul manager
            adevarat si-ar fi vazut numele „Manager" pe ecranul lui. */}
        <div className="user-avatar">{String(nume || 'L').trim().charAt(0).toUpperCase()}</div>
        <div style={{ flex: 1 }}><div className="user-nume">{nume || 'Luminița K.'}</div><div className="user-rol">{t('sidebar', 'superAdmin')}</div></div>
        <button onClick={onLogout} title={t('sidebar', 'iesiDinCont')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#4B5563', display: 'flex', padding: 4 }}><IconLinie nume="iesire" marime={18} /></button>
      </div>
      <div style={{ padding: '0 16px 12px', fontSize: 11, color: '#9CA3AF', textAlign: 'center', lineHeight: 1.5 }}>
        <a href={legal('confidentialitate')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{t('sidebar', 'confidentialitate')}</a>
        {' · '}
        <a href={legal('termeni')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{t('sidebar', 'termeniConditii')}</a>
        {' · '}
        <a href={legal('stergere')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{t('sidebar', 'stergereaDatelor')}</a>
        {' · '}
        <a href={legal('cookies')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{t('sidebar', 'cookies')}</a>
      </div>
    </div>
  );
}
// Banda de sus pe telefon (19 septembrie 2026). Pe desktop logo-ul sta in
// sidebar, dar sidebar-ul e display:none sub 768px, deci pe telefon banda are
// nevoie de element propriu, randat in afara lui.
function BaraSusMobil({ onClick, nume = null, rol = null, clopotel = null }) {
  return (
    <div className="mobile-topbar" style={onClick ? { cursor: 'pointer' } : undefined} onClick={onClick}>
      <div className="logo-nm">NM</div><div className="logo-social">Social</div>
      {/* Cine esti, si pe telefon: aici era loc gol langa logo. */}
      {nume && (
        <div className="topbar-cont">
          <span className="topbar-nume">{nume}</span>
          {rol && <span className="topbar-rol">{rol}</span>}
        </div>
      )}
      {clopotel && <div style={{ marginLeft: nume ? 8 : 'auto' }}>{clopotel}</div>}
    </div>
  );
}
// Bara de jos pentru super_admin si manager (refacuta pe 11 octombrie 2026, vezi BaraJosMobil.js).
// In bara: Acasa, Clienti, Postare (buton central), Aprobate; restul urca in foaia „Mai mult",
// cu „De aprobat" primul. Cele patru din bara sunt alegerea Luminitei.
function MobileNavbar({ paginaActiva, setPaginaActiva, postari, sectiuni = [], clientAles = null, onLogout = null }) {
  const nrAprobare = postari.filter(p => ['aprobare_finala', 'intern'].includes(p.status)).length;
  const nrAprobate = postari.filter(p => p.status === 'aprobat').length;

  const intrari = [
    { id: 'acasa',       label: t('sidebar', 'acasa'),    icon: 'acasa',    activ: paginaActiva === 'acasa',   onClick: () => setPaginaActiva('acasa') },
    { id: 'clienti',     label: t('sidebar', 'clienti'),  icon: 'clienti',  activ: ['clienti', 'profil_client'].includes(paginaActiva), onClick: () => setPaginaActiva('clienti') },
    { id: 'compositor2', label: t('sidebar', 'postare'),  icon: 'plus',     central: true, activ: paginaActiva === 'compositor2', onClick: () => setPaginaActiva('compositor2') },
    { id: 'aprobate',    label: t('sidebar', 'aprobate'), icon: 'aprobari', badge: nrAprobate, activ: paginaActiva === 'aprobate', onClick: () => setPaginaActiva('aprobate') },
  ];
  const restul = [
    { id: 'aprobare', label: t('sidebar', 'deAprobat'), icon: 'deAprobat', badge: nrAprobare, activ: paginaActiva === 'aprobare', onClick: () => setPaginaActiva('aprobare') },
    { id: 'calendar', label: t('sidebar', 'calendar'), icon: 'calendar', activ: paginaActiva === 'calendar', onClick: () => setPaginaActiva('calendar') },
    { id: 'inbox',    label: t('sidebar', 'inbox'),    icon: 'inbox',    activ: paginaActiva === 'inbox',    onClick: () => setPaginaActiva('inbox') },
    // Ca in sidebar: Analize doar pe un client ales.
    clientAles && { id: 'analize', label: t('sidebar', 'analize'), icon: 'analize', activ: paginaActiva === 'analize', onClick: () => setPaginaActiva('analize') },
    // Blocul clientului din sidebar (Conturi, Profil de voce, Echipa, Biblioteca, Asistent AI).
    ...sectiuni.filter(sc => !sc.cereClient || clientAles).map(sc => ({ id: sc.id, label: sc.label, icon: sc.id, activ: paginaActiva === sc.id, onClick: sc.onClick })),
  ].filter(Boolean);

  return <BaraJosMobil intrari={intrari} restul={restul} onLogout={onLogout} />;
}
// ============================================================
// ÎNLOCUIEȘTE funcția Biblioteca() din App.js cu aceasta
// ============================================================

function Biblioteca({ clienti, biblioteca, setBiblioteca }) {
  const [clientActiv, setClientActiv] = useState(clienti[0]?.id || null);
  const [folderActiv, setFolderActiv] = useState(null);
  const [showUpload, setShowUpload] = useState(false);
  const [cautare, setCautare] = useState('');
  const [folderNou, setFolderNou] = useState({ numeEveniment: '', data: '', taguri: '' });
  const [folderSelectatPentruUpload, setFolderSelectatPentruUpload] = useState('nou');
  const [fisierePendingUpload, setFisierePendingUpload] = useState([]);
  const [fisiereBrute, setFisiereBrute] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [loadingFoldere, setLoadingFoldere] = useState(false);

  // ── Încarcă folderele din Supabase la schimbarea clientului ──
  useEffect(() => {
    if (!clientActiv) return;
    incarcaFoldere(clientActiv);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientActiv]);

  async function incarcaFoldere(clientId) {
    setLoadingFoldere(true);
    try {
      const { data: foldere, error: errF } = await supabase
        .from('folders_media')
        .select('*')
        .eq('client_id', clientId)
        .order('data', { ascending: false });
      if (errF) throw errF;

      const foldereComplete = await Promise.all((foldere || []).map(async (folder) => {
        const { data: fisiere, error: errFis } = await supabase
          .from('fisiere_media')
          .select('*')
          .eq('folder_id', folder.id)
          .order('created_at', { ascending: true });
        if (errFis) throw errFis;
        return {
          id: folder.id,
          clientId: folder.client_id,
          numeEveniment: folder.nume_eveniment,
          data: folder.data,
          taguri: folder.taguri || [],
          fisiere: (fisiere || []).map(f => ({
            id: f.id,
            nume: f.nume,
            tip: f.tip,
            url: f.url,
            marime: f.marime,
            storagePath: f.storage_path,
          })),
        };
      }));

      setBiblioteca(prev => ({ ...prev, [clientId]: foldereComplete }));
    } catch (err) {
      console.error('Eroare încărcare foldere:', err);
    } finally {
      setLoadingFoldere(false);
    }
  }

  const foldereClient = biblioteca[clientActiv] || [];
  const foldereFiltrate = foldereClient.filter(f => {
    if (!cautare) return true;
    const q = cautare.toLowerCase();
    return f.numeEveniment.toLowerCase().includes(q) || f.taguri.some(t => t.toLowerCase().includes(q));
  });
  const folderCurent = foldereClient.find(f => f.id === folderActiv);

  function handleFisiereUpload(e) {
    const fisiere = Array.from(e.target.files);
    setFisiereBrute(fisiere);
    setFisierePendingUpload(fisiere.map(f => ({
      nume: f.name,
      tip: f.type.startsWith('video/') ? 'video' : 'imagine',
      marime: (f.size / (1024 * 1024)).toFixed(1) + ' MB',
      url: f.type.startsWith('image/') ? URL.createObjectURL(f) : null,
    })));
    if (folderActiv) setFolderSelectatPentruUpload(String(folderActiv));
    setShowUpload(true);
  }

  async function confirmaUpload() {
    if (fisiereBrute.length === 0) return;
    setUploading(true);
    try {
      let folderId = folderSelectatPentruUpload;

      // Creăm folder nou dacă e cazul
      if (folderSelectatPentruUpload === 'nou') {
        if (!folderNou.numeEveniment || !folderNou.data) return;
        const { data: folderCreat, error: errFolder } = await supabase
          .from('folders_media')
          .insert({
            client_id: clientActiv,
            nume_eveniment: folderNou.numeEveniment,
            data: folderNou.data,
            taguri: folderNou.taguri.split(',').map(t => t.trim()).filter(Boolean),
          })
          .select()
          .single();
        if (errFolder) throw errFolder;
        folderId = folderCreat.id;
      }

      // Uploadăm fișierele în Storage
      await Promise.all(fisiereBrute.map(async (fisier) => {
        const extensie = fisier.name.split('.').pop();
        const numeFisier = `${Date.now()}_${Math.random().toString(36).slice(2)}.${extensie}`;
        const storagePath = `${clientActiv}/${folderId}/${numeFisier}`;

        const { error: errUpload } = await supabase.storage
          .from('media-clienti')
          .upload(storagePath, fisier);
        if (errUpload) throw errUpload;

        const { data: { publicUrl } } = supabase.storage
          .from('media-clienti')
          .getPublicUrl(storagePath);

        // Salvăm metadatele în DB
        const { data: fisierSalvat, error: errFis } = await supabase
          .from('fisiere_media')
          .insert({
            folder_id: folderId,
            client_id: clientActiv,
            nume: fisier.name,
            tip: fisier.type.startsWith('video/') ? 'video' : 'imagine',
            url: publicUrl,
            marime: (fisier.size / (1024 * 1024)).toFixed(1) + ' MB',
            storage_path: storagePath,
          })
          .select()
          .single();
        if (errFis) throw errFis;

        return {
          id: fisierSalvat.id,
          nume: fisier.name,
          tip: fisier.type.startsWith('video/') ? 'video' : 'imagine',
          url: publicUrl,
          marime: (fisier.size / (1024 * 1024)).toFixed(1) + ' MB',
          storagePath,
        };
      }));

      // Reîncărcăm folderele din DB
      await incarcaFoldere(clientActiv);
      if (folderSelectatPentruUpload === 'nou') {
        // Găsim folderul nou creat și îl deschidem
        const foldereNoi = biblioteca[clientActiv] || [];
        const ultimul = foldereNoi[0];
        if (ultimul) setFolderActiv(ultimul.id);
      }

      setShowUpload(false);
      setFisierePendingUpload([]);
      setFisiereBrute([]);
      setFolderNou({ numeEveniment: '', data: '', taguri: '' });
      setFolderSelectatPentruUpload('nou');
    } catch (err) {
      alert(t('biblioteca', 'eroareUpload') + err.message);
    } finally {
      setUploading(false);
    }
  }

  const totalFisiere = foldereClient.reduce((sum, f) => sum + f.fisiere.length, 0);

  return (
    <div className="pagina">
      <div className="pagina-header">
        <div>
          <h1 className="pagina-titlu">{t('biblioteca', 'bibliotecaMedia')}</h1>
          <p className="pagina-subtitlu">{totalFisiere} {t('biblioteca', 'fisiere')} · {foldereClient.length} {t('biblioteca', 'evenimente')}</p>
        </div>
        <label className="btn-principal" style={{ cursor: 'pointer' }}>
          <input type="file" accept="image/*,video/*" multiple onChange={handleFisiereUpload} style={{ display: 'none' }} />
          {t('biblioteca', 'incarcaFisiere')}
        </label>
      </div>

      <div className="biblioteca-layout">
        <div className="biblioteca-clienti">
          <div className="biblioteca-clienti-titlu">{t('biblioteca', 'clienti')}</div>
          {clienti.filter(c => c.status === 'activ').map(c => (
            <button key={c.id} className={`biblioteca-client-btn ${clientActiv === c.id ? 'activ' : ''}`}
              onClick={() => { setClientActiv(c.id); setFolderActiv(null); }}>
              <div className="biblioteca-client-avatar">{c.nume.charAt(0)}</div>
              <div>
                <div className="biblioteca-client-nume">{c.nume}</div>
                <div className="biblioteca-client-nr">{(biblioteca[c.id] || []).reduce((s, f) => s + f.fisiere.length, 0)} {t('biblioteca', 'fisiere')}</div>
              </div>
            </button>
          ))}
        </div>

        <div className="biblioteca-continut">
          {loadingFoldere ? (
            <div className="pagina-gol"><div className="pagina-gol-icon">⏳</div><p>{t('biblioteca', 'seIncarca')}</p></div>
          ) : !folderActiv ? (
            <>
              <div className="biblioteca-cautare-bar">
                <input className="biblioteca-cautare" placeholder={t('biblioteca', 'cautaEveniment')} value={cautare} onChange={e => setCautare(e.target.value)} />
              </div>
              {foldereFiltrate.length === 0 ? (
                <div className="pagina-gol"><div className="pagina-gol-icon">🖼️</div><p>{t('biblioteca', 'niciunEveniment')}</p></div>
              ) : (
                <div className="biblioteca-foldere">
                  {foldereFiltrate.map(folder => (
                    <div key={folder.id} className="biblioteca-folder-card" onClick={() => setFolderActiv(folder.id)}>
                      <div className="biblioteca-folder-preview">
                        {folder.fisiere.slice(0, 4).map((f, i) => (
                          f.url
                            ? <img key={i} src={f.url} alt={f.nume} className="biblioteca-folder-thumb" />
                            : <div key={i} className="biblioteca-folder-thumb-placeholder">{f.tip === 'video' ? '🎬' : '🖼️'}</div>
                        ))}
                      </div>
                      <div className="biblioteca-folder-info">
                        <div className="biblioteca-folder-nume">{folder.numeEveniment}</div>
                        <div className="biblioteca-folder-data">📅 {folder.data} · {folder.fisiere.length} {t('biblioteca', 'fisiere')}</div>
                        <div className="biblioteca-folder-taguri">{folder.taguri.map(t => <span key={t} className="tag-chip">#{t}</span>)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            <>
              <div className="biblioteca-folder-header">
                <button className="btn-inapoi" onClick={() => setFolderActiv(null)}>{t('biblioteca', 'inapoi')}</button>
                <div>
                  <div className="biblioteca-folder-titlu">{folderCurent?.numeEveniment}</div>
                  <div className="biblioteca-folder-meta">📅 {folderCurent?.data} · {folderCurent?.fisiere.length} {t('biblioteca', 'fisiere')}</div>
                  <div className="biblioteca-folder-taguri" style={{ marginTop: 6 }}>
                    {folderCurent?.taguri.map(t => <span key={t} className="tag-chip">#{t}</span>)}
                  </div>
                </div>
                <label className="btn-principal" style={{ cursor: 'pointer', marginLeft: 'auto' }}>
                  <input type="file" accept="image/*,video/*" multiple onChange={handleFisiereUpload} style={{ display: 'none' }} />
                  {t('biblioteca', 'adaugaFisiere')}
                </label>
              </div>
              <div className="biblioteca-fisiere">
                {folderCurent?.fisiere.map(f => (
                  <div key={f.id} className="biblioteca-fisier-card">
                    {f.tip === 'imagine' && f.url
                      ? <img src={f.url} alt={f.nume} className="biblioteca-fisier-img" />
                      : <div className="biblioteca-fisier-placeholder">{f.tip === 'video' ? '🎬' : '🖼️'}</div>}
                    <div className="biblioteca-fisier-info">
                      <div className="biblioteca-fisier-nume">{f.nume}</div>
                      <div className="biblioteca-fisier-marime">{f.marime}</div>
                    </div>
                    <button className="biblioteca-fisier-foloseste">{t('biblioteca', 'foloseste')}</button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      {showUpload && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <div className="modal-titlu">{t('biblioteca', 'incarcaNFisiere')} {fisierePendingUpload.length} {t('biblioteca', 'fisiere')}</div>
              <button className="btn-inchide" onClick={() => { setShowUpload(false); setFisierePendingUpload([]); setFisiereBrute([]); }}>✕</button>
            </div>
            <div className="modal-fisiere-preview">
              {fisierePendingUpload.slice(0, 6).map((f, i) => (
                <div key={i} className="modal-fisier-chip">
                  {f.url ? <img src={f.url} alt={f.nume} className="modal-fisier-thumb" /> : <span>{f.tip === 'video' ? '🎬' : '🖼️'}</span>}
                  <span className="modal-fisier-nume">{f.nume}</span>
                </div>
              ))}
              {fisierePendingUpload.length > 6 && <div className="modal-fisier-chip">+{fisierePendingUpload.length - 6} {t('biblioteca', 'maiMulte')}</div>}
            </div>
            <div className="modal-sectiune">
              <label className="label">{t('biblioteca', 'undeIncarci')}</label>
              <div className="modal-folder-optiuni">
                <button className={`modal-folder-opt ${folderSelectatPentruUpload === 'nou' ? 'selectat' : ''}`} onClick={() => setFolderSelectatPentruUpload('nou')}>{t('biblioteca', 'folderNou')}</button>
                {foldereClient.map(f => (
                  <button key={f.id} className={`modal-folder-opt ${folderSelectatPentruUpload === String(f.id) ? 'selectat' : ''}`}
                    onClick={() => setFolderSelectatPentruUpload(String(f.id))}>📂 {f.numeEveniment}</button>
                ))}
              </div>
            </div>
            {folderSelectatPentruUpload === 'nou' && (
              <div className="modal-sectiune">
                <div className="modal-camp">
                  <label className="label">{t('biblioteca', 'dataEvenimentului')}</label>
                  <input type="date" className="input-data" value={folderNou.data} onChange={e => setFolderNou(p => ({ ...p, data: e.target.value }))} />
                </div>
                <div className="modal-camp">
                  <label className="label">{t('biblioteca', 'numeEveniment')}</label>
                  <input type="text" className="select-input" placeholder={t('biblioteca', 'numeEvenimentPlaceholder')} value={folderNou.numeEveniment} onChange={e => setFolderNou(p => ({ ...p, numeEveniment: e.target.value }))} />
                </div>
                <div className="modal-camp">
                  <label className="label">{t('biblioteca', 'taguri')}</label>
                  <input type="text" className="select-input" placeholder={t('biblioteca', 'taguriPlaceholder')} value={folderNou.taguri} onChange={e => setFolderNou(p => ({ ...p, taguri: e.target.value }))} />
                </div>
              </div>
            )}
            <div className="modal-actiuni">
              <button className="btn-principal" onClick={confirmaUpload}
                disabled={uploading || (folderSelectatPentruUpload === 'nou' && (!folderNou.numeEveniment || !folderNou.data))}>
                {uploading ? t('biblioteca', 'seIncarcaUpload') : t('biblioteca', 'confirmaUpload')}
              </button>
              <button className="btn-secundar" onClick={() => { setShowUpload(false); setFisierePendingUpload([]); setFisiereBrute([]); }}>{t('biblioteca', 'anuleaza')}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Cifrele de pe cartonul clientului din lista: postarile PUBLICATE luna aceasta si data
// ultimei publicari. Pana pe 16 sept 2026 cartonul citea `client.postariLuna` si
// `client.ultimaPostare`, campuri care nu exista in baza, deci arata mereu 0 si „-".
function cifrePostariClient(postari, clientId) {
  const acum = new Date();
  const publicate = postari.filter(p => p.clientId === clientId && p.status === 'publicat' && p.publicatLa);
  const luna = publicate.filter(p => {
    const d = new Date(p.publicatLa);
    return d.getMonth() === acum.getMonth() && d.getFullYear() === acum.getFullYear();
  }).length;
  const ultimaMs = publicate.reduce((m, p) => Math.max(m, new Date(p.publicatLa).getTime()), 0);
  const ultima = ultimaMs
    ? new Date(ultimaMs).toLocaleDateString(getLocale(), { timeZone: 'Europe/Bucharest', day: '2-digit', month: '2-digit', year: 'numeric' })
    : '-';
  return { luna, ultima };
}

function ListaClienti({ clienti, setClienti, profiluri, setProfiluri, deschideClient, postari = [] }) {
  const [showModal, setShowModal] = useState(false);
  const seAdaugaClient = React.useRef(false);
 const [clientNou, setClientNou] = useState({ nume: '', functie: '', localitate: '', email: '' });
  const [permisiuniClientNou, setPermisiuniClientNou] = useState({
    poate_crea_postari: false,
    poate_publica: false,
    poate_folosi_ai_compositor: false,
    vede_calendar: false,
    vede_biblioteca_media: false,
    vede_analytics_complet: true,
    vede_inbox: false,
    raspunde_inbox: false
  });

  const togglePermisiune = (cheie) => {
    setPermisiuniClientNou(prev => {
      // Aceleasi dependente ca in fereastra de drepturi (src/DrepturiClient.js).
      return comutaDrept(prev, cheie);
    });
  };

async function handleAdaugaClient() {
  if (!clientNou.nume || !clientNou.functie) return;
  // Un al doilea clic, cat primul inca lucreaza, facea un al doilea client (vazut pe 9 octombrie 2026).
  if (seAdaugaClient.current) return;
  seAdaugaClient.current = true;
  try { await adaugaClientul(); } finally { seAdaugaClient.current = false; }
}

async function adaugaClientul() {
  const adresa = clientNou.email.trim().toLowerCase();

  // Intai clientul, apoi contul lui, facut pe server (`invita-cont`, 9 octombrie 2026). Daca
  // invitatia pica, clientul ramane „Fara cont" si se invita mai tarziu din fisa lui.
  // Fara email (15 octombrie 2026, cerut de Luminita pentru Temele zilei): clientul e doar o fisa,
  // fara cont si fara invitatie; contul i se face mai tarziu, din fisa, cu adresa lui reala.
  const { data, error } = await supabase
    .from('clienti')
    .insert({
      nume: clientNou.nume,
      functie: clientNou.functie,
      localitate: clientNou.localitate,
      email: adresa || null,
      retele: [],
      status: 'activ',
      permisiuni_client: permisiuniClientNou,
    })
    .select()
    .single();
  if (error) { alert(t('clienti', 'eroarePrefix') + error.message); return; }

  const invitatie = adresa
    ? await invitaCont({ email: adresa, nume: clientNou.nume, rol: 'client', clientId: data.id })
    : { ok: false, faraEmail: true };

  setClienti(prev => [{ ...data, are_cont: invitatie.ok }, ...prev]);
  setClientNou({ nume: '', functie: '', localitate: '', email: '' });
  setPermisiuniClientNou({
    poate_crea_postari: false,
    poate_publica: false,
    poate_folosi_ai_compositor: false,
    vede_calendar: false,
    vede_biblioteca_media: false,
    vede_analytics_complet: true,
    vede_inbox: false,
    raspunde_inbox: false
  });
  setShowModal(false);
  alert(invitatie.ok
    ? t('clienti', 'clientAdaugat', { nume: data.nume, email: adresa })
    : invitatie.faraEmail
      ? t('clienti', 'clientFaraEmail', { nume: data.nume })
      : t('clienti', 'clientFaraInvitatie', { nume: data.nume }) + invitatie.mesaj);
}

  return (
    <div className="pagina">
      <div className="pagina-header">
        <div><h1 className="pagina-titlu">{t('clienti', 'clienti')}</h1><p className="pagina-subtitlu">{t('clienti', 'clientiActivi', { n: clienti.filter(c => c.status === 'activ').length })}</p></div>
        <button className="btn-principal" onClick={() => setShowModal(true)}>{t('clienti', 'clientNou')}</button>
      </div>
      <div className="lista-clienti">
        {clienti.map(client => (
          <div key={client.id} className="card-client" onClick={() => deschideClient(client)}>
            <div className="card-client-header">
              <AvatarClient clientId={client.id} nume={client.nume} />
              <div className="client-info"><div className="client-nume">{client.nume}</div><div className="client-functie">{client.functie} · {client.localitate}</div></div>
              <div className="card-client-dreapta">
                {/* „N de aprobat" langa fiecare client (Etapa 4, pasul 7): ca sa se
                    vada de pe lista cine te asteapta, fara sa intri la fiecare. */}
                {postari.filter(p => p.clientId === client.id && ['aprobare_finala', 'intern'].includes(p.status)).length > 0 && (
                  <div className="card-client-aprobat">
                    {t('sidebar', 'deAprobatN', { n: postari.filter(p => p.clientId === client.id && ['aprobare_finala', 'intern'].includes(p.status)).length })}
                  </div>
                )}
                <div className={`status-badge ${client.status === 'inactiv' ? 'inactiv' : client.inrolat ? 'activ' : client.are_cont ? 'invitat' : 'fara-cont'}`}>{client.status === 'inactiv' ? t('clienti', 'inactiv') : client.inrolat ? t('clienti', 'activ') : client.are_cont ? t('clienti', 'invitat') : t('clienti', 'faraCont')}</div>
                {profiluri[client.id] && <div className="profil-badge">{t('clienti', 'profilIncarcat')}</div>}
              </div>
            </div>
            <div className="card-client-footer">
              <div className="retele">{(client.retele || []).map(r => { const retea = RETELE.find(x => x.id === r); return <span key={r} className="retea-icon-wrap" style={{ background: retea?.bg }}><IconRetea id={r} size={14} /></span>; })}</div>
              <div className="postari-info"><span className="postari-numar">{cifrePostariClient(postari, client.id).luna}</span> {t('clienti', 'postariLunaAceasta')}</div>
              <div className="ultima-postare">{t('clienti', 'ultima')}{cifrePostariClient(postari, client.id).ultima}</div>
            </div>
          </div>
        ))}
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <div className="modal-titlu">{t('clienti', 'clientNouTitlu')}</div>
              <button className="btn-inchide" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div className="modal-sectiune">
              <div className="modal-camp">
                <label className="label">{t('clienti', 'numeComplet')}</label>
                <input type="text" className="select-input" placeholder={t('clienti', 'numePlaceholder')} value={clientNou.nume} onChange={e => setClientNou(p => ({ ...p, nume: e.target.value }))} />
              </div>
              <div className="modal-camp">
                <label className="label">{t('clienti', 'functie')}</label>
                <input type="text" className="select-input" placeholder={t('clienti', 'functiePlaceholder')} value={clientNou.functie} onChange={e => setClientNou(p => ({ ...p, functie: e.target.value }))} />
              </div>
              <div className="modal-camp">
                <label className="label">{t('clienti', 'localitate')}</label>
                <input type="text" className="select-input" placeholder={t('clienti', 'localitatePlaceholder')} value={clientNou.localitate} onChange={e => setClientNou(p => ({ ...p, localitate: e.target.value }))} />
              </div>
              <div className="modal-camp">
                <label className="label">{t('clienti', 'emailOptional')}</label>
                <input type="email" className="select-input" placeholder={t('clienti', 'emailPlaceholder')} value={clientNou.email} onChange={e => setClientNou(p => ({ ...p, email: e.target.value }))} />
                <p style={{ fontSize: 12.5, color: '#4B5563', margin: '6px 0 0' }}>{t('clienti', 'emailOptionalNota')}</p>
              </div>
              <div style={{ height: 1, background: '#D1E8DA', margin: '20px 0 18px 0' }} />
              <div style={{
                fontSize: 12, fontWeight: 600, letterSpacing: '0.06em',
                textTransform: 'uppercase', color: '#0F3D22', marginBottom: 16,
              }}>
                {t('clienti', 'cePoateFace')}
              </div>
              {[
                // „Vede ciornele" a iesit, „Poate publica" a intrat (16 sept 2026).
                // Bifele doar ale super adminului nu se pun la crearea clientului, ci dupa, din fisa.
                ...GRUPE_DREPTURI.map(g => ({ titlu: t('clienti', g.titlu), cheie: g.chei.filter(k => !CHEI_DOAR_SUPER_ADMIN.includes(k)) })),
              ].map(categorie => (
                <div key={categorie.titlu} style={{ marginBottom: 18 }}>
                  <div style={{
                    fontSize: 11, fontWeight: 600, letterSpacing: '0.05em',
                    textTransform: 'uppercase', color: '#1A6B3C', marginBottom: 10,
                  }}>
                    {categorie.titlu}
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 8, paddingLeft: 4 }}>
                    {categorie.cheie.map(cheie => {
                      const labels = Object.fromEntries(
                        Object.entries(ETICHETE_DREPTURI).map(([k, v]) => [k, t('clienti', v)])
                      );
                      const disabled = dreptBlocat(permisiuniClientNou, cheie);
                      return (
                        <label key={cheie} style={{
                          display: 'flex', alignItems: 'center', gap: 10,
                          fontSize: 14, color: '#1F2937',
                          cursor: disabled ? 'not-allowed' : 'pointer',
                          opacity: disabled ? 0.5 : 1,
                        }}>
                          <input
                            type="checkbox"
                            checked={permisiuniClientNou[cheie]}
                            disabled={disabled}
                            onChange={() => togglePermisiune(cheie)}
                            style={{
                              width: 16, height: 16, accentColor: '#1A6B3C',
                              cursor: disabled ? 'not-allowed' : 'pointer', margin: 0,
                            }}
                          />
                          <span>{labels[cheie]}</span>
                        </label>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
            <div className="modal-actiuni">
              <button className="btn-principal" onClick={handleAdaugaClient} disabled={!clientNou.nume || !clientNou.functie}>
                {t('clienti', 'adaugaClient')}
              </button>
              <button className="btn-secundar" onClick={() => setShowModal(false)}>{t('clienti', 'anuleaza')}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function BtnConectareFacebook({ clientId }) {
  const [tokenExista, setTokenExista] = useState(false);
  const [pageName, setPageName] = useState('');
  // Instagram nu se conecteaza separat: vine cu Pagina de Facebook. Dar daca nu
  // se vede nicaieri, nu ai cum sa stii daca un client il are legat sau nu.
  // Din 15 septembrie 2026 baza de date permite un singur rand pe client si retea
  // (PAGINA_PRINCIPALA_PLAN.md), deci pagina si contul de Instagram sunt pereche.
  const [contIg, setContIg] = useState('');

  useEffect(() => {
    async function verificaToken() {
      const { data } = await supabase
        .rpc('stare_conectare_client', { p_client_id: clientId, p_platform: 'facebook' });
      if (data && data.length > 0) {
        setTokenExista(true);
        setPageName(data[0].page_name);
      }
      const { data: ig } = await supabase
        .rpc('stare_conectare_client', { p_client_id: clientId, p_platform: 'instagram' });
      if (ig && ig.length > 0) setContIg(ig[0].page_name);
    }
    verificaToken();
  }, [clientId]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('facebook') === 'connected') {
      setTokenExista(true);
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  // Adresa de autorizare s-a mutat in `conectare.js`: acelasi sir de permisiuni
  // e folosit si de randul de conturi din pagina clientului (16 sept 2026).
  function conecteazaFacebook() { pornesteFacebook(clientId); }

  async function deconecteazaFacebook() {
    if (!window.confirm(t('conectare', 'confirmDeconectare', { pageName }))) return;
    // Instagram vine cu Pagina de Facebook, deci pleaca odata cu ea. Pana acum se
    // stergea doar randul de facebook, iar contul de Instagram ramanea salvat cu
    // tokenul lui: interfata spunea "neconectat", dar aplicatia citea mai departe
    // date de la un client deconectat. Cand cineva spune "nu mai vreau", trebuie
    // sa se opreasca tot, nu jumatate.
    const [rFb, rIg] = await Promise.all([
      deconecteazaRetea(clientId, 'facebook'),
      deconecteazaRetea(clientId, 'instagram'),
    ]);
    const error = rFb.error || rIg.error;
    if (error) { alert(t('conectare', 'eroareDeconectare') + error.message); return; }
    setTokenExista(false);
    setPageName('');
    setContIg('');
  }

  if (tokenExista) {
    return (
      <>
      <button className="btn-actiune-rapida" onClick={deconecteazaFacebook} style={{ borderColor: '#C0392B', background: '#FDEDEC' }}>
        <span>🔌</span>
        <div>
          <div className="btn-actiune-titlu" style={{ color: '#C0392B' }}>{t('conectare', 'deconecteazaFacebook')}</div>
          <div className="btn-actiune-sub">{t('conectare', 'conectat')}{pageName}{contIg && <><br />{t('conectare', 'instagramLegat')}{contIg}</>}</div>
        </div>
      </button>
      {/* Avertismentul „mai multe pagini” a disparut: din 15 septembrie 2026 baza de date
          nu mai permite decat o pagina pe client. Schimbarea paginii reia conectarea, iar
          pagina noua se alege in aplicatie (AlegePagina.js). */}
      <button className="btn-actiune-rapida" onClick={conecteazaFacebook} style={{ borderColor: '#1877F2', background: '#EBF3FF' }}>
        <span>🔄</span>
        <div>
          <div className="btn-actiune-titlu" style={{ color: '#1877F2' }}>{t('conectare', 'schimbaPagina')}</div>
          <div className="btn-actiune-sub">{t('conectare', 'schimbaPaginaSub')}</div>
        </div>
      </button>
      </>
    );
  }

  return (
    <button className="btn-actiune-rapida" onClick={conecteazaFacebook} style={{ borderColor: '#1877F2', background: '#EBF3FF' }}>
      <span><IconRetea id="facebook" size={18} /></span>
      <div>
        <div className="btn-actiune-titlu" style={{ color: '#1877F2' }}>{t('conectare', 'conecteazaFacebook')}</div>
        <div className="btn-actiune-sub">{t('conectare', 'autorizeazaPagina')}</div>
      </div>
    </button>
  );
}

// Cheia de client TikTok vine din mediu, nu din cod. Cea de sandbox (sb...) nu are
// ce cauta intr-un build de productie, iar fara cheie butonul nu se afiseaza.
const CLIENT_KEY_TIKTOK = process.env.REACT_APP_TIKTOK_CLIENT_KEY;

function BtnConectareTikTok({ clientId }) {
  const [tokenExista, setTokenExista] = useState(false);
  const [pageName, setPageName] = useState('');

  useEffect(() => {
    async function verificaToken() {
      const { data } = await supabase
        .rpc('stare_conectare_client', { p_client_id: clientId, p_platform: 'tiktok' });
      if (data && data.length > 0) { setTokenExista(true); setPageName(data[0].page_name); }
    }
    verificaToken();
  }, [clientId]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('tiktok') === 'connected') {
      setTokenExista(true);
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  // Adresa de autorizare s-a mutat in `conectare.js` (16 sept 2026).
  function conecteazaTikTok() { pornesteTikTok(clientId); }

  async function deconecteazaTikTok() {
    if (!window.confirm(t('tiktok', 'confirmDeconectare', { nume: pageName }))) return;
    const { error } = await deconecteazaRetea(clientId, 'tiktok');
    if (error) { alert(t('tiktok', 'eroareDeconectare') + error.message); return; }
    setTokenExista(false);
    setPageName('');
  }

  // Fara cheie configurata in mediu, integrarea TikTok nu e utilizabila: butonul
  // nu se randeaza deloc. Asa nu ajunge in productie un buton care duce la sandbox.
  if (!CLIENT_KEY_TIKTOK) return null;

  if (tokenExista) {
    return (
      <button className="btn-actiune-rapida" onClick={deconecteazaTikTok} style={{ borderColor: '#C0392B', background: '#FDEDEC' }}>
        <span>🔌</span>
        <div>
          <div className="btn-actiune-titlu" style={{ color: '#C0392B' }}>{t('tiktok', 'deconecteaza')}</div>
          <div className="btn-actiune-sub">{t('tiktok', 'conectat')}{pageName}</div>
        </div>
      </button>
    );
  }

  return (
    <button className="btn-actiune-rapida" onClick={conecteazaTikTok} style={{ borderColor: '#000000', background: '#F0F0F0' }}>
      <span><IconRetea id="tiktok" size={18} /></span>
      <div>
        <div className="btn-actiune-titlu" style={{ color: '#000000' }}>{t('tiktok', 'conecteaza')}</div>
        <div className="btn-actiune-sub">{t('tiktok', 'autorizeaza')}</div>
      </div>
    </button>
  );
}

// Cheia de client LinkedIn vine din mediu, ca la TikTok: fara ea butonul nu se
// randeaza deloc, ca sa nu ajunga in productie un buton care nu duce nicaieri.
const CLIENT_ID_LINKEDIN = process.env.REACT_APP_LINKEDIN_CLIENT_ID;

function BtnConectareLinkedIn({ clientId }) {
  const [tokenExista, setTokenExista] = useState(false);
  const [pageName, setPageName] = useState('');
  const [zileRamase, setZileRamase] = useState(null);
  // Semnul pus de `linkedin-publish` cand reteaua a refuzat tokenul. Fara el,
  // butonul scrie „Conectat" si dupa ce autorizarea a murit, iar omul afla abia
  // cand o postare nu pleaca.
  const [tokenMort, setTokenMort] = useState(false);

  useEffect(() => {
    async function verificaToken() {
      const { data } = await supabase
        .rpc('stare_conectare_client', { p_client_id: clientId, p_platform: 'linkedin' });
      if (!data || data.length === 0) return;
      setTokenExista(true);
      setPageName(data[0].page_name);
      // Cat mai tine tokenul. Daca `expirare_token_client` nu e inca lipita in baza,
      // apelul esueaza si `exp` vine gol: butonul ramane intreg, doar fara avertisment.
      const { data: exp } = await supabase
        .rpc('expirare_token_client', { p_client_id: clientId, p_platform: 'linkedin' });
      const rand = exp && exp.length > 0 ? exp[0] : null;
      if (rand?.expires_at) setZileRamase(Math.ceil((new Date(rand.expires_at) - Date.now()) / 86400000));
      if (rand?.invalid_la) setTokenMort(true);
    }
    verificaToken();
  }, [clientId]);

  // Se avertizeaza abia in ultimele doua saptamani. Mai devreme ar fi zgomot:
  // tokenul tine 60 de zile si nu are ce sa i se intample intre timp.
  function textExpirare() {
    if (zileRamase === null) return null;
    if (zileRamase < 0) return t('linkedin', 'expirat');
    if (zileRamase === 0) return t('linkedin', 'expiraAzi');
    if (zileRamase <= 14) return t('linkedin', 'expiraIn', { zile: zileRamase });
    return null;
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('linkedin') === 'connected') {
      setTokenExista(true);
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);

  // Adresa de autorizare s-a mutat in `conectare.js` (16 sept 2026).
  function conecteazaLinkedIn() { pornesteLinkedIn(clientId); }

  async function deconecteazaLinkedIn() {
    if (!window.confirm(t('linkedin', 'confirmDeconectare', { nume: pageName }))) return;
    const { error } = await deconecteazaRetea(clientId, 'linkedin');
    if (error) { alert(t('linkedin', 'eroareDeconectare') + error.message); return; }
    setTokenExista(false);
    setPageName('');
  }

  if (!CLIENT_ID_LINKEDIN) return null;

  // Autorizarea a murit: reteaua a refuzat tokenul la ultima publicare. Nu mai
  // spunem „Conectat", ci cerem reconectarea, si spunem si de ce. Butonul duce
  // direct la autorizare, fara deconectare: reconectarea suprascrie randul.
  if (tokenExista && tokenMort) {
    return (
      <button className="btn-actiune-rapida" onClick={conecteazaLinkedIn} style={{ borderColor: '#C0392B', background: '#FDEDEC' }}>
        <span>⚠️</span>
        <div>
          <div className="btn-actiune-titlu" style={{ color: '#C0392B' }}>{t('linkedin', 'reconecteaza')}</div>
          <div className="btn-actiune-sub">{t('linkedin', 'autorizareRespinsa')}</div>
        </div>
      </button>
    );
  }

  if (tokenExista) {
    return (
      <button className="btn-actiune-rapida" onClick={deconecteazaLinkedIn} style={{ borderColor: '#C0392B', background: '#FDEDEC' }}>
        <span>🔌</span>
        <div>
          <div className="btn-actiune-titlu" style={{ color: '#C0392B' }}>{t('linkedin', 'deconecteaza')}</div>
          <div className="btn-actiune-sub">{t('linkedin', 'conectat')}{pageName}</div>
          {textExpirare() && (
            <div className="btn-actiune-sub" style={{ color: '#C0392B', fontWeight: 600 }}>{textExpirare()}</div>
          )}
        </div>
      </button>
    );
  }

  return (
    <button className="btn-actiune-rapida" onClick={conecteazaLinkedIn} style={{ borderColor: '#0A66C2', background: '#E8F0FB' }}>
      <span><IconRetea id="linkedin" size={18} /></span>
      <div>
        <div className="btn-actiune-titlu" style={{ color: '#0A66C2' }}>{t('linkedin', 'conecteaza')}</div>
        <div className="btn-actiune-sub">{t('linkedin', 'autorizeaza')}</div>
      </div>
    </button>
  );
}

function ConectareRetele({ clientId, nume, onGata, onLogout }) {
  const [stare, setStare] = useState('verificare');
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('facebook') === 'connected') {
      window.history.replaceState({}, '', window.location.pathname);
      onGata();
      return;
    }
    let activ = true;
    (async () => {
      const { data } = await supabase.rpc('stare_conectare_client', { p_client_id: clientId, p_platform: 'facebook' });
      if (!activ) return;
      if (data && data.length > 0) onGata(); else setStare('neconectat');
    })();
    return () => { activ = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  if (stare === 'verificare') {
    return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#E8F5EE', fontFamily: "'DM Sans', sans-serif", color: '#6B7280' }}>{t('conectare', 'seIncarca')}</div>;
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#E8F5EE', fontFamily: "'DM Sans', sans-serif", padding: 16 }}>
      <div style={{ background: 'white', borderRadius: 16, padding: 40, maxWidth: 520, width: '100%', boxShadow: '0 10px 40px rgba(15,61,34,0.08)', textAlign: 'center' }}>
        <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 22, color: '#1A6B3C', marginBottom: 16 }}>NM Social</div>
        <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 26, color: '#0F3D22', marginBottom: 8 }}>{t('conectare', 'conecteazaPaginile')}</div>
        <div style={{ fontSize: 15, color: '#6B7280', lineHeight: 1.5, marginBottom: 28 }}>{t('conectare', 'mesajBunVenit', { nume })}</div>
        <div style={{ marginBottom: 20 }}>
          <BtnConectareFacebook clientId={clientId} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 28 }}>
          {['Instagram', 'TikTok', 'LinkedIn', 'YouTube', 'X'].map(r => (
            <div key={r} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', borderRadius: 10, border: '1.5px solid #E5E7EB', color: '#9CA3AF', fontSize: 14 }}>
              <span>{r}</span><span style={{ fontSize: 12 }}>{t('conectare', 'inCurand')}</span>
            </div>
          ))}
        </div>
        <button onClick={onGata} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#1A6B3C', fontSize: 14, fontWeight: 600, fontFamily: "'DM Sans', sans-serif" }}>{t('conectare', 'spreDashboard')}</button>
        <div style={{ marginTop: 20 }}>
          <button onClick={onLogout} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#9CA3AF', fontSize: 13, fontFamily: "'DM Sans', sans-serif" }}>{t('conectare', 'iesiDinCont')}</button>
        </div>
      </div>
    </div>
  );
}
// Nefolosit din 16 sept 2026: analiticele si tab-urile de jos au iesit din pagina clientului,
// profilul de voce are pagina lui (ProfilVoce). Ramane in cod pana la curatenie.
// eslint-disable-next-line no-unused-vars
function ProfilClient({ client, postari, setPostari, profiluri, setProfiluri, inapoiLaClienti, setPaginaActiva, biblioteca, setBiblioteca, tabInitial, faraAntet, faraPostari }) {
  const [filtruStatus, setFiltruStatus] = useState('toate');
  const [filtruRetea, setFiltruRetea] = useState('toate');
  const [tabActiv, setTabActiv] = useState(tabInitial || (faraPostari ? 'profil' : 'postari'));
  // „Profil de voce" din blocul clientului trebuie să schimbe tabul și atunci
  // când pagina e DEJA deschisă, nu doar la prima deschidere.
  useEffect(() => { if (tabInitial) setTabActiv(tabInitial); }, [tabInitial]);
  const [profilSeIncarca, setProfilSeIncarca] = useState(true);
  const [statFb, setStatFb] = useState(null);
  const [statFbIncarca, setStatFbIncarca] = useState(true);

  // Aceleasi cifre ca in Analize, calculate la fel, ca cele doua ecrane sa nu se contrazica.
  useEffect(() => {
    let activ = true;
    setStatFbIncarca(true); setStatFb(null);
    (async () => {
      const [rFb, rIg] = await Promise.all([
        supabase.functions.invoke('facebook-page-insights', { body: { client_id: client.id, zile: 30 } }),
        supabase.functions.invoke('instagram-insights', { body: { client_id: client.id, zile: 30 } }),
      ]);
      if (!activ) return;
      const st = adunaStatistici([
        { retea: 'facebook', raspuns: rFb },
        { retea: 'instagram', raspuns: rIg },
      ]);
      if (!st) setStatFb({ indisponibil: true });
      else setStatFb({ engagement: st.total.engagement, postari: st.total.postari, medie: st.total.medie_engagement, peRetea: st.peRetea });
      setStatFbIncarca(false);
    })();
    return () => { activ = false; };
  }, [client.id]);

  useEffect(() => {
    let activ = true;
    setProfilSeIncarca(true);
    (async () => {
      const { data, error } = await supabase
        .from('profiluri_imagologice')
        .select('continut, actualizat_la')
        .eq('client_id', client.id)
        .maybeSingle();
      if (!activ) return;
      if (!error && data?.continut) {
        const dataFmt = data.actualizat_la ? new Date(data.actualizat_la).toLocaleDateString(getLocale()) : null;
        setProfiluri(prev => ({ ...prev, [client.id]: `Profil incarcat — ${data.continut.length} caractere${dataFmt ? ` · actualizat ${dataFmt}` : ''}` }));
      }
      setProfilSeIncarca(false);
    })();
    return () => { activ = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client.id]);

  const postariClient = postari.filter(p => p.clientId === client.id && (filtruStatus === 'toate' || p.status === filtruStatus) && (filtruRetea === 'toate' || p.retea === filtruRetea));

  async function stergePostare(postare) {
    if (!window.confirm(t('profilClient', 'confirmStergePostare'))) return;
    if (postare.externalPostId) {
      const { data, error } = await supabase.functions.invoke('facebook-delete', { body: { post_id: postare.id } });
      if (error || (data && data.error)) {
        if (!window.confirm(t('profilClient', 'confirmStergeFacebook'))) return;
      }
    }
    const { error: dbErr } = await supabase.from('postari').delete().eq('id', postare.id);
    if (dbErr) { alert(t('profilClient', 'eroareStergere') + dbErr.message); return; }
    setPostari(prev => prev.filter(p => p.id !== postare.id));
  }

  async function handleProfilFisier(e) {
    const fisier = e.target.files[0];
    e.target.value = '';
    if (!fisier) return;
    try {
      const text = await extrageTextDinWord(fisier);
      if (!text) {
        alert(t('profilClient', 'eroareCitireDocument'));
        return;
      }
      const { error } = await supabase
        .from('profiluri_imagologice')
        .upsert({ client_id: client.id, continut: text, actualizat_la: new Date().toISOString() }, { onConflict: 'client_id' });
      if (error) {
        console.error('Eroare salvare profil imagologic:', error);
        alert(t('profilClient', 'eroareSalvareProfil'));
        return;
      }
      setProfiluri(prev => ({ ...prev, [client.id]: `Profil incarcat — ${text.length} caractere` }));
    } catch (err) {
      console.error('Eroare procesare profil imagologic:', err);
      alert(t('profilClient', 'eroareProcesareDocument'));
    }
  }
  async function stergeProfilFisier() {
    if (!window.confirm(t('profilClient', 'confirmStergeProfil'))) return;
    const { error } = await supabase
      .from('profiluri_imagologice')
      .delete()
      .eq('client_id', client.id);
    if (error) {
      console.error('Eroare stergere profil imagologic:', error);
      alert(t('profilClient', 'eroareStergereProfil'));
      return;
    }
    setProfiluri(prev => {
      const nou = { ...prev };
      delete nou[client.id];
      return nou;
    });
  }

  const nrAprobare = postari.filter(p => p.clientId === client.id && ['aprobare_finala', 'intern'].includes(p.status)).length;
  const foldereClient = biblioteca[client.id] || [];

  return (
    <div className={faraAntet ? '' : 'pagina'}>
      {!faraAntet && <div className="profil-header">
        <button className="btn-inapoi" onClick={inapoiLaClienti}>{t('profilClient', 'inapoiClienti')}</button>
        <div className="profil-header-continut">
          <div className="profil-avatar">{client.nume.charAt(0)}</div>
          <div className="profil-info">
            <div className="profil-nume">{client.nume}</div>
            <div className="profil-functie">{client.functie} · {client.localitate} · {client.partid}</div>
            <div className="profil-retele">{(client.retele || []).map(r => { const retea = RETELE.find(x => x.id === r); return <span key={r} className="retea-chip" style={{ background: retea?.bg, color: retea?.culoare }}><IconRetea id={r} size={12} /> {retea?.label}</span>; })}</div>
          </div>
          <div className={`status-badge ${client.status}`}>{client.status === 'activ' ? t('profilClient', 'activ') : t('profilClient', 'inactiv')}</div>
        </div>
      </div>}
      {!faraAntet && <div className="profil-actiuni">
        <button className="btn-actiune-rapida btn-actiune-principal" onClick={() => setPaginaActiva('compositor2')}><span>✏️</span><div><div className="btn-actiune-titlu">{t('profilClient', 'postareNoua')}</div><div className="btn-actiune-sub">{t('profilClient', 'creeazaPostare')}</div></div></button>
        <button className="btn-actiune-rapida" onClick={() => setPaginaActiva('calendar')}><span>📅</span><div><div className="btn-actiune-titlu">{t('profilClient', 'calendar')}</div><div className="btn-actiune-sub">{t('profilClient', 'postariProgramate')}</div></div></button>
        <button className="btn-actiune-rapida" onClick={() => setPaginaActiva('inbox')}><span>💬</span><div><div className="btn-actiune-titlu">{t('profilClient', 'inbox')}</div><div className="btn-actiune-sub">{t('profilClient', 'mesajeComentarii')}</div></div></button>
        {nrAprobare > 0 && <button className="btn-actiune-rapida btn-actiune-atentie" onClick={() => setPaginaActiva('aprobare')}><span>✅</span><div><div className="btn-actiune-titlu">{t('profilClient', 'aprobare')}</div><div className="btn-actiune-sub">{t('profilClient', 'inAsteptare', { n: nrAprobare })}</div></div></button>}
      <BtnConectareFacebook clientId={client.id} />
      <BtnConectareTikTok clientId={client.id} />
      <BtnConectareLinkedIn clientId={client.id} />
    </div>}
      {/* Cifrele pe retea, ca in Analize: un total comun nu-ti spune CARE retea
          merge. Aceleasi carduri, acelasi calcul, ca sa nu se contrazica. */}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 18 }}>
        {statFbIncarca && !statFb?.indisponibil && (
          <div style={{ flex: '1 1 220px', background: 'white', border: '1.5px solid #D1E8DA', borderRadius: 12, padding: '16px', color: '#9CA3AF', fontSize: 13 }}>
            {t('statisticiClient', 'seIncarca')}
          </div>
        )}
        {/* Doar Facebook si Instagram: pentru TikTok nu avem inca permisiunile de
            citire (user.info.stats, video.list), deci un card acolo ar fi gol.
            Se adauga cand se cere a doua aprobare TikTok.
            O retea neconectata nu apare deloc, nici macar ca sa spuna ca lipseste:
            butonul mare "Connect Facebook" de deasupra spune deja asta, iar un card
            punctat langa unul plin doar repeta si arata strambe. */}
        {!statFbIncarca && ['facebook', 'instagram'].map(id => {
          const r = RETELE.find(x => x.id === id);
          const d = statFb?.peRetea?.[id];
          if (!d) return null;
          return (
            <div key={id} style={{ flex: '1 1 220px', background: 'white', border: `1.5px solid ${r.bg}`, borderLeft: `4px solid ${r.culoare}`, borderRadius: 12, padding: '12px 16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
                <IconRetea id={id} size={13} />
                <span style={{ fontSize: 13, fontWeight: 600, color: r.culoare }}>{r.label}</span>
              </div>
              <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
                {d.urmaritori !== null && (
                  <div>
                    <div style={{ fontSize: 17, fontWeight: 700, color: '#0F3D22' }}>{formatNr(d.urmaritori)}</div>
                    <div style={{ fontSize: 11, color: '#6B7280' }}>{t('analize', 'urmaritori')}</div>
                  </div>
                )}
                <div>
                  <div style={{ fontSize: 17, fontWeight: 700, color: '#0F3D22' }}>{d.postari}</div>
                  <div style={{ fontSize: 11, color: '#6B7280' }}>{t('analize', 'postari')}</div>
                </div>
                <div>
                  <div style={{ fontSize: 17, fontWeight: 700, color: '#1A6B3C' }}>{formatNr(d.engagement)}</div>
                  <div style={{ fontSize: 11, color: '#6B7280' }}>{t('analize', 'engagementRand')}</div>
                </div>
              </div>
              <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 8 }}>
                {d.reactii} {t('analize', 'reactii')} · {d.comentarii} {t('analize', 'comentarii')} · {d.distribuiri} {t('analize', 'distribuiri')}
              </div>
            </div>
          );
        })}
      </div>
      <div className="profil-tabs">
        {/* Cand pagina noua afiseaza postarile (Etapa 4, pasul 6), tabul asta ar
            arata aceleasi randuri a doua oara. */}
        {!faraPostari && <button className={`profil-tab ${tabActiv === 'postari' ? 'activ' : ''}`} onClick={() => setTabActiv('postari')}>{t('profilClient', 'tabPostari')} ({postariClient.length})</button>}
        <button className={`profil-tab ${tabActiv === 'profil' ? 'activ' : ''}`} onClick={() => setTabActiv('profil')}>{t('profilClient', 'profilImagologic')}</button>
        <button className={`profil-tab ${tabActiv === 'media' ? 'activ' : ''}`} onClick={() => setTabActiv('media')}>{t('profilClient', 'tabMedia')} ({foldereClient.reduce((s, f) => s + f.fisiere.length, 0)})</button>
      </div>
      {tabActiv === 'postari' && !faraPostari && (
        <div className="profil-sectiune">
          <div className="profil-sectiune-header">
            <div className="profil-sectiune-titlu">{t('profilClient', 'postari')}</div>
            <div className="profil-filtre">
              <select className="select-filtru" value={filtruStatus} onChange={e => setFiltruStatus(e.target.value)}>
                <option value="toate">{t('profilClient', 'toateStatusurile')}</option>
                {Object.entries(STATUS_INFO).map(([key, val]) => <option key={key} value={key}>{t('status', key)}</option>)}
              </select>
              <select className="select-filtru" value={filtruRetea} onChange={e => setFiltruRetea(e.target.value)}>
                <option value="toate">{t('profilClient', 'toateRetelele')}</option>
                {(client.retele || []).map(r => { const retea = RETELE.find(x => x.id === r); return <option key={r} value={r}>{retea?.label}</option>; })}
              </select>
            </div>
          </div>
          {postariClient.length === 0 ? <div className="pagina-gol" style={{ padding: '40px 0' }}><div className="pagina-gol-icon">📭</div><p>{t('profilClient', 'nicioPostare')}</p></div> : (
            <div className="profil-postari-lista">
              {postariClient.map(postare => {
                const retea = RETELE.find(r => r.id === postare.retea); const si = STATUS_INFO[postare.status];
                return (
                  <div key={postare.id} className="profil-postare-card">
                    <div className="profil-postare-header">
                      <div className="profil-postare-meta"><span className="retea-chip" style={{ background: retea?.bg, color: retea?.culoare }}><IconRetea id={postare.retea} size={12} /> {retea?.label} · {postare.format}</span><span className="aprobare-status-badge" style={{ background: si.bg, color: si.culoare }}>{t('status', postare.status)}</span></div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div className="profil-postare-data">{postare.status === 'publicat' && postare.publicatLa ? `${t('profilClient', 'publicat')}${new Date(postare.publicatLa).toLocaleString(getLocale(), { timeZone: 'Europe/Bucharest', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}` : `📅 ${postare.dataProgramata} · ${postare.ora}`}</div>
                        <button onClick={() => stergePostare(postare)} title={t('profilClient', 'stergePostarea')} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 16, padding: 4, lineHeight: 1, opacity: 0.65 }}>🗑</button>
                      </div>
                    </div>
                    {postare.imagineUrl && (
                      <img src={postare.imagineUrl} alt="" loading="lazy" style={{ display: 'block', width: '100%', maxHeight: 320, objectFit: 'cover', borderRadius: 10, margin: '8px 0' }} />
                    )}
                    <div className="profil-postare-text">{postare.text}</div>
                    {postare.hashtags && <div style={{ color: '#1A6B3C', fontSize: 13, marginTop: 8 }}>{postare.hashtags}</div>}
                    {postare.feedback && <div className="profil-postare-feedback">💬 {postare.feedback}</div>}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
      {tabActiv === 'profil' && (
        <div className="profil-sectiune">
          <div className="profil-sectiune-titlu">Profil imagologic</div>
          {profilSeIncarca ? (
            <div className="profil-incarcat">
              <span className="profil-incarcat-icon">⏳</span>
              <div className="profil-incarcat-info"><div className="profil-incarcat-nume">{t('profilClient', 'seVerificaProfilul')}</div></div>
            </div>
          ) : profiluri[client.id] ? (
            <div className="profil-incarcat">
              <span className="profil-incarcat-icon">📄</span>
              <div className="profil-incarcat-info"><div className="profil-incarcat-nume">{profiluri[client.id]}</div><div className="profil-incarcat-data">{t('profilClient', 'aiVaScrie')}</div></div>
              <div className="profil-incarcat-actiuni">
                <label className="btn-secundar" style={{ cursor: 'pointer', padding: '6px 14px', fontSize: '13px' }}><input type="file" accept=".doc,.docx" onChange={handleProfilFisier} style={{ display: 'none' }} />{t('profilClient', 'inlocuieste')}</label>
                <button className="btn-sterge-profil" onClick={stergeProfilFisier}>{t('profilClient', 'stergeProfil')}</button>
              </div>
            </div>
          ) : (
            <label className="upload-zona upload-zona-mic" style={{ cursor: 'pointer', maxWidth: 500 }}>
              <input type="file" accept=".doc,.docx" onChange={handleProfilFisier} style={{ display: 'none' }} />
              <div className="upload-continut"><div className="upload-icon">📄</div><div className="upload-text">{t('profilClient', 'incarcaProfilImagologic')}</div><div className="upload-hint">{t('profilClient', 'documentWord')}</div></div>
            </label>
          )}
        </div>
      )}
      {tabActiv === 'media' && (
        <div className="profil-sectiune">
          <div className="profil-sectiune-header">
            <div className="profil-sectiune-titlu">Media · {foldereClient.length} {t('profilClient', 'mediaEvenimente')}</div>
          </div>
          {foldereClient.length === 0 ? (
            <div className="pagina-gol" style={{ padding: '40px 0' }}><div className="pagina-gol-icon">🖼️</div><p>{t('profilClient', 'niciunFisier')}</p></div>
          ) : (
            <div className="profil-media-foldere">
              {foldereClient.map(folder => (
                <div key={folder.id} className="profil-media-folder">
                  <div className="profil-media-folder-header">
                    <div>
                      <div className="profil-media-folder-nume">{folder.numeEveniment}</div>
                      <div className="profil-media-folder-meta">📅 {folder.data} · {folder.fisiere.length} {t('profilClient', 'fisiere')}</div>
                      <div className="biblioteca-folder-taguri" style={{ marginTop: 4 }}>{folder.taguri.map(t => <span key={t} className="tag-chip">#{t}</span>)}</div>
                    </div>
                  </div>
                  <div className="profil-media-grid">
                    {folder.fisiere.map(f => (
                      <div key={f.id} className="profil-media-item">
                        {f.tip === 'imagine' && f.url ? <img src={f.url} alt={f.nume} className="profil-media-img" /> : <div className="profil-media-placeholder">{f.tip === 'video' ? '🎬' : '🖼️'}</div>}
                        <div className="profil-media-nume">{f.nume}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// Cand o functie edge intoarce non-2xx, supabase-js arunca corpul raspunsului si
// pastreaza doar "Edge Function returned a non-2xx status code". Motivul adevarat,
// pe care functia l-a scris, se pierde exact cand ai nevoie de el. Il recuperam.
async function motivEroareFunctie(err, data) {
  if (data?.error) return data.detail ? `${data.error} — ${data.detail}` : data.error;
  const resp = err?.context;
  if (resp && typeof resp.json === 'function') {
    try {
      const corp = await resp.json();
      if (corp?.error) return corp.detail ? `${corp.error} — ${corp.detail}` : corp.error;
      if (corp?.detail) return corp.detail;
    } catch (e) { /* corpul nu era JSON */ }
  }
  return err?.message || 'eroare necunoscuta';
}

function Compositor({ clienti, profiluri, clientPreSelectat, biblioteca, setPostari, sesiune, profilUtilizator, ascundeSelectorClient, permisiuniClient, onPublicat, postareEdit, setPostareEdit, setPaginaActiva }) {
  const [clientId, setClientId] = useState(clientPreSelectat ? String(clientPreSelectat.id) : '');
  const [reteleSelectate, setReteleSelectate] = useState([]);
  const [formate, setFormate] = useState({});
  const [text, setText] = useState('');
  const [hashtags, setHashtags] = useState('');
  const [context, setContext] = useState('');
  const [contextFisiere, setContextFisiere] = useState([]);
  const [imagine, setImagine] = useState(null);
  const [eroareVideo, setEroareVideo] = useState('');
  const [imagineUrl, setImagineUrl] = useState(null);
  // Postarea cu link. LinkedIn nu citeste pagina ca sa-si faca previzualizarea
  // („The Posts API does not support URL scraping"), deci titlul, descrierea si
  // miniatura pleaca de la noi sau linkul apare gol in feed.
  const [linkUrl, setLinkUrl] = useState('');
  const [linkTitlu, setLinkTitlu] = useState('');
  const [linkDescriere, setLinkDescriere] = useState('');
  const [uploadingImagine, setUploadingImagine] = useState(false);
  const [imagineConvertita, setImagineConvertita] = useState(false);
  const [imaginiCarusel, setImaginiCarusel] = useState([]);
  const [uploadingCarusel, setUploadingCarusel] = useState(false);
  const [video, setVideo] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [uploadingVideo, setUploadingVideo] = useState(false);
  const [linkMedia, setLinkMedia] = useState('');
  // Alegerile cerute de TikTok pentru Direct Post. Se fac aici, la compunere,
  // si se salveaza pe postare: cron-ul publica apoi cu ele, fara om in fata ecranului.
  const [videoDurataSec, setVideoDurataSec] = useState(null);
  const [ttInfo, setTtInfo] = useState(null);
  const [ttIncarca, setTtIncarca] = useState(false);
  const [ttEroare, setTtEroare] = useState('');
  const [ttPrivacy, setTtPrivacy] = useState('');
  // Lista nativa <select> se deseneaza intr-un strat al sistemului si NU apare in
  // inregistrarile de ecran. TikTok cere ca recenzentul sa VADA optiunile si
  // valoarea goala implicita, deci o construim din elemente de pagina.
  const [ttListaDeschisa, setTtListaDeschisa] = useState(false);
  const [ttComentarii, setTtComentarii] = useState(false);
  const [ttDuet, setTtDuet] = useState(false);
  const [ttStitch, setTtStitch] = useState(false);
  const [ttComercial, setTtComercial] = useState(false);
  const [ttBrandPropriu, setTtBrandPropriu] = useState(false);
  const [ttBrandContent, setTtBrandContent] = useState(false);
  const [cropActiv, setCropActiv] = useState(null);
  const [dataProgramata, setDataProgramata] = useState('');
  const [oraProgramata, setOraProgramata] = useState('10:00');
  const [publicareImediata, setPublicareImediata] = useState(false);
  const [tiktokConectat, setTiktokConectat] = useState(false);

  useEffect(() => {
    if (!clientId) { setTiktokConectat(false); return; }
    async function verificaTikTok() {
      const { data } = await supabase.rpc('stare_conectare_client', { p_client_id: clientId, p_platform: 'tiktok' });
      const conectat = !!(data && data.length > 0);
      setTiktokConectat(conectat);
      if (!conectat) setReteleSelectate(prev => prev.filter(id => id !== 'tiktok'));
    }
    verificaTikTok();
  }, [clientId]);

  useEffect(() => {
    if (!postareEdit) return;
    setClientId(String(postareEdit.clientId));
    setReteleSelectate([postareEdit.retea]);
    setFormate({ [postareEdit.retea]: postareEdit.format });
    setText(postareEdit.text || '');
    setHashtags(postareEdit.hashtags || '');
    setImagineUrl(postareEdit.imagineUrl || null);
    setImagine(postareEdit.imagineUrl || null);
    setImaginiCarusel((postareEdit.imaginiUrl || []).map(u => ({ url: u })));
    setVideoUrl(postareEdit.videoUrl || null);
    setVideo(postareEdit.videoUrl || null);
    setDataProgramata(postareEdit.dataProgramata || '');
    setOraProgramata(postareEdit.ora || '10:00');
    setPublicareImediata(false);
  }, [postareEdit]);

  async function salveazaEditare() {
    if (!poateTrimite) return;
    if (!publicareImediata && !dataProgramata) {
      alert(t('compositor', 'alegeData'));
      return;
    }
    setTrimitere(true);
    try {
      const retea = reteleSelectate[0] || postareEdit.retea;
      const updateData = {
        retea,
        format: formate[retea] || FORMATE[retea][0],
        text,
        hashtags,
        data_programata: dataProgramata || null,
        ora_programata: oraProgramata || null,
        imagine_url: caruselActiv ? (imaginiCarusel[0]?.url || null) : imagineUrl,
        video_url: caruselActiv ? null : videoUrl,
        imagini_url: caruselActiv ? imaginiCarusel.map(i => i.url) : null,
      };
      const { error } = await supabase.from('postari').update(updateData).eq('id', postareEdit.id);
      if (error) throw error;
      setPostari(prev => prev.map(p => p.id === postareEdit.id
        ? { ...p, retea, format: updateData.format, text, hashtags, dataProgramata: dataProgramata || null, ora: oraProgramata || null, imagineUrl, videoUrl }
        : p));
      setText(''); setHashtags(''); setReteleSelectate([]); setFormate({});
      setImagine(null); setImagineUrl(null); setVideo(null); setVideoUrl(null);
      setDataProgramata(''); setOraProgramata('10:00'); setPublicareImediata(false);
      if (setPostareEdit) setPostareEdit(null);
      alert(t('compositor', 'modificariSalvate'));
      if (setPaginaActiva) setPaginaActiva('calendar');
    } catch (err) {
      alert(t('compositor', 'eroarePrefix') + err.message);
    } finally {
      setTrimitere(false);
    }
  }
  const [aiLoading, setAiLoading] = useState(false);
  const [aiRezultate, setAiRezultate] = useState({});
  const [aiTabActiv, setAiTabActiv] = useState(null);
  const [profilText, setProfilText] = useState(null);
  const [tema, setTema] = useState('');
  const [trimitere, setTrimitere] = useState(false);
const textareaPostareRef = React.useRef(null);
  const clientAles = clienti.find(c => c.id === parseInt(clientId));
  const areProfilImagologic = !!profilText;
  const areContext = context.trim().length > 0 || contextFisiere.length > 0 || tema.trim().length > 0;
  const areRezultateAI = Object.keys(aiRezultate).length > 0;

  useEffect(() => {
    let activ = true;
    setProfilText(null);
    if (!clientAles?.id) {
      return;
    }
    (async () => {
      const { data, error } = await supabase
        .from('profiluri_imagologice')
        .select('continut')
        .eq('client_id', clientAles.id)
        .maybeSingle();
      if (!activ) return;
      if (error) {
        console.error('Eroare incarcare profil imagologic:', error);
        setProfilText(null);
        return;
      }
      setProfilText(data?.continut || null);
    })();
    return () => { activ = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, clientAles]);

  function toggleRetea(r) {
    setReteleSelectate(prev => {
      if (prev.includes(r)) {
        const nou = prev.filter(x => x !== r);
        if (cropActiv === r) setCropActiv(nou[0] || null);
        if (aiTabActiv === r) setAiTabActiv(nou[0] || null);
        return nou;
      } else {
        if (!cropActiv) setCropActiv(r);
        if (!aiTabActiv) setAiTabActiv(r);
        setFormate(f => ({ ...f, [r]: FORMATE[r][0] }));
        return [...prev, r];
      }
    });
  }

  function setFormat(retea, format) { setFormate(f => ({ ...f, [retea]: format })); }

  function getLimitaCaractere() {
    if (reteleSelectate.length === 0) return null;
    return Math.min(...reteleSelectate.map(r => LIMITE_CARACTERE[r]?.[formate[r] || FORMATE[r][0]] || 2200));
  }

  function getOreRecomandate() {
    if (reteleSelectate.length === 0) return [];
    return [...new Set(reteleSelectate.flatMap(r => ORE_RECOMANDATE[r] || []))].sort();
  }

  // Caruselul are propriul drum de incarcare: mai multe fisiere odata, toate
  // trecute prin laJpeg ca orice imagine, adaugate la lista existenta.
  async function handleFisiereCarusel(e) {
    const fisiere = Array.from(e.target.files || []);
    e.target.value = '';
    if (!fisiere.length) return;
    if (!clientId) { setEroareVideo(t('compositor', 'selecteazaClientImagine')); return; }
    setEroareVideo('');
    setUploadingCarusel(true);
    try {
      for (const fisier of fisiere) {
        if (!fisier.type.startsWith('image/')) continue;
        const { fisier: deIncarcat } = await laJpeg(fisier);
        const extensie = deIncarcat.name.split('.').pop();
        const numeFisier = `${Date.now()}_${Math.random().toString(36).slice(2)}.${extensie}`;
        const storagePath = `${parseInt(clientId)}/postari/${numeFisier}`;
        const { error: errUpload } = await supabase.storage.from('media-clienti').upload(storagePath, deIncarcat);
        if (errUpload) throw errUpload;
        const { data: { publicUrl } } = supabase.storage.from('media-clienti').getPublicUrl(storagePath);
        setImaginiCarusel(prev => prev.length >= 10 ? prev : [...prev, { url: publicUrl }]);
      }
    } catch (err) {
      setEroareVideo(t('compositor', 'eroareIncarcareImagine') + err.message);
    } finally {
      setUploadingCarusel(false);
    }
  }

  function stergeImagineCarusel(idx) {
    setImaginiCarusel(prev => prev.filter((_, i) => i !== idx));
  }

  async function handleFisierMedia(e) {
    const fisier = e.target.files[0]; if (!fisier) return;
    setEroareVideo(''); setImagine(null); setImagineUrl(null); setVideo(null); setVideoUrl(null); setImagineConvertita(false);
    if (fisier.type.startsWith('video/')) {
      const mb = fisier.size / (1024 * 1024);
      const lim = reteleSelectate.length > 0 ? Math.min(...reteleSelectate.map(r => LIMITE_VIDEO[r] || 100)) : 100;
      if (mb > lim) { setEroareVideo(t('compositor', 'fisierPreaMare', { mb: mb.toFixed(0), lim })); return; }
      if (!clientId) { setEroareVideo(t('compositor', 'selecteazaClientVideo')); return; }
      setVideo(URL.createObjectURL(fisier));
      if (reteleSelectate.length > 0 && !cropActiv) setCropActiv(reteleSelectate[0]);
      setUploadingVideo(true);
      try {
        const extensie = fisier.name.split('.').pop();
        const numeFisier = `${Date.now()}_${Math.random().toString(36).slice(2)}.${extensie}`;
        const storagePath = `${parseInt(clientId)}/postari/${numeFisier}`;
        const { error: errUpload } = await supabase.storage.from('media-clienti').upload(storagePath, fisier);
        if (errUpload) throw errUpload;
        const { data: { publicUrl } } = supabase.storage.from('media-clienti').getPublicUrl(storagePath);
        setVideoUrl(publicUrl);
      } catch (err) {
        setEroareVideo(t('compositor', 'eroareIncarcareVideo') + err.message);
        setVideo(null);
        setVideoUrl(null);
      } finally {
        setUploadingVideo(false);
      }
      return;
    }
    if (fisier.type.startsWith('image/')) {
      if (!clientId) { setEroareVideo(t('compositor', 'selecteazaClientImagine')); return; }
      // preview local instant
      setImagine(URL.createObjectURL(fisier));
      if (reteleSelectate.length > 0 && !cropActiv) setCropActiv(reteleSelectate[0]);
      // upload real la Storage (media-clienti), tine URL-ul persistent pt salvare
      setUploadingImagine(true);
      try {
        const { fisier: deIncarcat, convertit } = await laJpeg(fisier);
        setImagineConvertita(convertit);
        // Previzualizarea arata rezultatul real, nu originalul: altfel omul vede
        // transparenta pe ecran si fundal alb in postarea publicata.
        if (convertit) setImagine(URL.createObjectURL(deIncarcat));
        const extensie = deIncarcat.name.split('.').pop();
        const numeFisier = `${Date.now()}_${Math.random().toString(36).slice(2)}.${extensie}`;
        const storagePath = `${parseInt(clientId)}/postari/${numeFisier}`;
        const { error: errUpload } = await supabase.storage.from('media-clienti').upload(storagePath, deIncarcat);
        if (errUpload) throw errUpload;
        const { data: { publicUrl } } = supabase.storage.from('media-clienti').getPublicUrl(storagePath);
        setImagineUrl(publicUrl);
      } catch (err) {
        setEroareVideo(t('compositor', 'eroareIncarcareImagine') + err.message);
        setImagine(null);
        setImagineUrl(null);
      } finally {
        setUploadingImagine(false);
      }
    }
  }

  // Facebook ia fisierul singur de la adresa data (facebook-publish trimite `url`,
  // nu octetii), deci un link public merge la fel de bine ca o urcare in Storage.
  function linkDirect(brut) {
    try {
      const u = new URL(brut);
      if (!u.hostname.includes('dropbox.com')) return brut;
      // Linkul de partajare intoarce o pagina web, nu fisierul.
      u.hostname = 'dl.dropboxusercontent.com';
      u.searchParams.delete('dl');
      u.searchParams.delete('st');
      return u.toString();
    } catch (e) {
      return brut;
    }
  }

  function aplicaLinkMedia() {
    const brut = linkMedia.trim();
    if (!brut) return;
    const url = linkDirect(brut);
    let cale = url.toLowerCase();
    try { cale = new URL(url).pathname.toLowerCase(); } catch (e) { /* link fara schema */ }
    const eVideo = /\.(mp4|mov|m4v|webm)$/.test(cale);
    const eImagine = /\.(jpg|jpeg|png|gif|webp)$/.test(cale);
    if (!eVideo && !eImagine) { setEroareVideo(t('compositor', 'linkNerecunoscut')); return; }
    setEroareVideo('');
    setImagineConvertita(false);
    if (eVideo) { setVideo(url); setVideoUrl(url); setImagine(null); setImagineUrl(null); }
    else { setImagine(url); setImagineUrl(url); setVideo(null); setVideoUrl(null); }
    if (reteleSelectate.length > 0 && !cropActiv) setCropActiv(reteleSelectate[0]);
    setLinkMedia('');
  }

  function handleContextFisier(e) {
    const fisiere = Array.from(e.target.files);
    setContextFisiere(prev => [...prev, ...fisiere.map(f => ({
      nume: f.name,
      tip: f.type.startsWith('image/') ? 'imagine' : 'document',
      url: f.type.startsWith('image/') ? URL.createObjectURL(f) : null,
    }))]);
  }

  function stergeContextFisier(idx) { setContextFisiere(prev => prev.filter((_, i) => i !== idx)); }

  async function handleGenereazaAI() {
    if (!clientAles || reteleSelectate.length === 0) return;
    setAiLoading(true);
    setAiRezultate({});
    try {
      const rezultate = await genereazaContiut({
        politician: `${clientAles.nume} — ${clientAles.functie}, ${clientAles.localitate}`,
        tema: tema || context || 'postare generală',
        context: context,
        profilText: profilText,
        reteleSelectate,
        formate,
      });
      setAiRezultate(rezultate);
      const primaRetea = reteleSelectate.find(r => rezultate[r]?.text);
      if (primaRetea) setAiTabActiv(primaRetea);
      const reteaSimple = ['facebook', 'linkedin'].find(r => reteleSelectate.includes(r) && rezultate[r]?.text);
      if (reteaSimple) {
        const parsed = parseazaRezultat(reteaSimple, rezultate[reteaSimple].text);
        if (parsed.tip === 'simplu') {
          setText(parsed.continut);
          if (parsed.hashtags) setHashtags(parsed.hashtags);
        }
      }
    } catch (err) {
      console.error('Eroare generare AI:', err);
    } finally {
      setAiLoading(false);
    }
  }

  async function handleTrimiteAprobare() {
    if (!poateTrimite) return;
    setTrimitere(true);
    try {
      const postariDeSalvat = reteleSelectate.map(retea => ({
        client_id: parseInt(clientId),
        client_nume: clientAles.nume,
        retea,
        format: formate[retea] || FORMATE[retea][0],
        text,
        hashtags,
        status: 'aprobare_finala',
        data_programata: dataProgramata || null,
        ora_programata: oraProgramata || null,
        creat_de: sesiune?.user?.id,
        creat_de_nume: profilUtilizator?.nume || 'Utilizator',
        // La carusel, imagine_url ramane PRIMA imagine: toate previzualizarile
        // existente (Calendar, Aprobare, Drafturi) o citesc si continua sa mearga.
        imagine_url: (retea === 'instagram' && caruselActiv) ? (imaginiCarusel[0]?.url || null) : imagineUrl,
        video_url: (retea === 'instagram' && caruselActiv) ? null : videoUrl,
        ...(retea === 'instagram' && caruselActiv ? { imagini_url: imaginiCarusel.map(i => i.url) } : {}),
        ...campuriTikTok(retea),
        ...campuriLink(retea),
      }));
      const { data: inserate, error } = await supabase.from('postari').insert(postariDeSalvat).select();
      if (error) throw error;
      // Adăugăm în state local din rândurile reale (cu uuid corect din DB)
      setPostari(prev => [...prev, ...inserate.map(normalizeazaPostare)]);
      alert(t('compositor', 'postariTrimiseAprobare', { n: reteleSelectate.length }));
      setText('');
      setHashtags('');
      setTema('');
      setContext('');
      setAiRezultate({});
      setReteleSelectate([]);
      setImagine(null);
      setImagineUrl(null);
      setLinkUrl('');
      setLinkTitlu('');
      setLinkDescriere('');
      setVideo(null);
      setVideoUrl(null);
    } catch (err) {
      alert(t('compositor', 'eroarePrefix') + err.message);
    } finally {
      setTrimitere(false);
    }
  }

  async function handlePublica() {
    if (!poateTrimite) return;
    if (!publicareImediata && !dataProgramata) {
      alert(t('compositor', 'alegeData'));
      return;
    }
    setTrimitere(true);
    try {
      const statusNou = publicareImediata ? 'publicat' : 'programat';
      const postariDeSalvat = reteleSelectate.map(retea => ({
        client_id: parseInt(clientId),
        client_nume: clientAles.nume,
        retea,
        format: formate[retea] || FORMATE[retea][0],
        text,
        hashtags,
        status: statusNou,
        data_programata: dataProgramata || null,
        ora_programata: oraProgramata || null,
        creat_de: sesiune?.user?.id,
        creat_de_nume: profilUtilizator?.nume || 'Utilizator',
        // La carusel, imagine_url ramane PRIMA imagine: toate previzualizarile
        // existente (Calendar, Aprobare, Drafturi) o citesc si continua sa mearga.
        imagine_url: (retea === 'instagram' && caruselActiv) ? (imaginiCarusel[0]?.url || null) : imagineUrl,
        video_url: (retea === 'instagram' && caruselActiv) ? null : videoUrl,
        ...(retea === 'instagram' && caruselActiv ? { imagini_url: imaginiCarusel.map(i => i.url) } : {}),
        ...campuriTikTok(retea),
        ...campuriLink(retea),
      }));

      // Inseram si luam id-urile reale inapoi
      const { data: inserate, error } = await supabase
        .from('postari')
        .insert(postariDeSalvat)
        .select();
      if (error) throw error;

      // Publicam efectiv pe Facebook postarile imediate (restul retelelor raman mock)
      const erori = [];
      if (publicareImediata) {
        for (const p of inserate) {
          const fnPublicare = FUNCTIE_PUBLICARE[p.retea];
          if (!fnPublicare) continue;
          const { data: pubData, error: pubErr } = await supabase.functions.invoke(
            fnPublicare,
            { body: { post_id: p.id } }
          );
          if (pubErr || pubData?.error) {
            p.status = 'draft'; // functia a pus deja draft in DB; sincronizam local
            erori.push({ retea: p.retea, motiv: await motivEroareFunctie(pubErr, pubData) });
          }
        }
      }

      // State-ul local din randurile reale
      const postariNoi = inserate.map(row => ({
        id: row.id,
        clientId: row.client_id,
        client: row.client_nume,
        retea: row.retea,
        format: row.format,
        text: row.text,
        status: row.status,
        creatDe: row.creat_de_nume,
        dataProgramata: row.data_programata || '',
        ora: row.ora_programata || '',
        feedback: '',
        imagineUrl: row.imagine_url,
        videoUrl: row.video_url,
      }));
      setPostari(prev => [...prev, ...postariNoi]);

      const n = reteleSelectate.length;

      // Resetam complet formularul pentru o postare noua
      setText('');
      setHashtags('');
      setTema('');
      setContext('');
      setContextFisiere([]);
      setAiRezultate({});
      setAiTabActiv(null);
      setReteleSelectate([]);
      setFormate({});
      setImagine(null);
      setImagineUrl(null);
      setLinkUrl('');
      setLinkTitlu('');
      setLinkDescriere('');
      setVideo(null);
      setVideoUrl(null);
      setEroareVideo('');
      setCropActiv(null);
      setDataProgramata('');
      setOraProgramata('10:00');
      setPublicareImediata(false);

      if (erori.length > 0) {
        alert(t('compositor', 'publicarePicata', {
          n, k: erori.length,
          retele: erori.map(e => e.retea).join(', '),
          detaliu: erori.map(e => e.motiv).join(' | '),
        }));
      } else {
        alert(publicareImediata
          ? t('compositor', 'postariPublicate', { n })
          : t('compositor', 'postariProgramate', { n }));
      }

      if (onPublicat) onPublicat();
    } catch (err) {
      alert(t('compositor', 'eroarePrefix') + err.message);
    } finally {
      setTrimitere(false);
    }
  }

  async function handleSalveazaDraft() {
    if (!poateTrimite) return;
    setTrimitere(true);
    try {
      const postariDeSalvat = reteleSelectate.map(retea => ({
        client_id: parseInt(clientId),
        client_nume: clientAles.nume,
        retea,
        format: formate[retea] || FORMATE[retea][0],
        text,
        hashtags,
        status: 'draft',
        data_programata: dataProgramata || null,
        ora_programata: oraProgramata || null,
        creat_de: sesiune?.user?.id,
        creat_de_nume: profilUtilizator?.nume || 'Utilizator',
        // La carusel, imagine_url ramane PRIMA imagine: toate previzualizarile
        // existente (Calendar, Aprobare, Drafturi) o citesc si continua sa mearga.
        imagine_url: (retea === 'instagram' && caruselActiv) ? (imaginiCarusel[0]?.url || null) : imagineUrl,
        video_url: (retea === 'instagram' && caruselActiv) ? null : videoUrl,
        ...(retea === 'instagram' && caruselActiv ? { imagini_url: imaginiCarusel.map(i => i.url) } : {}),
        ...campuriTikTok(retea),
        ...campuriLink(retea),
      }));
      const { error } = await supabase.from('postari').insert(postariDeSalvat);
      if (error) throw error;
      const postariNoi = reteleSelectate.map((retea, i) => ({
        id: Date.now() + i,
        clientId: parseInt(clientId),
        client: clientAles.nume,
        retea,
        format: formate[retea] || FORMATE[retea][0],
        text,
        status: 'draft',
        creatDe: profilUtilizator?.nume || 'Utilizator',
        dataProgramata: dataProgramata || '',
        ora: oraProgramata || '',
        feedback: '',
        imagineUrl: imagineUrl,
        videoUrl: videoUrl,
      }));
      setPostari(prev => [...prev, ...postariNoi]);
      const n = reteleSelectate.length;
      alert(t('compositor', 'cioraneSalvate', { n }));
    } catch (err) {
      alert(t('compositor', 'eroarePrefix') + err.message);
    } finally {
      setTrimitere(false);
    }
  }

  function folosestTextulAI(retea) {
    const rez = aiRezultate[retea];
    if (!rez?.text) return;
    const parsed = parseazaRezultat(retea, rez.text);
    if (parsed.tip === 'simplu') {
      setText(parsed.continut);
      if (parsed.hashtags) setHashtags(parsed.hashtags);
    }
    else if (parsed.tip === 'instagram') setText(parsed.textPostare);
    else if (parsed.tip === 'video') setText(parsed.script);
    else if (parsed.tip === 'thread') setText(parsed.tweets.join('\n\n'));
  }

  const limitaCaractere = getLimitaCaractere();
  const depasitLimita = limitaCaractere && text.length > limitaCaractere;
  const azi = new Date().toISOString().split('T')[0];
  const oreRecomandate = getOreRecomandate();
  // Cat timp media urca la Storage, imagine_url e inca null: daca se publica acum,
  // postarea pleaca fara imagine. Vezi cazul din 16 aug (NM Write, postare text-only).
  const tiktokAles = reteleSelectate.includes('tiktok');

  // Alegerile se salveaza doar pe randul de TikTok; pe celelalte retele n-au sens.
  const etichetaConfid = o => (
    o === 'PUBLIC_TO_EVERYONE' ? t('tiktok', 'privPublic')
      : o === 'FOLLOWER_OF_CREATOR' ? t('tiktok', 'privUrmaritori')
      : o === 'MUTUAL_FOLLOW_FRIENDS' ? t('tiktok', 'privPrieteni')
      : o === 'SELF_ONLY' ? t('tiktok', 'privDoarEu') : o
  );

  // Campurile de link merg doar pe LinkedIn, singura retea de la noi care cere
  // previzualizarea construita de noi. Miniatura foloseste poza postarii: pe
  // LinkedIn o postare e ori articol, ori imagine, deci daca ai pus si link, si
  // poza, poza devine miniatura linkului.
  const campuriLink = retea => (retea !== 'linkedin' || !linkUrl.trim()) ? {} : {
    link_url: linkUrl.trim(),
    link_titlu: linkTitlu.trim() || null,
    link_descriere: linkDescriere.trim() || null,
    link_imagine_url: imagineUrl || null,
  };

  const campuriTikTok = retea => retea !== 'tiktok' ? {} : {
    tiktok_privacy_level: ttPrivacy || null,
    tiktok_disable_comment: !ttComentarii,
    tiktok_disable_duet: !ttDuet,
    tiktok_disable_stitch: !ttStitch,
    tiktok_brand_content_toggle: ttComercial && ttBrandContent,
    tiktok_brand_organic_toggle: ttComercial && ttBrandPropriu,
  };

  // TikTok cere ca datele sa fie citite la afisarea ecranului de postare, nu mai
  // devreme: setarile contului se pot schimba intre timp.
  useEffect(() => {
    if (!tiktokAles || !clientId) { setTtInfo(null); setTtEroare(''); return; }
    let activ = true;
    setTtIncarca(true); setTtEroare(''); setTtInfo(null);
    (async () => {
      const { data, error } = await supabase.functions.invoke('tiktok-creator-info', { body: { client_id: parseInt(clientId) } });
      if (!activ) return;
      if (error || data?.error) setTtEroare(data?.detail || data?.error || error?.message || 'eroare');
      else setTtInfo(data);
      setTtIncarca(false);
    })();
    return () => { activ = false; };
  }, [tiktokAles, clientId]);

  // Continutul de brand nu poate fi privat: daca se bifeaza, alegerea privata cade.
  useEffect(() => {
    if (ttBrandContent && ttPrivacy === 'SELF_ONLY') setTtPrivacy('');
  }, [ttBrandContent, ttPrivacy]);

  // Durata se citeste din metadatele previzualizarii. La link extern poate esua
  // (CORS); atunci ramane necunoscuta si nu blocam - TikTok va decide el.
  useEffect(() => {
    if (!video) { setVideoDurataSec(null); return; }
    let activ = true;
    const el = document.createElement('video');
    el.preload = 'metadata';
    el.onloadedmetadata = () => { if (activ) setVideoDurataSec(el.duration || null); };
    el.onerror = () => { if (activ) setVideoDurataSec(null); };
    el.src = video;
    return () => { activ = false; };
  }, [video]);

  // Story nu primeste text: nici Instagram, nici Facebook nu il afiseaza, iar
  // LIMITE_CARACTERE stia deja asta (limita 0). Deci textul e obligatoriu doar
  // daca macar o retea aleasa are un format care chiar accepta text.
  const cereText = reteleSelectate.some(retea => {
    const f = formate[retea] || FORMATE[retea][0];
    const limita = LIMITE_CARACTERE[retea] && LIMITE_CARACTERE[retea][f];
    return limita === undefined ? true : limita > 0;
  });
  const caruselActiv = reteleSelectate.includes('instagram') && (formate.instagram || FORMATE.instagram[0]) === 'Carusel';
  const caruselPreaPutine = caruselActiv && imaginiCarusel.length < 2;
  const caruselPreaMulte = caruselActiv && imaginiCarusel.length > 10;
  // Instagram nu accepta postari fara media, la niciun format. La carusel,
  // cerinta e acoperita de garzile de mai sus, pe lista de imagini.
  const instagramNecesitaMedia = reteleSelectate.includes('instagram') && !caruselActiv && !videoUrl && !imagineUrl;
  // Incarcarile se convertesc singure in JPEG, dar un link lipit direct nu trece
  // prin conversie, si nici pozele salvate in drafturi mai vechi. Extensie
  // nerecunoscuta = nu blocam, ca sa nu oprim din greseala un link valid.
  const instagramPozaNeacceptata = (() => {
    if (!reteleSelectate.includes('instagram') || caruselActiv || !imagineUrl || videoUrl) return false;
    let cale = imagineUrl.toLowerCase();
    try { cale = new URL(imagineUrl).pathname.toLowerCase(); } catch (e) { /* link fara schema */ }
    const gasit = cale.match(/\.(jpg|jpeg|png|gif|webp|bmp|tiff?|avif|heic)$/);
    return gasit ? gasit[1] !== 'jpg' && gasit[1] !== 'jpeg' : false;
  })();
  const tiktokNecesitaMedia = reteleSelectate.includes('tiktok') && !videoUrl && !imagineUrl;
  const tiktokFaraConfid = tiktokAles && !ttPrivacy;
  const tiktokVideoPreaLung = tiktokAles && !!ttInfo?.durata_maxima_sec && !!videoDurataSec && videoDurataSec > ttInfo.durata_maxima_sec;
  const poateTrimite = clientId && reteleSelectate.length > 0 && (!cereText || text.trim().length > 0) && !uploadingImagine && !uploadingVideo && !uploadingCarusel && !caruselPreaPutine && !caruselPreaMulte && !instagramNecesitaMedia && !instagramPozaNeacceptata && !tiktokNecesitaMedia && !tiktokFaraConfid && !tiktokVideoPreaLung;
  const poateGenera = clientId && reteleSelectate.length > 0 && areContext && !aiLoading;

  return (
    <div className="pagina">
      <div className="pagina-header">
        <div>
          <h1 className="pagina-titlu">{t('compositor', 'postareNoua')}</h1>
          <p className="pagina-subtitlu">{t('compositor', 'creeazaProgrameaza')}</p>
        </div>
        <div className="header-actiuni">
          {postareEdit ? (
            <button className="btn-principal" disabled={!poateTrimite || trimitere} onClick={salveazaEditare}>
              {trimitere ? t('compositor', 'seSalveaza') : t('compositor', 'salveazaModificarile')}
            </button>
          ) : (<>
          <button className="btn-secundar" disabled={!poateTrimite || trimitere} onClick={handleSalveazaDraft}>{t('compositor', 'salveazaDraft')}</button>
          {permisiuniClient?.poate_crea_postari ? (
            <button className="btn-principal" disabled={!poateTrimite || trimitere} onClick={handlePublica}>
              {trimitere ? t('compositor', 'sePublica') : (publicareImediata ? t('compositor', 'publica') : t('compositor', 'programeazaSimplu'))}
            </button>
          ) : profilUtilizator?.rol === 'super_admin' ? (
            <>
              <button className="btn-secundar" disabled={!poateTrimite || trimitere} onClick={handleTrimiteAprobare}>
                {trimitere ? t('compositor', 'seTrimite') : t('compositor', 'trimiteSpreAprobare')}
              </button>
              <button className="btn-principal" disabled={!poateTrimite || trimitere} onClick={handlePublica}>
                {trimitere ? t('compositor', 'sePublica') : (publicareImediata ? t('compositor', 'publica') : t('compositor', 'programeazaSimplu'))}
              </button>
            </>
          ) : (
            <button className="btn-principal" disabled={!poateTrimite || trimitere} onClick={handleTrimiteAprobare}>
              {trimitere ? t('compositor', 'seTrimite') : t('compositor', 'trimiteSpreAprobare')}
            </button>
          )}
          </>)}
        </div>
      </div>
      <div className="compositor-layout">
        <div className="compositor-editor">
          <div className="sectiune">
            <label className="label">{t('compositor', 'client')}</label>
            {ascundeSelectorClient ? (
              <div className="select-input" style={{ display: 'flex', alignItems: 'center', fontWeight: 600, color: '#0F3D22', background: '#F2F8F4', cursor: 'default' }}>
                {t('compositor', 'posteziCa')}{clientAles ? `${clientAles.nume}${clientAles.functie ? ' — ' + clientAles.functie : ''}` : '—'}
              </div>
            ) : (
              <select className="select-input" value={clientId} onChange={e => setClientId(e.target.value)}>
                <option value="">{t('compositor', 'selecteazaClientul')}</option>
                {clienti.filter(c => c.status === 'activ').map(c =>
                  <option key={c.id} value={c.id}>{c.nume} — {c.functie}</option>
                )}
              </select>
            )}
            {clientAles && profilUtilizator?.rol !== 'client' && (
              <div className="client-ales-info">
                {areProfilImagologic
                  ? <span className="profil-ok">{t('compositor', 'profilIncarcat')}</span>
                  : <span className="profil-lipsa">{t('compositor', 'profilLipsa')}</span>}
              </div>
            )}
          </div>
          <div className="sectiune">
            <label className="label">{t('compositor', 'reteleSociale')}</label>
            <div className="retele-selectie">
              {RETELE.map(r => {
                const dezactivat = r.id === 'tiktok' && !tiktokConectat;
                return (
                  <button key={r.id} className={`btn-retea ${reteleSelectate.includes(r.id) ? 'selectat' : ''}`}
                    style={reteleSelectate.includes(r.id) ? { borderColor: r.culoare, background: r.bg, color: r.culoare } : (dezactivat ? { opacity: 0.45, cursor: 'not-allowed' } : {})}
                    disabled={dezactivat}
                    title={dezactivat ? t('compositor', 'tiktokNeconectat') : ''}
                    onClick={() => toggleRetea(r.id)}>
                    <IconRetea id={r.id} size={15} /> {r.label}{dezactivat ? ` (${t('compositor', 'neconectat')})` : ''}
                  </button>
                );
              })}
            </div>
            {reteleSelectate.length > 0 && (
              <div className="formate-container">
                {reteleSelectate.map(r => {
                  const retea = RETELE.find(x => x.id === r);
                  return (
                    <div key={r} className="format-row">
                      <div className="format-retea-label"><IconRetea id={r} size={13} /><span>{retea?.label}</span></div>
                      <div className="format-optiuni">
                        {FORMATE[r].map(fmt => (
                          <button key={fmt} className={`btn-format ${(formate[r] || FORMATE[r][0]) === fmt ? 'selectat' : ''}`}
                            style={(formate[r] || FORMATE[r][0]) === fmt ? { borderColor: retea?.culoare, background: retea?.bg, color: retea?.culoare } : {}}
                            onClick={() => setFormat(r, fmt)}>{fmt}</button>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          <div className="sectiune">
            <label className="label">{t('compositor', 'temaPostarii')}</label>
            <input className="select-input" placeholder={t('compositor', 'temaPlaceholder')} value={tema} onChange={e => setTema(e.target.value)} style={{ marginBottom: 12 }} />
            <label className="label">{t('compositor', 'contextSuplimentar')}</label>
            <textarea className="textarea" placeholder={t('compositor', 'contextPlaceholder')} value={context} onChange={e => setContext(e.target.value)} rows={4} />
            {contextFisiere.length > 0 && (
              <div className="context-fisiere">
                {contextFisiere.map((f, i) => (
                  <div key={i} className="context-fisier-chip">
                    {f.tip === 'imagine' && f.url ? <img src={f.url} alt={f.nume} className="context-fisier-preview" /> : <span className="context-fisier-icon">📄</span>}
                    <span className="context-fisier-nume">{f.nume}</span>
                    <button className="context-fisier-sterge" onClick={() => stergeContextFisier(i)}>✕</button>
                  </div>
                ))}
              </div>
            )}
            <div className="context-upload-bar">
              <label className="btn-context-upload"><input type="file" accept="image/*,.pdf,.doc,.docx" multiple onChange={handleContextFisier} style={{ display: 'none' }} />{t('compositor', 'adaugaPoze')}</label>
              <label className="btn-context-upload"><input type="file" accept=".pdf,.doc,.docx,.txt" multiple onChange={handleContextFisier} style={{ display: 'none' }} />{t('compositor', 'adaugaDocumente')}</label>
              <span className="context-upload-hint">{t('compositor', 'hintDocumente')}</span>
            </div>
          </div>
          <div className="sectiune">
            <div className="ai-bar">
              <button className={`btn-ai ${aiLoading ? 'loading' : ''}`} disabled={!poateGenera} onClick={handleGenereazaAI} style={{ minWidth: 180 }}>
                {aiLoading ? t('compositor', 'genereaza') : t('compositor', 'genereazaCuAI')}
              </button>
              <span className="ai-hint">
                {!clientId ? t('compositor', 'hintSelecteazaClient')
                  : reteleSelectate.length === 0 ? t('compositor', 'hintSelecteazaRetea')
                  : !areContext ? t('compositor', 'hintAdaugaTema')
                  : aiLoading ? t('compositor', 'hintSeGenereaza', { n: reteleSelectate.length })
                  : areRezultateAI ? t('compositor', 'hintContinutGenerat')
                  : t('compositor', 'hintGataDeGenerat')}
              </span>
            </div>
            {areRezultateAI && (
              <div className="ai-rezultate">
                <div className="ai-tabs">
                  {reteleSelectate.map(r => {
                    const retea = RETELE.find(x => x.id === r);
                    const rez = aiRezultate[r];
                    return (
                      <button key={r} className={`ai-tab ${aiTabActiv === r ? 'activ' : ''} ${rez?.eroare ? 'eroare' : ''}`}
                        style={aiTabActiv === r ? { borderColor: retea?.culoare, background: retea?.bg, color: retea?.culoare } : {}}
                        onClick={() => setAiTabActiv(r)}>
                        <IconRetea id={r} size={12} /> {retea?.label}
                        {rez?.eroare && ' ⚠️'}
                      </button>
                    );
                  })}
                </div>
                {aiTabActiv && aiRezultate[aiTabActiv] && (
                  <div className="ai-rezultat-continut">
                    {aiRezultate[aiTabActiv].eroare ? (
                      <div className="ai-eroare">{t('compositor', 'eroareAI')}{aiRezultate[aiTabActiv].eroare}</div>
                    ) : (
                      <>
                        <RezultatAIFormatat retea={aiTabActiv} text={aiRezultate[aiTabActiv].text} />
                        <div className="ai-rezultat-actiuni">
                          <button className="btn-principal" style={{ fontSize: 13, padding: '8px 16px' }} onClick={() => folosestTextulAI(aiTabActiv)}>{t('compositor', 'folosesteAcestText')}</button>
                          <button className="btn-secundar" style={{ fontSize: 13, padding: '8px 16px' }} onClick={handleGenereazaAI} disabled={aiLoading}>{t('compositor', 'regenereaza')}</button>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="sectiune">
  <label className="label">{t('compositor', 'textPostare')}</label>
  <TextToolbar
    textareaRef={textareaPostareRef}
    value={text}
    onChange={setText}
  />
  <textarea
    ref={textareaPostareRef}
    className={`textarea ${depasitLimita ? 'textarea-eroare' : ''}`}
    placeholder={t('compositor', 'editeazaText')}
    value={text}
    onChange={e => setText(e.target.value)}
    rows={7}
  />
  <div className="contor-caractere">
    <span style={{ color: depasitLimita ? '#EF4444' : '#9CA3AF' }}>
      {text.length}{limitaCaractere ? ` / ${limitaCaractere}` : ''} {t('compositor', 'contorCaractere')}
    </span>
    {depasitLimita && <span className="contor-depasit">{t('compositor', 'textPreaLung')}</span>}
  </div>
</div>
          <div className="sectiune">
            <label className="label">{t('compositor', 'hashtaguri')}</label>
            <textarea className="textarea" placeholder={t('compositor', 'hashtagPlaceholder')} value={hashtags} onChange={e => setHashtags(e.target.value)} rows={2} />
          </div>
          <div className="sectiune">
            <label className="label">{t('compositor', 'mediaPostare')}</label>
            {caruselActiv ? (
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: '#0F3D22' }}>{t('compositor', 'caruselTitlu')}</span>
                  <span style={{ fontSize: 12, color: imaginiCarusel.length > 10 ? '#B91C1C' : '#9CA3AF' }}>
                    {t('compositor', 'caruselNumar', { n: imaginiCarusel.length })}
                  </span>
                </div>
                {imaginiCarusel.length > 0 && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
                    {imaginiCarusel.map((im, idx) => (
                      <div key={im.url} style={{ position: 'relative', width: 84, height: 84 }}>
                        <img src={im.url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8, border: '1.5px solid #D1E8DA' }} />
                        <span style={{ position: 'absolute', bottom: 3, left: 3, background: 'rgba(15,61,34,0.75)', color: 'white', fontSize: 10, borderRadius: 4, padding: '1px 5px' }}>{idx + 1}</span>
                        <button
                          type="button"
                          title={t('compositor', 'caruselSterge')}
                          onClick={() => stergeImagineCarusel(idx)}
                          style={{ position: 'absolute', top: -6, right: -6, width: 20, height: 20, borderRadius: '50%', border: 'none', background: '#B91C1C', color: 'white', fontSize: 12, lineHeight: '20px', cursor: 'pointer', padding: 0 }}
                        >×</button>
                      </div>
                    ))}
                  </div>
                )}
                <label className="upload-zona" style={{ padding: 18 }}>
                  <input type="file" accept="image/*" multiple onChange={handleFisiereCarusel} style={{ display: 'none' }} />
                  <div className="upload-continut"><div className="upload-icon">🖼️</div><div className="upload-text">{t('compositor', 'caruselAdauga')}</div><div className="upload-hint">{t('compositor', 'caruselHint')}</div></div>
                </label>
              </div>
            ) : (
              <label className="upload-zona">
                <input type="file" accept="image/*,video/*" onChange={handleFisierMedia} style={{ display: 'none' }} />
                <div className="upload-continut"><div className="upload-icon">📎</div><div className="upload-text">{t('compositor', 'incarcaImagineVideo')}</div><div className="upload-hint">{t('compositor', 'formatMedia')}</div></div>
              </label>
            )}
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 10 }}>
              <input
                className="input"
                style={{ flex: 1, fontSize: 13 }}
                placeholder={t('compositor', 'sauLipesteLink')}
                value={linkMedia}
                onChange={e => setLinkMedia(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); aplicaLinkMedia(); } }}
              />
              <button className="btn-secundar" style={{ fontSize: 13, padding: '8px 14px' }} disabled={!linkMedia.trim()} onClick={aplicaLinkMedia}>
                {t('compositor', 'folosesteLink')}
              </button>
            </div>
            {(uploadingImagine || uploadingVideo || uploadingCarusel) && <div className="eroare-video" style={{ background: '#FEF3C7', color: '#92400E' }}>⏳ {t('compositor', 'seIncarcaMedia')}</div>}
            {/* Legat de existenta imaginii, nu doar de steag: imaginea se goleste
                din patru locuri diferite, iar un steag pe care trebuie sa-l stingi
                manual in fiecare dintre ele ramane, mai devreme sau mai tarziu, aprins
                pe un ecran gol. */}
            {imagineConvertita && imagine && <div className="eroare-video" style={{ background: '#EFF6FF', color: '#1E40AF' }}>ℹ️ {t('compositor', 'imagineConvertita')}</div>}
            {eroareVideo && <div className="eroare-video">⚠️ {eroareVideo}</div>}
          </div>
          {tiktokAles && (
            <div className="sectiune">
              <label className="label">{t('tiktok', 'panouTitlu')}</label>

              {ttIncarca && <div style={{ fontSize: 13, color: '#9CA3AF' }}>{t('tiktok', 'seIncarcaCont')}</div>}

              {!ttIncarca && ttEroare && (
                <div className="eroare-video">⚠️ {t('tiktok', 'eroareCont')} {ttEroare}</div>
              )}

              {!ttIncarca && ttInfo && (
                <div style={{ background: 'white', border: '1.5px solid #D1E8DA', borderRadius: 12, padding: 16 }}>

                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                    {ttInfo.avatar && <img src={ttInfo.avatar} alt="" style={{ width: 36, height: 36, borderRadius: '50%' }} />}
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: '#0F3D22' }}>{ttInfo.nume}</div>
                      {ttInfo.utilizator && <div style={{ fontSize: 12, color: '#9CA3AF' }}>@{ttInfo.utilizator}</div>}
                    </div>
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#0F3D22', marginBottom: 6 }}>{t('tiktok', 'confidentialitate')}</div>
                    <div style={{ position: 'relative' }}>
                      <button
                        type="button"
                        onClick={() => setTtListaDeschisa(v => !v)}
                        style={{ width: '100%', textAlign: 'left', padding: '10px 14px', borderRadius: 10, border: '1.5px solid #D1E8DA', background: 'white', fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: ttPrivacy ? '#0F3D22' : '#9CA3AF', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                      >
                        <span>{ttPrivacy ? etichetaConfid(ttPrivacy) : t('tiktok', 'alege')}</span>
                        <span style={{ fontSize: 11, color: '#9CA3AF' }}>{ttListaDeschisa ? '▲' : '▼'}</span>
                      </button>
                      {ttListaDeschisa && (
                        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 4, background: 'white', border: '1.5px solid #D1E8DA', borderRadius: 10, boxShadow: '0 6px 20px rgba(26,107,60,0.12)', zIndex: 20, overflow: 'hidden' }}>
                          {(ttInfo.optiuni_confidentialitate || []).map(o => {
                            const blocat = o === 'SELF_ONLY' && ttComercial && ttBrandContent;
                            return (
                              <button
                                key={o}
                                type="button"
                                disabled={blocat}
                                onClick={() => { setTtPrivacy(o); setTtListaDeschisa(false); }}
                                style={{ display: 'block', width: '100%', textAlign: 'left', padding: '10px 14px', border: 'none', background: ttPrivacy === o ? '#F9FCF9' : 'white', fontSize: 14, fontFamily: "'DM Sans', sans-serif", color: blocat ? '#C7CDD4' : '#1F2937', cursor: blocat ? 'not-allowed' : 'pointer' }}
                              >
                                {etichetaConfid(o)}
                                {blocat && <span style={{ fontSize: 11, marginLeft: 8 }}>({t('tiktok', 'brandNuPrivat')})</span>}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>
                    {ttComercial && ttBrandContent && (
                      <div style={{ fontSize: 12, color: '#92400E', marginTop: 6 }}>{t('tiktok', 'brandNuPrivat')}</div>
                    )}
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#0F3D22', marginBottom: 6 }}>{t('tiktok', 'interactiuni')}</div>
                    {[
                      { cheie: 'permiteComentarii', val: ttComentarii, set: setTtComentarii, oprit: ttInfo.comentarii_oprite },
                      { cheie: 'permiteDuet', val: ttDuet, set: setTtDuet, oprit: ttInfo.duet_oprit },
                      { cheie: 'permiteStitch', val: ttStitch, set: setTtStitch, oprit: ttInfo.stitch_oprit },
                    ].map(x => (
                      <label key={x.cheie} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, fontSize: 13, color: x.oprit ? '#9CA3AF' : '#1F2937', cursor: x.oprit ? 'not-allowed' : 'pointer' }}>
                        <input type="checkbox" checked={x.val && !x.oprit} disabled={x.oprit} onChange={e => x.set(e.target.checked)} />
                        {t('tiktok', x.cheie)}
                        {x.oprit && <span style={{ fontSize: 11 }}>({t('tiktok', 'opritDinCont')})</span>}
                      </label>
                    ))}
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontWeight: 600, color: '#0F3D22', cursor: 'pointer' }}>
                      <input type="checkbox" checked={ttComercial} onChange={e => setTtComercial(e.target.checked)} />
                      {t('tiktok', 'comercial')}
                    </label>
                    <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 4 }}>{t('tiktok', 'comercialExplic')}</div>
                    {ttComercial && (
                      <div style={{ marginTop: 8, paddingLeft: 22 }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4, fontSize: 13, cursor: 'pointer' }}>
                          <input type="checkbox" checked={ttBrandPropriu} onChange={e => setTtBrandPropriu(e.target.checked)} />
                          {t('tiktok', 'brandPropriu')}
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer' }}>
                          <input type="checkbox" checked={ttBrandContent} onChange={e => setTtBrandContent(e.target.checked)} />
                          {t('tiktok', 'brandContent')}
                        </label>
                      </div>
                    )}
                  </div>

                  <div style={{ fontSize: 11, color: '#6B7280', lineHeight: 1.5, borderTop: '1px solid #E8F5EE', paddingTop: 12 }}>
                    {ttComercial && ttBrandContent
                      ? "By posting, you agree to TikTok's Branded Content Policy and Music Usage Confirmation."
                      : "By posting, you agree to TikTok's Music Usage Confirmation."}
                    <div style={{ marginTop: 6, color: '#9CA3AF' }}>{t('tiktok', 'procesare')}</div>
                  </div>

                </div>
              )}
            </div>
          )}
          {/* Campurile de link apar doar cand LinkedIn e bifat: e singura retea de
              la noi care cere previzualizarea construita de noi. Titlul si
              descrierea se arata abia dupa ce exista o adresa, ca sa nu incarce
              ecranul degeaba. */}
          {reteleSelectate.includes('linkedin') && (
            <div className="sectiune">
              <label className="label">{t('compositor', 'linkSectiune')}</label>
              <input
                className="input"
                type="url"
                placeholder={t('compositor', 'linkUrlPlaceholder')}
                value={linkUrl}
                onChange={e => setLinkUrl(e.target.value)}
              />
              {linkUrl.trim() && (
                <>
                  <input
                    className="input"
                    style={{ marginTop: 8 }}
                    placeholder={t('compositor', 'linkTitluPlaceholder')}
                    value={linkTitlu}
                    onChange={e => setLinkTitlu(e.target.value)}
                  />
                  <textarea
                    className="textarea"
                    style={{ marginTop: 8 }}
                    placeholder={t('compositor', 'linkDescrierePlaceholder')}
                    value={linkDescriere}
                    onChange={e => setLinkDescriere(e.target.value)}
                    rows={2}
                  />
                  <div style={{ marginTop: 6, fontSize: 12, color: '#9CA3AF' }}>
                    {t('compositor', 'linkAjutor')}
                  </div>
                </>
              )}
            </div>
          )}
          <div className="sectiune">
            <label className="label">{t('compositor', 'programare')}</label>
            <div className="programare-optiuni">
              <button className={`btn-programare ${publicareImediata ? 'selectat' : ''}`} onClick={() => setPublicareImediata(true)}>{t('compositor', 'publicaImediat')}</button>
              <button className={`btn-programare ${!publicareImediata ? 'selectat' : ''}`} onClick={() => setPublicareImediata(false)}>{t('compositor', 'programeaza')}</button>
            </div>
            {!publicareImediata && (
              <div className="programare-data-wrapper">
                <div className="programare-data">
                  <input type="date" className="input-data" min={azi} value={dataProgramata} onChange={e => setDataProgramata(e.target.value)} />
                  <OraMinut className="input-data" value={oraProgramata} onChange={setOraProgramata} />
                </div>
                {oreRecomandate.length > 0 && (
                  <div className="ore-recomandate">
                    <span className="ore-recomandate-label">{t('compositor', 'oreRecomandate')}</span>
                    <div className="ore-chips">
                      {oreRecomandate.map(ora => (
                        <button key={ora} className={`ora-chip ${oraProgramata === ora ? 'selectat' : ''}`} onClick={() => setOraProgramata(ora)}>{ora}</button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          {!poateTrimite && (
            <div style={{ fontSize: 13, color: '#6B7280', marginBottom: 10, padding: '0 4px' }}>
              {t('compositor', 'maiTrebuie')} {[
                !clientId && t('compositor', 'unClient'),
                reteleSelectate.length === 0 && t('compositor', 'oRetea'),
                cereText && text.trim().length === 0 && t('compositor', 'textulPostarii'),
                caruselPreaPutine && t('compositor', 'caruselPreaPutine'),
                caruselPreaMulte && t('compositor', 'caruselPreaMulte'),
                instagramNecesitaMedia && t('compositor', 'mediaPentruInstagram'),
                instagramPozaNeacceptata && t('compositor', 'pozaJpegInstagram'),
                tiktokNecesitaMedia && t('compositor', 'mediaPentruTikTok'),
                tiktokFaraConfid && t('tiktok', 'alegeConfid'),
                tiktokVideoPreaLung && t('tiktok', 'videoPreaLung', { max: Math.round(ttInfo.durata_maxima_sec / 60), are: Math.ceil(videoDurataSec / 60) }),
              ].filter(Boolean).join(', ')}
            </div>
          )}
          <div className="compositor-footer">
            {postareEdit ? (
              <button className="btn-principal btn-trimite-mare" disabled={!poateTrimite || trimitere} onClick={salveazaEditare}>
                {trimitere ? t('compositor', 'seSalveaza') : t('compositor', 'salveazaModificarile')}
              </button>
            ) : (<>
            <button className="btn-secundar" disabled={!poateTrimite || trimitere} onClick={handleSalveazaDraft}>{t('compositor', 'salveazaDraft')}</button>
            {permisiuniClient?.poate_crea_postari ? (
              <button className="btn-principal btn-trimite-mare" disabled={!poateTrimite || trimitere} onClick={handlePublica}>
                {trimitere ? t('compositor', 'sePublica') : (publicareImediata ? t('compositor', 'publicaSageata') : t('compositor', 'programeazaSageata'))}
              </button>
            ) : profilUtilizator?.rol === 'super_admin' ? (
              <>
                <button className="btn-secundar" disabled={!poateTrimite || trimitere} onClick={handleTrimiteAprobare}>
                  {trimitere ? t('compositor', 'seTrimite') : t('compositor', 'trimiteSpreAprobare')}
                </button>
                <button className="btn-principal btn-trimite-mare" disabled={!poateTrimite || trimitere} onClick={handlePublica}>
                  {trimitere ? t('compositor', 'sePublica') : (publicareImediata ? t('compositor', 'publicaSageata') : t('compositor', 'programeazaSageata'))}
                </button>
              </>
            ) : (
              <button className="btn-principal btn-trimite-mare" disabled={!poateTrimite || trimitere} onClick={handleTrimiteAprobare}>
                {trimitere ? t('compositor', 'seTrimite') : t('compositor', 'trimiteSpreAprobareSageata')}
              </button>
            )}
            </>)}
          </div>
        </div>
        {(imagine || video) && reteleSelectate.length > 0 && (
          <div className="compositor-preview">
            <label className="label">{t('compositor', 'previzualizarePerRetea')}</label>
            <div className="preview-tabs">
              {reteleSelectate.map(r => {
                const retea = RETELE.find(x => x.id === r);
                return (
                  <button key={r} className={`preview-tab ${cropActiv === r ? 'activ' : ''}`}
                    style={cropActiv === r ? { borderColor: retea?.culoare, background: retea?.bg, color: retea?.culoare } : {}}
                    onClick={() => setCropActiv(r)}>
                    <IconRetea id={r} size={12} /> {retea?.label}
                  </button>
                );
              })}
            </div>
            {cropActiv && (
              <div className="preview-imagine-container">
                <div className="preview-format-label">{formate[cropActiv] || FORMATE[cropActiv]?.[0]}</div>
                <div className="preview-imagine" style={{ paddingBottom: `${PREVIEW_RATIO[cropActiv]?.[formate[cropActiv] || FORMATE[cropActiv]?.[0]] || 56.25}%` }}>
                  {imagine ? (
                    <img src={imagine} alt="preview" className="preview-img" />
                  ) : (
                    <video src={video} controls className="preview-img" />
                  )}
                </div>
                <div className="preview-dimensiune">{PREVIEW_LABEL[cropActiv]?.[formate[cropActiv] || FORMATE[cropActiv]?.[0]] || '—'} px</div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function RezultatAIFormatat({ retea, text }) {
  const parsed = parseazaRezultat(retea, text);
  if (parsed.tip === 'thread') {
    return (
      <div className="ai-rezultat-text">
        {parsed.tweets.map((tweet, i) => (
          <div key={i} className="ai-tweet"><span className="ai-tweet-nr">{i + 1}</span><span>{tweet}</span></div>
        ))}
      </div>
    );
  }
  if (parsed.tip === 'instagram') {
    return (
      <div className="ai-rezultat-text">
        <div style={{ marginBottom: 12 }}>{parsed.textPostare}</div>
        {parsed.carouselTitles && (
          <div className="ai-sectiune-extra">
            <div className="ai-sectiune-label">{t('compositor', 'titluriCarousel')}</div>
            <div style={{ whiteSpace: 'pre-line', fontSize: 13, color: '#6B7280' }}>{parsed.carouselTitles}</div>
          </div>
        )}
      </div>
    );
  }
  if (parsed.tip === 'video') {
    return (
      <div className="ai-rezultat-text">
        <div className="ai-sectiune-label">{t('compositor', 'script')}</div>
        <div style={{ marginBottom: 12 }}>{parsed.script}</div>
        {parsed.overlay && <div className="ai-sectiune-extra"><div className="ai-sectiune-label">{t('compositor', 'overlayTitlu')}</div><div style={{ fontSize: 13, color: '#6B7280' }}>{parsed.overlay}</div></div>}
        {parsed.caption && <div className="ai-sectiune-extra"><div className="ai-sectiune-label">{t('compositor', 'caption')}</div><div style={{ fontSize: 13, color: '#6B7280' }}>{parsed.caption}</div></div>}
      </div>
    );
  }
  return <div className="ai-rezultat-text" style={{ whiteSpace: 'pre-line' }}>{parsed.continut || text}</div>;
}

const TIP_ANALIZE = { photo: 'tipPhoto', album: 'tipPhoto', video: 'tipVideo', link: 'tipLink', reel: 'tipReel', text: 'tipText' };

function Analize({ clienti }) {
  const [filtruClient, setFiltruClient] = useState('toti');
  const [perioada, setPerioada] = useState('30');
  const [incarca, setIncarca] = useState(false);
  const [eroare, setEroare] = useState('');
  const [rezultat, setRezultat] = useState(null);
  const [metricaGrafic, setMetricaGrafic] = useState(null);

  const idClienti = clienti.map(c => c.id).join(',');

  useEffect(() => {
    let anulat = false;
    (async () => {
      const tinte = filtruClient === 'toti' ? clienti : clienti.filter(c => String(c.id) === String(filtruClient));
      setIncarca(true); setEroare(''); setRezultat(null);
      try {
        // Fiecare client are pana la doua surse: Pagina de Facebook si contul de
        // Instagram. Le cerem in paralel si le punem in acelasi tabel — nu are sens
        // sa te uiti separat la performanta aceluiasi mesaj pe doua retele.
        const raspunsuri = await Promise.all(tinte.map(async c => {
          const [fb, ig] = await Promise.all([
            supabase.functions.invoke('facebook-page-insights', { body: { client_id: c.id, zile: Number(perioada) } }),
            supabase.functions.invoke('instagram-insights', { body: { client_id: c.id, zile: Number(perioada) } }),
          ]);
          const problema = sursa => sursa.error ? sursa.error.message : (sursa.data?.error || null);
          const randuri = sursa => (sursa.data?.postari || []).map(p => ({ ...p, client_nume: c.nume }));
          const pFb = problema(fb);
          const pIg = problema(ig);
          return {
            client: c,
            // Un client poate avea Facebook fara Instagram, sau invers. Lipsa uneia
            // nu goleste pagina, doar scoate randurile ei.
            postari: [
              ...(pFb ? [] : randuri(fb).map(p => ({ ...p, retea: p.retea || 'facebook' }))),
              ...(pIg ? [] : randuri(ig)),
            ],
            // 'fara_token' nu e o defectiune, e un client care n-are reteaua conectata.
            // Raportam problema doar daca AMBELE lipsesc, altfel ar aparea o eroare
            // pentru fiecare client care are doar una dintre retele.
            problema: (pFb && pIg && pFb === 'fara_token' && pIg === 'fara_token')
              ? 'fara_token'
              : ([pFb, pIg].filter(x => x && x !== 'fara_token')[0] || null),
            avertismentReels: fb.data?.avertisment_reels || null,
            avertismentInsights: ig.data?.avertisment_insights || null,
            avertismentMeta: [fb.data?.avertisment_pagina, ig.data?.avertisment_cont].filter(Boolean).join(' \u00b7 ') || null,
            urmaritoriFb: pFb ? null : (fb.data?.urmaritori ?? null),
            urmaritoriIg: pIg ? null : (ig.data?.urmaritori ?? null),
            // Vizualizarile (15 oct 2026, metricile „media view” ale Meta) intra langa cifrele paginii.
            totalFb: pFb ? null : (fb.data?.total_pagina || fb.data?.vizualizari ? { ...(fb.data?.total_pagina || {}), ...(fb.data?.vizualizari || {}) } : null),
            anteriorFb: pFb ? null : (fb.data?.anterior_pagina ?? null),
            serieFb: pFb ? [] : (fb.data?.serie ?? []),
            totalIg: pIg ? null : (ig.data?.total_cont ?? null),
            anteriorIg: pIg ? null : (ig.data?.anterior_cont ?? null),
            serieIg: pIg ? [] : (ig.data?.serie ?? []),
          };
        }));
        if (anulat) return;
        const postari = raspunsuri.flatMap(r => r.postari || []);
        const total = postari.reduce((a, p) => ({
          reactii: a.reactii + p.reactii, comentarii: a.comentarii + p.comentarii,
          distribuiri: a.distribuiri + p.distribuiri, engagement: a.engagement + p.engagement,
        }), { reactii: 0, comentarii: 0, distribuiri: 0, engagement: 0 });
        const medie = postari.length ? total.engagement / postari.length : 0;
        postari.sort((a, b) => b.engagement - a.engagement);
        const totiUrmaritorii = raspunsuri
          .flatMap(r => [r.urmaritoriFb, r.urmaritoriIg])
          .filter(v => typeof v === 'number');
        // Defalcarea pe retea: doar retelele care chiar au ceva. O retea
        // neconectata nu apare deloc, in loc sa apara cu zerouri.
        const urmaritoriPeRetea = {
          facebook: raspunsuri.map(r => r.urmaritoriFb).filter(v => typeof v === 'number'),
          instagram: raspunsuri.map(r => r.urmaritoriIg).filter(v => typeof v === 'number'),
        };
        const peRetea = {};
        for (const r of RETELE) {
          const ale = postari.filter(p => (p.retea || 'facebook') === r.id);
          const urm = urmaritoriPeRetea[r.id];
          if (!ale.length && !(urm && urm.length)) continue;
          peRetea[r.id] = {
            postari: ale.length,
            reactii: ale.reduce((a, p) => a + (p.reactii || 0), 0),
            comentarii: ale.reduce((a, p) => a + (p.comentarii || 0), 0),
            distribuiri: ale.reduce((a, p) => a + (p.distribuiri || 0), 0),
            engagement: ale.reduce((a, p) => a + (p.engagement || 0), 0),
            urmaritori: urm && urm.length ? urm.reduce((a, v) => a + v, 0) : null,
          };
        }
        // Cifrele de la Meta se aduna intre clienti, ca si postarile. Seriile pe
        // zile se aduna PE ZI: doi clienti au aceleasi zile, nu zile diferite.
        const adunaCampuri = (chei, camp) => {
          const bune = raspunsuri.map(r => r[camp]).filter(Boolean);
          if (!bune.length) return null;
          const rez = {};
          for (const k of chei) {
            const val = bune.map(b => b[k]).filter(v => typeof v === 'number');
            rez[k] = val.length ? val.reduce((a, v) => a + v, 0) : null;
          }
          return rez;
        };
        const adunaSerie = (camp, chei) => {
          const peZi = new Map();
          for (const r of raspunsuri) {
            for (const punct of (r[camp] || [])) {
              const existent = peZi.get(punct.zi) || {};
              for (const k of chei) existent[k] = (existent[k] || 0) + (punct[k] || 0);
              peZi.set(punct.zi, existent);
            }
          }
          return Array.from(peZi.entries()).sort((a, b) => a[0] < b[0] ? -1 : 1)
            .map(([zi, v]) => ({ zi, ...v }));
        };

        const cheiFb = ['engagement', 'vizite', 'vizualizari', 'vizionari_video'];
        const cheiIg = ['acoperire', 'conturi_implicate', 'interactiuni', 'urmariri_nete'];

        setRezultat({
          peRetea,
          metaFb: adunaCampuri(cheiFb, 'totalFb'),
          metaFbAnterior: adunaCampuri(cheiFb, 'anteriorFb'),
          serieFb: adunaSerie('serieFb', cheiFb),
          metaIg: adunaCampuri(cheiIg, 'totalIg'),
          metaIgAnterior: adunaCampuri(cheiIg, 'anteriorIg'),
          serieIg: adunaSerie('serieIg', ['acoperire']),
          urmaritori: totiUrmaritorii.length ? totiUrmaritorii.reduce((a, v) => a + v, 0) : null,
          postari: postari.map(p => ({ ...p, peste_medie: p.engagement > medie, la_medie: p.engagement === medie })),
          total, medie,
          faraPagina: raspunsuri.filter(r => r.problema === 'fara_token').map(r => r.client.nume),
          probleme: raspunsuri.filter(r => r.problema && r.problema !== 'fara_token'),
          avertismenteReels: raspunsuri.filter(r => r.avertismentReels),
          avertismenteInsights: raspunsuri.filter(r => r.avertismentInsights),
          avertismenteMeta: raspunsuri.filter(r => r.avertismentMeta),
        });
      } catch (e) {
        if (!anulat) setEroare(String(e.message || e));
      } finally {
        if (!anulat) setIncarca(false);
      }
    })();
    return () => { anulat = true; };
  }, [filtruClient, perioada, idClienti]); // eslint-disable-line react-hooks/exhaustive-deps

  // Cu o singura postare nu exista termen de comparatie: media e chiar ea.
  const comparabil = !!rezultat && rezultat.postari.length > 1;

  const cifra = (v, eticheta, accent) => (
    <div style={{ minWidth: 120 }}>
      <div style={{ fontSize: 26, fontWeight: 700, color: accent ? '#1A6B3C' : '#0F3D22' }}>{v}</div>
      <div style={{ fontSize: 12, color: '#6B7280' }}>{eticheta}</div>
    </div>
  );

  return (
    <div className="pagina">
      <div className="pagina-header">
        <div><h1 className="pagina-titlu">{t('analize', 'analize')}</h1><p className="pagina-subtitlu">{t('analize', 'performantaConturilor')}</p></div>
        <div className="header-actiuni">
          {clienti.length > 1 && (<select className="select-filtru" value={filtruClient} onChange={e => setFiltruClient(e.target.value)}><option value="toti">{t('analize', 'totiClientii')}</option>{clienti.map(c => <option key={c.id} value={c.id}>{c.nume}</option>)}</select>)}
          <div className="vedere-tabs">{/* Fara 90 de zile: Instagram refuza cifrele de cont pe perioade mai lungi
              de 30, deci la 90 jumatate din pagina ramanea goala cu un avertisment. */}
          {['7', '30'].map(z => <button key={z} className={`vedere-tab ${perioada === z ? 'activ' : ''}`} onClick={() => setPerioada(z)}>{z} {t('analize', 'zile')}</button>)}</div>
        </div>
      </div>

      {incarca && <div className="pagina-gol" style={{ marginTop: 60 }}><div className="pagina-gol-icon">📊</div><p style={{ fontSize: 14, color: '#6B7280' }}>{t('analize', 'seIncarca')}</p></div>}

      {!incarca && eroare && (
        <div className="pagina-gol" style={{ marginTop: 60 }}>
          <div className="pagina-gol-icon">⚠️</div>
          <p style={{ fontSize: 15, fontWeight: 600, color: '#B91C1C', marginBottom: 6 }}>{t('analize', 'eroareStatistici')}</p>
          <p style={{ fontSize: 12, color: '#6B7280', maxWidth: 460, textAlign: 'center' }}>{eroare}</p>
        </div>
      )}

      {!incarca && !eroare && rezultat && (
        <>
          <div style={{ background: 'white', border: '1.5px solid #D1E8DA', borderRadius: 14, padding: '20px 24px', marginBottom: 8 }}>
            {/* Fara titlu, cartonul de sus arata la fel cu cele pe retea si nu se
                intelege ca le aduna. */}
            <div style={{ fontSize: 13, fontWeight: 600, color: '#0F3D22', marginBottom: 14 }}>{t('analize', 'totalToate')}</div>
            <div style={{ display: 'flex', gap: 28, flexWrap: 'wrap' }}>
            {rezultat.urmaritori !== null && cifra(rezultat.urmaritori, t('analize', 'urmaritori'), true)}
            {cifra(rezultat.postari.length, t('analize', 'postari'))}
            {cifra(rezultat.total.engagement, t('analize', 'engagementTotal'), true)}
            {cifra(Math.round(rezultat.medie * 10) / 10, t('analize', 'mediePePostare'), true)}
            </div>
          </div>
          {/* Totalul de sus aduna retelele, ceea ce nu-ti spune CARE merge. Aici
              se despart: aceleasi cifre, o coloana de fiecare retea conectata.
              E lucrul pe care Meta nu ti-l da — acolo te uiti la o retea o data. */}
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
            {RETELE.filter(r => rezultat.peRetea[r.id]).map(r => {
              const d = rezultat.peRetea[r.id];
              return (
                <div key={r.id} style={{ flex: '1 1 220px', background: 'white', border: `1.5px solid ${r.bg}`, borderLeft: `4px solid ${r.culoare}`, borderRadius: 12, padding: '12px 16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
                    <IconRetea id={r.id} size={13} />
                    <span style={{ fontSize: 13, fontWeight: 600, color: r.culoare }}>{r.label}</span>
                  </div>
                  {d.urmaritori !== null && (
                    <div style={{ marginBottom: 10 }}>
                      <div style={{ fontSize: 17, fontWeight: 700, color: '#0F3D22' }}>{d.urmaritori}</div>
                      <div style={{ fontSize: 11, color: '#6B7280' }}>{t('analize', 'urmaritori')}</div>
                    </div>
                  )}
                  {/* Doua grupuri de cifre cu nume care semanau: unul numarat de
                      noi din postarile trimise din aplicatie, altul calculat de
                      Meta pentru toata Pagina. Sunt lucruri diferite, deci fiecare
                      isi spune provenienta. */}
                  <div style={{ fontSize: 11, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 4 }}>
                    {t('analize', 'dinAplicatie')}
                  </div>
                  <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
                    <div>
                      <div style={{ fontSize: 17, fontWeight: 700, color: '#0F3D22' }}>{d.postari}</div>
                      <div style={{ fontSize: 11, color: '#6B7280' }}>{t('analize', 'postari')}</div>
                    </div>
                    <div>
                      <div style={{ fontSize: 17, fontWeight: 700, color: '#1A6B3C' }}>{d.engagement}</div>
                      <div style={{ fontSize: 11, color: '#6B7280' }}>{t('analize', 'engagementRand')}</div>
                    </div>
                  </div>
                  <div style={{ fontSize: 11, color: '#9CA3AF', marginTop: 8 }}>
                    {d.reactii} {t('analize', 'reactii')} · {d.comentarii} {t('analize', 'comentarii')} · {d.distribuiri} {t('analize', 'distribuiri')}
                  </div>
                  {/* Cifrele venite de la Meta, cu variatia fata de perioada
                      dinainte. Sunt altele decat cele de mai sus: alea le numaram
                      noi din postari, astea le calculeaza Meta. */}
                  {(r.id === 'facebook' ? rezultat.metaFb : rezultat.metaIg) && (
                    <div style={{ borderTop: '1px solid #F3F4F6', marginTop: 10, paddingTop: 10 }}>
                      <div style={{ fontSize: 11, color: '#9CA3AF', textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 4 }}>
                        {t('analize', r.id === 'facebook' ? 'toataPagina' : 'totContul')}
                      </div>
                      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                      {(r.id === 'facebook'
                        ? [['vizualizari', t('analize', 'vizualizari')], ['vizionari_video', t('analize', 'vizionariVideo')], ['engagement', t('analize', 'engagementRand')], ['vizite', t('analize', 'vizitePagina')]]
                        : [['acoperire', t('analize', 'acoperire')], ['urmariri_nete', t('analize', 'urmaririNete')], ['conturi_implicate', t('analize', 'contImplicate')]]
                      ).map(([cheie, eticheta]) => {
                        const acum = (r.id === 'facebook' ? rezultat.metaFb : rezultat.metaIg)?.[cheie];
                        const inainte = (r.id === 'facebook' ? rezultat.metaFbAnterior : rezultat.metaIgAnterior)?.[cheie];
                        if (typeof acum !== 'number') return null;
                        return (
                          <div key={cheie}>
                            <div style={{ fontSize: 15, fontWeight: 700, color: '#0F3D22', whiteSpace: 'nowrap' }}>
                              {formatNr(acum)}<Sageata v={variatie(acum, inainte)} />
                            </div>
                            <div style={{ fontSize: 11, color: '#6B7280' }}>{eticheta}</div>
                          </div>
                        );
                      })}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Graficul. O singura linie: metricile de mai jos masoara lucruri
              diferite si vin de la retele diferite, deci suprapuse ar parea
              comparabile fara sa fie. */}
          {(() => {
            const optiuni = [];
            if (rezultat.serieFb?.length > 1) {
              optiuni.push({ id: 'fb-eng', serie: rezultat.serieFb, cheie: 'engagement', culoare: '#1877F2', eticheta: t('analize', 'metricaFb', { nume: t('analize', 'engagementRand') }) });
              optiuni.push({ id: 'fb-viz', serie: rezultat.serieFb, cheie: 'vizite', culoare: '#1877F2', eticheta: t('analize', 'metricaFb', { nume: t('analize', 'vizitePagina') }) });
            }
            if (rezultat.serieIg?.length > 1) {
              optiuni.push({ id: 'ig-acop', serie: rezultat.serieIg, cheie: 'acoperire', culoare: '#E1306C', eticheta: t('analize', 'metricaIg', { nume: t('analize', 'acoperire') }) });
            }
            if (!optiuni.length) return null;
            const aleasa = optiuni.find(o => o.id === metricaGrafic) || optiuni[0];
            return (
              <div style={{ background: 'white', border: '1.5px solid #D1E8DA', borderRadius: 14, padding: '16px 20px', marginBottom: 18 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12, flexWrap: 'wrap', marginBottom: 4 }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: '#0F3D22' }}>{t('analize', 'evolutie')}</span>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {optiuni.map(o => (
                      <button key={o.id} className={`vedere-tab ${aleasa.id === o.id ? 'activ' : ''}`} style={{ fontSize: 12 }} onClick={() => setMetricaGrafic(o.id)}>
                        {o.eticheta}
                      </button>
                    ))}
                  </div>
                </div>
                <GraficZile serie={aleasa.serie} cheie={aleasa.cheie} culoare={aleasa.culoare} />
              </div>
            );
          })()}

          <p style={{ fontSize: 12, color: '#9CA3AF', marginBottom: 18 }}>{t('analize', 'ambeleRetele')}{rezultat.postari.some(p => p.retea === 'instagram') && <> {t('analize', 'doarInstagram')}</>}</p>

          {rezultat.faraPagina.length > 0 && (
            <p style={{ fontSize: 12, color: '#92400E', background: '#FEF3C7', borderRadius: 8, padding: '8px 12px', marginBottom: 14 }}>
              {t('analize', 'faraPagina')} {rezultat.faraPagina.join(', ')}
            </p>
          )}
          {rezultat.probleme.map(pr => (
            <p key={pr.client.id} style={{ fontSize: 12, color: '#B91C1C', background: '#FEE2E2', borderRadius: 8, padding: '8px 12px', marginBottom: 14 }}>
              {pr.client.nume}: {pr.problema}
            </p>
          ))}
          {rezultat.avertismenteMeta.map(a => (
            <p key={`meta-${a.client.id}`} style={{ fontSize: 12, color: '#92400E', background: '#FEF3C7', borderRadius: 8, padding: '8px 12px', marginBottom: 14 }}>
              {t('analize', 'cifreMetaLipsa')} {a.client.nume} — {a.avertismentMeta}
            </p>
          ))}
          {rezultat.avertismenteInsights.map(a => (
            <p key={`ig-${a.client.id}`} style={{ fontSize: 12, color: '#92400E', background: '#FEF3C7', borderRadius: 8, padding: '8px 12px', marginBottom: 14 }}>
              {t('analize', 'insightsIndisponibile')} {a.client.nume} — {a.avertismentInsights}
            </p>
          ))}
          {rezultat.avertismenteReels.map(a => (
            <p key={`reels-${a.client.id}`} style={{ fontSize: 12, color: '#92400E', background: '#FEF3C7', borderRadius: 8, padding: '8px 12px', marginBottom: 14 }}>
              {t('analize', 'reelsNecitite')} {a.client.nume} — {a.avertismentReels}
            </p>
          ))}

          {rezultat.postari.length === 0 && (
            <div className="pagina-gol" style={{ marginTop: 40 }}><div className="pagina-gol-icon">📭</div><p style={{ fontSize: 13, color: '#6B7280' }}>{t('analize', 'faraPostari')}</p></div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {rezultat.postari.map(p => (
              <div key={p.id} className="card-mesaj" style={{ cursor: 'default', borderLeft: `3px solid ${comparabil && p.peste_medie ? '#2E9E5B' : '#E5E7EB'}` }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, alignItems: 'flex-start' }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
                      <IconRetea id={p.retea || 'facebook'} size={12} />
                      <span style={{ fontSize: 12, color: '#6B7280' }}>{new Date(p.creat_la).toLocaleDateString(getLocale(), { day: '2-digit', month: 'short', year: 'numeric' })}</span>
                      <span className="status-badge inactiv" style={{ fontSize: 11 }}>{t('analize', TIP_ANALIZE[p.tip] || 'tipText')}</span>
                      {filtruClient === 'toti' && <span style={{ fontSize: 11, color: '#1A6B3C', fontWeight: 600 }}>{p.client_nume}</span>}
                      {comparabil && <span className={`status-badge ${p.peste_medie ? 'activ' : 'inactiv'}`} style={{ fontSize: 11 }}>{p.peste_medie ? t('analize', 'pesteMedie') : p.la_medie ? t('analize', 'laMedie') : t('analize', 'subMedie')}</span>}
                    </div>
                    <div style={{ fontSize: 13, color: '#0F3D22', whiteSpace: 'pre-line', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{p.text || t('analize', 'faraText')}</div>
                    <a href={p.link} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: '#2E9E5B', display: 'inline-block', marginTop: 6 }}>{t('analize', 'vezi', { retea: RETELE.find(r => r.id === (p.retea || 'facebook'))?.label || 'Facebook' })} ↗</a>
                  </div>
                  <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <div style={{ marginBottom: 4, whiteSpace: 'nowrap' }}>
                      <span style={{ fontSize: 22, fontWeight: 700, color: comparabil && p.peste_medie ? '#1A6B3C' : '#0F3D22' }}>{p.engagement}</span>
                      <span style={{ fontSize: 11, color: '#9CA3AF', marginLeft: 5 }}>{t('analize', 'engagementRand')}</span>
                    </div>
                    <div style={{ fontSize: 11, color: '#9CA3AF', whiteSpace: 'nowrap' }}>
                      {p.reactii} {t('analize', 'reactii')} · {p.comentarii} {t('analize', 'comentarii')} · {p.distribuiri} {t('analize', 'distribuiri')}
                    </div>
                    {/* Vizualizarile postarii pe Facebook (15 oct 2026): vizualizari, oameni, clicuri. */}
                    {typeof p.vizualizari === 'number' && (
                      <div style={{ fontSize: 11, color: '#4B5563', whiteSpace: 'nowrap', marginTop: 2 }}>
                        {formatNr(p.vizualizari)} {t('analize', 'vizualizari')}{typeof p.oameni === 'number' ? ` · ${formatNr(p.oameni)} ${t('analize', 'oameni')}` : ''}{typeof p.clicuri === 'number' ? ` · ${formatNr(p.clicuri)} ${t('analize', 'clicuri')}` : ''}
                      </div>
                    )}
                    {/* Acoperirea si salvarile vin doar de la Instagram, prin
                        instagram_manage_insights. Le cerem de la inceput, dar pana acum
                        nu le afisam nicaieri — adica permisiunea nu se vedea folosita
                        nici in aplicatie, nici intr-un film de submisie. */}
                    {(p.acoperire > 0 || p.salvari > 0) && (
                      <div style={{ fontSize: 11, color: '#6B7280', whiteSpace: 'nowrap', marginTop: 4 }}>
                        <span style={{ color: '#0F3D22', fontWeight: 600 }}>{p.acoperire}</span> {t('analize', 'acoperire')}
                        {' · '}
                        <span style={{ color: '#0F3D22', fontWeight: 600 }}>{p.salvari}</span> {t('analize', 'salvari')}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

// media_tip pastreaza exact attachment.type de la Facebook. La comentarii vine
// photo / video_inline / animated_image_video, la mesaje image / video / audio /
// file / sticker / animated_image_share. Pana acum totul se randa ca <img>, deci
// un video aparea ca imagine rupta.
function MediaMesaj({ url, tip, maxHeight }) {
  if (!url) return null;
  const t2 = (tip || '').toLowerCase();
  const stil = { maxWidth: '100%', maxHeight, borderRadius: 8, marginTop: 6 };
  if (t2.includes('video')) {
    return <video src={url} controls preload="metadata" playsInline style={stil} />;
  }
  if (!tip || ['image', 'photo', 'sticker', 'animated_image_share'].includes(t2)) {
    return <img src={url} alt={t('inbox', 'atasament')} style={stil} />;
  }
  // audio, file, template, fallback: un link e mai util decat un chenar gol.
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', marginTop: 6, fontSize: 12, color: '#2E9E5B' }}>
      {t('inbox', 'deschideAtasament')}
    </a>
  );
}

// Inboxul VECHI. Nu mai e folosit de niciun rol din 20 septembrie 2026: clientul a trecut si el
// pe Inbox V3, ca agentia. Ramane in cod, ca si compozitorul vechi — nu se sterge ce a mers luni
// de zile, se lasa deoparte. Daca vreodata nu mai e nevoie de el, se scoate cu tot cu stiluri.
// eslint-disable-next-line no-unused-vars
function Inbox({ mesaje, setMesaje, clienti, poateRaspunde = true }) {
  const [mesajActiv, setMesajActiv] = useState(null);
  const [raspuns, setRaspuns] = useState('');
  const [filtruClient, setFiltruClient] = useState('toti');
  const [filtruRetea, setFiltruRetea] = useState('toate');
  const [filtruTip, setFiltruTip] = useState('toate');
  const [filtruCitit, setFiltruCitit] = useState('toate');
  const [trimitereRaspuns, setTrimitereRaspuns] = useState(false);
  const mesajeFiltrate = mesaje.filter(m => !m.arhivat && (filtruClient === 'toti' || m.clientId === parseInt(filtruClient)) && (filtruRetea === 'toate' || m.retea === filtruRetea) && (filtruTip === 'toate' || m.tip === filtruTip) && (filtruCitit === 'toate' || (filtruCitit === 'necitit' ? !m.citit : m.citit)));
  const nrNecitite = mesaje.filter(m => !m.arhivat && !m.citit).length;
  function selecteazaMesaj(mesaj) {
    setMesajActiv(mesaj);
    setRaspuns('');
    if (!mesaj.citit) {
      setMesaje(prev => prev.map(m => m.id === mesaj.id ? { ...m, citit: true } : m));
      supabase.from('mesaje').update({ citit: true }).eq('id', mesaj.id).then(() => {});
    }
  }
  function marcheazaCitit(id, e) {
    e.stopPropagation();
    const m = mesaje.find(x => x.id === id);
    const nou = m ? !m.citit : true;
    setMesaje(prev => prev.map(x => x.id === id ? { ...x, citit: nou } : x));
    supabase.from('mesaje').update({ citit: nou }).eq('id', id).then(() => {});
  }
  async function arhiveazaMesaj() {
    if (!mesajActiv) return;
    const id = mesajActiv.id;
    const { error } = await supabase.from('mesaje').update({ arhivat: true }).eq('id', id);
    if (error) { alert(t('inbox', 'eroareArhivare') + error.message); return; }
    setMesaje(prev => prev.map(m => m.id === id ? { ...m, arhivat: true } : m));
    setMesajActiv(null);
  }
  // Ascunderea unui comentariu Instagram. Intra sub aceeasi permisiune ca
  // raspunsul (instagram_manage_comments) si e a doua operatiune pe care o poti
  // face cu un comentariu urat, in afara de a-i raspunde.
  // Din 15 septembrie 2026 aceeasi functie si readuce comentariul (`arata`), iar starea se tine
  // minte in `mesaje.ascuns`, ca butonul sa se schimbe. Confirmarea se cere doar la ascundere.
  async function comutaAscundereIg(ascunde) {
    if (!mesajActiv || mesajActiv.retea !== 'instagram' || mesajActiv.tip !== 'comentariu') return;
    if (ascunde && !window.confirm(t('inbox', 'confirmAscunde'))) return;
    const id = mesajActiv.id;
    const { error } = await supabase.functions.invoke('instagram-reply', {
      body: ascunde ? { mesaj_id: id, ascunde: true } : { mesaj_id: id, arata: true }
    });
    if (error) {
      let detaliu = error.message;
      try { const b = await error.context.json(); detaliu = (b && (b.detail ? (typeof b.detail === 'string' ? b.detail : JSON.stringify(b.detail)) : b.error)) || detaliu; } catch (e) {}
      alert(t('inbox', ascunde ? 'eroareAscundere' : 'eroareAratare') + detaliu);
      return;
    }
    setMesaje(prev => prev.map(m => m.id === id ? { ...m, citit: true, ascuns: ascunde } : m));
    setMesajActiv(prev => prev && prev.id === id ? { ...prev, ascuns: ascunde } : prev);
    alert(t('inbox', ascunde ? 'comentariuAscuns' : 'comentariuAratat'));
  }

  // Stergerea definitiva a unui comentariu Instagram. Tot sub
  // instagram_manage_comments, ca raspunsul si ascunderea.
  async function stergeComentariuIg() {
    if (!mesajActiv || mesajActiv.retea !== 'instagram' || mesajActiv.tip !== 'comentariu') return;
    if (!window.confirm(t('inbox', 'confirmStergere'))) return;
    const id = mesajActiv.id;
    const { error } = await supabase.functions.invoke('instagram-reply', {
      body: { mesaj_id: id, sterge: true }
    });
    if (error) {
      let detaliu = error.message;
      try { const b = await error.context.json(); detaliu = (b && (b.detail ? (typeof b.detail === 'string' ? b.detail : JSON.stringify(b.detail)) : b.error)) || detaliu; } catch (e) {}
      alert(t('inbox', 'eroareStergere') + detaliu);
      return;
    }
    setMesaje(prev => prev.map(m => m.id === id ? { ...m, arhivat: true, citit: true } : m));
    setMesajActiv(null);
    alert(t('inbox', 'comentariuSters'));
  }

  // Moderarea comentariilor de pe Facebook. Merge cu permisiuni deja aprobate,
  // deci nu asteapta niciun App Review — spre deosebire de tot ce tine de
  // Instagram. Raportarea nu exista prin API, la nicio retea.
  async function moderezFb(actiune) {
    if (!mesajActiv || mesajActiv.retea !== 'facebook' || mesajActiv.tip !== 'comentariu') return;
    const intrebari = { sterge: 'confirmStergere', blocheaza: 'confirmBlocare', ascunde: 'confirmAscunde' };
    if (intrebari[actiune] && !window.confirm(t('inbox', intrebari[actiune]))) return;
    const id = mesajActiv.id;
    const { data, error } = await supabase.functions.invoke('facebook-moderate', {
      body: { mesaj_id: id, actiune }
    });
    if (error) {
      let detaliu = error.message;
      try { const b = await error.context.json(); detaliu = (b && (b.detail ? (typeof b.detail === 'string' ? b.detail : JSON.stringify(b.detail)) : b.error)) || detaliu; } catch (e) {}
      const mesajeEroare = { sterge: 'eroareStergere', blocheaza: 'eroareBlocare', ascunde: 'eroareAscundere', arata: 'eroareAratare' };
      alert(t('inbox', mesajeEroare[actiune] || 'eroareAscundere') + detaliu);
      return;
    }
    if (actiune === 'sterge' || actiune === 'blocheaza') {
      setMesaje(prev => prev.map(m => m.id === id ? { ...m, arhivat: true, citit: true } : m));
      setMesajActiv(null);
      alert(t('inbox', actiune === 'sterge' ? 'comentariuSters' : 'autorBlocat'));
      return;
    }
    // Functia verifica pe Facebook ce s-a intamplat de fapt: e raportat ca API-ul
    // raspunde cu succes iar comentariul ramane in starea veche. Un "gata" fals e mai
    // rau decat o eroare. Starea noua se tine minte doar daca e confirmata (15 septembrie
    // 2026, mesaje.ascuns), ca butonul sa comute intre „Ascunde” si „Arata”.
    const ascunsAcum = actiune === 'ascunde';
    const confirmat = data?.confirmat !== false;
    setMesaje(prev => prev.map(m => m.id === id ? { ...m, citit: true, ...(confirmat ? { ascuns: ascunsAcum } : {}) } : m));
    if (confirmat) setMesajActiv(prev => prev && prev.id === id ? { ...prev, ascuns: ascunsAcum } : prev);
    if (ascunsAcum) alert(confirmat ? t('inbox', 'comentariuAscuns') : t('inbox', 'ascunsNeconfirmat'));
    else alert(confirmat ? t('inbox', 'comentariuAratat') : t('inbox', 'aratatNeconfirmat'));
  }

  async function trimiteRaspuns() {
    if (!mesajActiv || !raspuns.trim() || trimitereRaspuns) return;
    setTrimitereRaspuns(true);
    try {
      // Functia de raspuns depinde de retea SI de tip: comentariile si mesajele
      // directe merg pe drumuri diferite, la ambele retele.
      const fnRaspuns = mesajActiv.retea === 'instagram'
        ? (mesajActiv.tip === 'mesaj' ? 'instagram-message-send' : 'instagram-reply')
        : (mesajActiv.tip === 'mesaj' ? 'facebook-message-send' : 'facebook-reply');
      const { error } = await supabase.functions.invoke(fnRaspuns, {
        body: { mesaj_id: mesajActiv.id, raspuns_text: raspuns }
      });
      if (error) {
        let detaliu = error.message;
        let cod = '';
        try { const b = await error.context.json(); cod = b && b.error ? b.error : ''; detaliu = (b && (b.detail ? (typeof b.detail === 'string' ? b.detail : JSON.stringify(b.detail)) : b.error)) || detaliu; } catch (e) {}
        if (cod === 'acces_mesaje_oprit') {
          alert(t('inbox', 'accesMesajeOprit'));
        } else if (cod === 'fereastra_24h') {
          alert(t('inbox', 'fereastra24h'));
        } else {
          alert(t('inbox', 'raspunsNetrimis') + detaliu);
        }
        return;
      }
      const acum = new Date().toISOString();
      setMesaje(prev => prev.map(m => m.id === mesajActiv.id ? { ...m, raspunsTrimisLa: acum, raspunsText: raspuns } : m));
      setMesajActiv(prev => prev ? { ...prev, raspunsTrimisLa: acum, raspunsText: raspuns } : prev);
      setRaspuns('');
    } catch (err) {
      alert(t('inbox', 'raspunsNetrimis') + (err && err.message ? err.message : String(err)));
    } finally {
      setTrimitereRaspuns(false);
    }
  }
  return (
    <div className="pagina">
      <div className="pagina-header"><div><h1 className="pagina-titlu">{t('inbox', 'inbox')}</h1><p className="pagina-subtitlu">{nrNecitite > 0 ? t('inbox', 'mesajeNecitite', { n: nrNecitite }) : t('inbox', 'toateCitite')}</p></div></div>
      <div className="inbox-filtre">
        {clienti.length > 1 && (<select className="select-filtru" value={filtruClient} onChange={e => setFiltruClient(e.target.value)}><option value="toti">{t('inbox', 'totiClientii')}</option>{clienti.map(c => <option key={c.id} value={c.id}>{c.nume}</option>)}</select>)}
        <select className="select-filtru" value={filtruRetea} onChange={e => setFiltruRetea(e.target.value)}><option value="toate">{t('inbox', 'toateRetelele')}</option>{RETELE.map(r => <option key={r.id} value={r.id}>{r.label}</option>)}</select>
        <select className="select-filtru" value={filtruTip} onChange={e => setFiltruTip(e.target.value)}><option value="toate">{t('inbox', 'toateTipurile')}</option><option value="comentariu">{t('inbox', 'comentarii')}</option><option value="mesaj">{t('inbox', 'mesaje')}</option><option value="mentiune">{t('inbox', 'mentiuni')}</option></select>
        <div className="vedere-tabs"><button className={`vedere-tab ${filtruCitit === 'toate' ? 'activ' : ''}`} onClick={() => setFiltruCitit('toate')}>{t('inbox', 'toate')}</button><button className={`vedere-tab ${filtruCitit === 'necitit' ? 'activ' : ''}`} onClick={() => setFiltruCitit('necitit')}>{t('inbox', 'necitite')} {nrNecitite > 0 && `(${nrNecitite})`}</button><button className={`vedere-tab ${filtruCitit === 'citit' ? 'activ' : ''}`} onClick={() => setFiltruCitit('citit')}>{t('inbox', 'citite')}</button></div>
      </div>
      <div className="inbox-layout">
        <div className="inbox-lista">
          {mesajeFiltrate.length === 0 ? <div className="pagina-gol"><div className="pagina-gol-icon">💬</div><p>{t('inbox', 'niciunMesaj')}</p></div> :
            mesajeFiltrate.map(mesaj => { const retea = RETELE.find(r => r.id === mesaj.retea); const tip = TIP_INFO[mesaj.tip]; return (
              <div key={mesaj.id} className={`card-mesaj ${mesajActiv?.id === mesaj.id ? 'selectat' : ''} ${!mesaj.citit ? 'necitit' : ''}`} onClick={() => selecteazaMesaj(mesaj)}>
                <div className="card-mesaj-header"><div className="card-mesaj-autor"><div className="mesaj-avatar">{mesaj.autor.charAt(0).toUpperCase()}</div><div><div className="mesaj-autor-nume">{mesaj.autor} {!mesaj.citit && <span className="mesaj-nou-dot"></span>}</div><div className="mesaj-meta-inline"><span className="retea-chip" style={{ background: retea?.bg, color: retea?.culoare }}><IconRetea id={mesaj.retea} size={10} /> {retea?.label}</span><span className="mesaj-tip-badge">{tip?.icon} {t('inbox', mesaj.tip)}</span></div></div></div><div className="card-mesaj-dreapta"><div className="mesaj-timp">{mesaj.timp}</div><button className="btn-citit" onClick={e => marcheazaCitit(mesaj.id, e)}>{mesaj.citit ? '○' : '●'}</button></div></div>
                <div className="card-mesaj-client">{mesaj.client}</div>
                <div className="card-mesaj-text">{mesaj.text || <span style={{ color: '#6B7280', fontStyle: 'italic' }}>{t('inbox', 'faraText')}</span>}</div>
                {mesaj.mediaUrl && <MediaMesaj url={mesaj.mediaUrl} tip={mesaj.mediaTip} maxHeight={120} />}
                {mesaj.postare && <div className="card-mesaj-postare">↳ {mesaj.postare}</div>}
                {mesaj.raspunsTrimisLa && <div className="card-mesaj-raspuns" style={{ color: '#1A6B3C', fontSize: 12, fontWeight: 600, marginTop: 4 }}>{t('inbox', 'raspunsTrimis')}</div>}
                {mesaj.ascuns && <div style={{ display: 'inline-block', marginTop: 4, padding: '1px 8px', borderRadius: 6, background: '#FEF3C7', color: '#92400E', fontSize: 12, fontWeight: 600 }}>{t('inbox', 'etichetaAscuns')}</div>}
              </div>
            ); })}
        </div>
        {mesajActiv && (
          <div className="inbox-detaliu">
            <div className="detaliu-header"><div><div className="detaliu-client">{mesajActiv.autor}</div><div className="detaliu-meta"><span className="retea-chip" style={{ background: RETELE.find(r => r.id === mesajActiv.retea)?.bg, color: RETELE.find(r => r.id === mesajActiv.retea)?.culoare }}><IconRetea id={mesajActiv.retea} size={12} /> {RETELE.find(r => r.id === mesajActiv.retea)?.label}</span><span className="mesaj-tip-badge">{TIP_INFO[mesajActiv.tip]?.icon} {t('inbox', mesajActiv.tip)}</span></div></div><button className="btn-inchide" onClick={() => setMesajActiv(null)}>✕</button></div>
            <div className="inbox-detaliu-info"><div className="detaliu-info-rand"><span className="detaliu-info-label">{t('inbox', 'client')}</span><span className="detaliu-info-val">{mesajActiv.client}</span></div><div className="detaliu-info-rand"><span className="detaliu-info-label">{t('inbox', 'primit')}</span><span className="detaliu-info-val">{mesajActiv.timp}</span></div></div>
            {/* O mentiune poate veni fara text: cineva te-a etichetat intr-o poza
                sau intr-un comentariu gol. Pana pe 17 septembrie 2026, cardul
                ramanea alb si parea defect. Acum scrie ce s-a intamplat. */}
            <div className="inbox-mesaj-text">
              {mesajActiv.text
                ? mesajActiv.text
                : <span style={{ color: '#6B7280', fontStyle: 'italic' }}>{t('inbox', 'faraText')}</span>}
            </div>
            {/* Adresa mentiunii pe Facebook: fara ea nu aveai cum sa ajungi la
                locul unde a fost mentionat clientul. */}
            {mesajActiv.link && (
              <a
                href={mesajActiv.link}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secundar"
                style={{ display: 'inline-block', marginTop: 8, textDecoration: 'none' }}
              >
                {t('inbox', 'deschidePeRetea')}
              </a>
            )}
            {mesajActiv.mediaUrl && <MediaMesaj url={mesajActiv.mediaUrl} tip={mesajActiv.mediaTip} maxHeight={300} />}
            {mesajActiv.raspunsTrimisLa ? (
              <div className="inbox-raspuns-trimis" style={{ background: '#D4EDE0', border: '1px solid #1A6B3C', borderRadius: 8, padding: 12, marginTop: 12 }}>
                <div style={{ color: '#1A6B3C', fontWeight: 600, marginBottom: 4 }}>{t('inbox', 'raspunsTrimis')}</div>
                {mesajActiv.raspunsText && <div style={{ color: '#1A6B3C', fontSize: 14 }}>{mesajActiv.raspunsText}</div>}
              </div>
            ) : poateRaspunde ? (
              <div className="inbox-raspuns">
                {/* Nu blocam trimiterea dupa 24 de ore: documentatia nu spune
                    raspicat durata ferestrei pentru Instagram, iar un numar
                    neverificat folosit ca blocaj ar opri raspunsuri valide.
                    Avertizam, si lasam API-ul sa decida. */}
                {mesajActiv.tip === 'mesaj' && mesajActiv.primitLa && (() => {
                  const ore = (Date.now() - new Date(mesajActiv.primitLa).getTime()) / 3600000;
                  if (ore < 20) return null;
                  return (
                    <div style={{ fontSize: 12, color: '#92400E', background: '#FEF3C7', borderRadius: 8, padding: '8px 12px', marginBottom: 8 }}>
                      {ore >= 24
                        ? t('inbox', 'fereastraProbabilInchisa')
                        : t('inbox', 'fereastraSeInchide', { ore: Math.floor(ore) })}
                    </div>
                  );
                })()}<label className="label">{t('inbox', 'raspuns')}</label><textarea className="textarea" placeholder={t('inbox', 'scrieRaspuns')} value={raspuns} onChange={e => setRaspuns(e.target.value)} rows={4} /><div className="inbox-raspuns-actiuni"><button className="btn-principal" disabled={!raspuns.trim() || trimitereRaspuns} onClick={trimiteRaspuns}>{trimitereRaspuns ? t('inbox', 'seTrimite') : t('inbox', 'trimiteRaspuns')}</button></div></div>
            ) : (
              <div style={{ background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 8, padding: 12, marginTop: 12, color: '#6B7280', fontSize: 14 }}>{t('inbox', 'doarEchipa')}</div>
            )}
            {/* Ascunderea sta langa Arhiveaza, nu in zona de raspuns: zona aia
                dispare dupa ce trimiti raspunsul, iar decizia de a ascunde un
                comentariu vine de obicei DUPA ce l-ai citit si i-ai raspuns. */}
            <div style={{ marginTop: 12, display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
              {/* Butonul de ascundere comuta dupa `mesajActiv.ascuns` (15 septembrie 2026):
                  un comentariu ascuns din aplicatie se poate readuce tot de aici. */}
              {poateRaspunde && mesajActiv.retea === 'instagram' && mesajActiv.tip === 'comentariu' && (<>
                <button className="btn-secundar" onClick={() => comutaAscundereIg(!mesajActiv.ascuns)}>{t('inbox', mesajActiv.ascuns ? 'aratComentariu' : 'ascundeComentariu')}</button>
                <button className="btn-secundar" style={{ color: '#B91C1C', borderColor: '#FCA5A5' }} onClick={stergeComentariuIg}>{t('inbox', 'stergeComentariu')}</button>
              </>)}
              {/* La Facebook se poate si blocarea autorului, ceea ce Instagram nu
                  permite prin API. Raportarea nu exista la niciuna. */}
              {poateRaspunde && mesajActiv.retea === 'facebook' && mesajActiv.tip === 'comentariu' && (<>
                <button className="btn-secundar" onClick={() => moderezFb(mesajActiv.ascuns ? 'arata' : 'ascunde')}>{t('inbox', mesajActiv.ascuns ? 'aratComentariu' : 'ascundeComentariu')}</button>
                <button className="btn-secundar" style={{ color: '#B91C1C', borderColor: '#FCA5A5' }} onClick={() => moderezFb('sterge')}>{t('inbox', 'stergeComentariu')}</button>
                <button className="btn-secundar" style={{ color: '#B91C1C', borderColor: '#FCA5A5' }} onClick={() => moderezFb('blocheaza')}>{t('inbox', 'blocheazaAutor')}</button>
              </>)}
              <button className="btn-secundar" onClick={arhiveazaMesaj}>{t('inbox', 'arhiveaza')}</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// Titlul de TikTok Photo Mode si primul comentariu pleaca odata cu postarea, dar nu stau in
// text. Pana pe 13 octombrie 2026 ecranul de aprobare nu le arata, deci clientul aproba textul
// si le vedea abia pe retea. Culorile sunt inchise anume: griul deschis nu se citeste pe telefon.
// `peInchis` e pentru caseta colorata a postarii fara poza, unde textul e alb: acolo mostenesc culoarea.
const ETICHETA_APROBARE = { display: 'block', fontSize: 11, fontWeight: 600, color: '#4B5563', textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 2 };

function TitluTikTokAfisat({ postare, peInchis }) {
  if (!postare || !postare.titluTikTok) return null;
  return (
    <div style={{ marginBottom: 8 }}>
      <span style={peInchis ? { ...ETICHETA_APROBARE, color: 'inherit' } : ETICHETA_APROBARE}>{t('aprobare', 'titluTikTok')}</span>
      <span style={{ display: 'block', fontWeight: 700, color: peInchis ? 'inherit' : '#111827' }}>{postare.titluTikTok}</span>
    </div>
  );
}

function PrimComentariuAfisat({ postare, peInchis }) {
  if (!postare || !postare.primComentariu) return null;
  return (
    <div style={{ marginTop: 10, paddingTop: 8, borderTop: peInchis ? '1px solid rgba(255,255,255,.45)' : '1px solid #E5E7EB' }}>
      <span style={peInchis ? { ...ETICHETA_APROBARE, color: 'inherit' } : ETICHETA_APROBARE}>{t('aprobare', 'primComentariu')}</span>
      <span style={{ display: 'block', fontSize: 13, color: peInchis ? 'inherit' : '#1F2937', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{postare.primComentariu}</span>
    </div>
  );
}

function Aprobare({ postari, setPostari }) {
  const [postareActiva, setPostareActiva] = useState(null);
  const [filtru, setFiltru] = useState('toate');
  const [showRespingere, setShowRespingere] = useState(false);
  const [motivRespingere, setMotivRespingere] = useState('');
  const postariAprobare = postari.filter(p => filtru === 'toate' ? ['intern', 'aprobare_finala'].includes(p.status) : p.status === filtru);
  const toatePostarile = postari.filter(p => ['intern', 'aprobare_finala'].includes(p.status));
  function selecteazaPostare(postare) { setPostareActiva(postare); setShowRespingere(false); setMotivRespingere(''); }
  async function aprobaPostare(id) {
    const { data: postare } = await supabase.from('postari').select('retea, data_programata, ora_programata').eq('id', id).maybeSingle();
    if (areProgramareInViitor(postare)) {
      const { error } = await supabase.from('postari').update({ status: 'programat' }).eq('id', id);
      if (error) { alert(t('aprobare', 'eroarePublicare') + error.message); return; }
      setPostari(prev => prev.map(p => p.id === id ? { ...p, status: 'programat' } : p));
      setPostareActiva(null);
      alert(t('aprobare', 'aprobatProgramat', { data: postare.data_programata, ora: String(postare.ora_programata).slice(0, 5) }));
      return;
    }
    // Declarat aici, nu mai jos: ramura care publica prin functie il foloseste
    // inainte de linia unde era declarat, iar const nu se ridica — ar fi crapat.
    const acum = new Date().toISOString();
    const fnPublicare = FUNCTIE_PUBLICARE[postare?.retea];
    if (fnPublicare) {
      const { data, error } = await supabase.functions.invoke(fnPublicare, { body: { post_id: id } });
      if (error || data?.error) {
        alert(t('aprobare', 'aprobatPublicareEsuata') + (data?.error ? JSON.stringify(data.error) : error.message));
        setPostari(prev => prev.map(p => p.id === id ? { ...p, status: 'draft' } : p));
        setPostareActiva(null);
        return;
      }
      setPostari(prev => prev.map(p => p.id === id ? { ...p, status: 'publicat', ...campuriDupaPublicare(p, acum) } : p));
      setPostareActiva(null);
      return;
    }
    const { error } = await supabase.from('postari').update({ status: 'publicat', publicat_la: acum }).eq('id', id);
    if (error) { alert(t('aprobare', 'eroarePublicare') + error.message); return; }
    setPostari(prev => prev.map(p => p.id === id ? { ...p, status: 'publicat', ...campuriDupaPublicare(p, acum) } : p));
    setPostareActiva(null);
  }
  async function confirmaRespingere() {
    if (!postareActiva) return;
    const { error } = await supabase.from('postari').update({ status: 'respins', feedback: motivRespingere }).eq('id', postareActiva.id);
    if (error) { alert(t('aprobare', 'eroareRespingere') + error.message); return; }
    setPostari(prev => prev.map(p => p.id === postareActiva.id ? { ...p, status: 'respins', feedback: motivRespingere } : p));
    setPostareActiva(null);
    setShowRespingere(false);
    setMotivRespingere('');
  }
  const retea = postareActiva ? RETELE.find(r => r.id === postareActiva.retea) : null;
  const ratioPreview = postareActiva ? (PREVIEW_RATIO[postareActiva.retea]?.[postareActiva.format] || 56.25) : 56.25;
  const labelPreview = postareActiva ? (PREVIEW_LABEL[postareActiva.retea]?.[postareActiva.format] || '—') : '—';
  return (
    <div className="pagina">
      <div className="pagina-header"><div><h1 className="pagina-titlu">{t('aprobare', 'aprobarePostari')}</h1><p className="pagina-subtitlu">{toatePostarile.length} {t('aprobare', 'postariInAsteptare')}</p></div>
        <div className="filtru-tabs"><button className={`filtru-tab ${filtru === 'toate' ? 'activ' : ''}`} onClick={() => setFiltru('toate')}>{t('aprobare', 'toate')} {toatePostarile.length > 0 && `(${toatePostarile.length})`}</button><button className={`filtru-tab ${filtru === 'intern' ? 'activ' : ''}`} onClick={() => setFiltru('intern')}>{t('aprobare', 'intern')}</button><button className={`filtru-tab ${filtru === 'aprobare_finala' ? 'activ' : ''}`} onClick={() => setFiltru('aprobare_finala')}>{t('aprobare', 'aprobareFinala')}</button></div>
      </div>
      <div className="aprobare-layout">
        <div className="aprobare-lista">
          {postariAprobare.length === 0 ? <div className="pagina-gol"><div className="pagina-gol-icon">✅</div><p>{t('aprobare', 'nicioPostareAsteptare')}</p></div> : postariAprobare.map(postare => {
            const r = RETELE.find(x => x.id === postare.retea); const si = STATUS_INFO[postare.status];
            return <div key={postare.id} className={`card-aprobare ${postareActiva?.id === postare.id ? 'selectat' : ''}`} onClick={() => selecteazaPostare(postare)}>
              <div className="card-aprobare-header"><div className="card-aprobare-client">{postare.client}</div><div className="aprobare-status-badge" style={{ background: si.bg, color: si.culoare }}>{t('status', postare.status)}</div></div>
              <div className="card-aprobare-meta"><span className="retea-chip" style={{ background: r?.bg, color: r?.culoare }}><IconRetea id={postare.retea} size={12} /> {r?.label} · {postare.format}</span><span className="card-aprobare-data">📅 {postare.dataProgramata} · {postare.ora}</span></div>
              {postare.imagineUrl && (
                <img src={postare.imagineUrl} alt="" loading="lazy" style={{ display: 'block', width: '100%', maxHeight: 320, objectFit: 'cover', borderRadius: 10, margin: '8px 0' }} />
              )}
              <TitluTikTokAfisat postare={postare} />
              <div className="card-aprobare-text">{postare.text}</div>
              {postare.hashtags && <div style={{ color: '#1A6B3C', fontSize: 13, marginTop: 8 }}>{postare.hashtags}</div>}
              <PrimComentariuAfisat postare={postare} />
              <div className="card-aprobare-actiuni"><button className="btn-aprobare-rapid" onClick={e => { e.stopPropagation(); aprobaPostare(postare.id); }}>{t('aprobare', 'aprobaRapid')}</button><button className="btn-respingere-rapid" onClick={e => { e.stopPropagation(); selecteazaPostare(postare); setShowRespingere(true); }}>{t('aprobare', 'respingeRapid')}</button></div>
            </div>;
          })}
        </div>
        {postareActiva && (
          <div className="aprobare-detaliu">
            <div className="detaliu-header"><div><div className="detaliu-client">{postareActiva.client}</div><div className="detaliu-meta"><span className="retea-chip" style={{ background: retea?.bg, color: retea?.culoare }}><IconRetea id={postareActiva.retea} size={12} /> {retea?.label} · {postareActiva.format}</span></div></div><button className="btn-inchide" onClick={() => { setPostareActiva(null); setShowRespingere(false); }}>✕</button></div>
            <div className="detaliu-preview-label">{t('aprobare', 'previzualizare')} {labelPreview} px</div>
            {postareActiva.imagineUrl ? (
              <div style={{ border: '1px solid #E8F5EE', borderRadius: 10, overflow: 'hidden', marginBottom: 16, background: 'white' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 12px' }}>
                  <div style={{ width: 32, height: 32, borderRadius: '50%', background: '#1A6B3C', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14, flexShrink: 0 }}>{(postareActiva.client || '?').charAt(0)}</div>
                  <div style={{ lineHeight: 1.2 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, color: '#1F2937' }}>{postareActiva.client || t('aprobare', 'client')}</div>
                    <div style={{ fontSize: 11, color: '#9CA3AF' }}>{t('aprobare', 'acum')}</div>
                  </div>
                </div>
                <div style={{ position: 'relative', width: '100%', paddingBottom: `${Math.min(ratioPreview, 100)}%`, overflow: 'hidden' }}>
                  <img src={postareActiva.imagineUrl} alt="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
                </div>
                <div style={{ padding: '10px 12px' }}>
                  <TitluTikTokAfisat postare={postareActiva} />
                  <div style={{ fontSize: 13, color: '#1F2937', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{postareActiva.text}</div>
                  {postareActiva.hashtags && <div style={{ color: '#1A6B3C', fontSize: 12, marginTop: 6 }}>{postareActiva.hashtags}</div>}
                  <PrimComentariuAfisat postare={postareActiva} />
                </div>
              </div>
            ) : (
              <div className="detaliu-preview" style={{ paddingBottom: `${Math.min(ratioPreview, 100)}%` }}><div className="detaliu-preview-continut"><div className="detaliu-preview-text"><TitluTikTokAfisat postare={postareActiva} peInchis />{postareActiva.text}<PrimComentariuAfisat postare={postareActiva} peInchis /></div></div></div>
            )}
            <div className="detaliu-info"><div className="detaliu-info-rand"><span className="detaliu-info-label">{t('aprobare', 'creatDe')}</span><span className="detaliu-info-val">{postareActiva.creatDe || '—'}</span></div><div className="detaliu-info-rand"><span className="detaliu-info-label">{t('aprobare', 'programat')}</span><span className="detaliu-info-val">{postareActiva.dataProgramata} · {postareActiva.ora}</span></div><div className="detaliu-info-rand"><span className="detaliu-info-label">{t('aprobare', 'status')}</span><span className="aprobare-status-badge" style={{ background: STATUS_INFO[postareActiva.status].bg, color: STATUS_INFO[postareActiva.status].culoare }}>{t('status', postareActiva.status)}</span></div></div>
            {showRespingere ? (
              <div className="respingere-dialog"><div className="respingere-titlu">{t('aprobare', 'deCeRespingi')}</div><textarea className="textarea" placeholder={t('aprobare', 'explicaModificat')} value={motivRespingere} onChange={e => setMotivRespingere(e.target.value)} rows={3} autoFocus /><div className="respingere-butoane"><button className="btn-respingere-final" onClick={confirmaRespingere}>{t('aprobare', 'confirmaRespingerea')}</button><button className="btn-anuleaza" onClick={() => setShowRespingere(false)}>{t('aprobare', 'anuleaza')}</button></div></div>
            ) : (
              <div className="detaliu-butoane"><button className="btn-aprobare-final" onClick={() => aprobaPostare(postareActiva.id)}>{t('aprobare', 'aprobaPostarea')}</button><button className="btn-respingere-final" onClick={() => setShowRespingere(true)}>{t('aprobare', 'respinge')}</button></div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function Drafturi({ postari, setPostari, setPaginaActiva }) {
  const drafturi = postari.filter(p => p.status === 'draft');

  async function trimiteAprobare(id) {
    const { error } = await supabase.from('postari').update({ status: 'aprobare_finala' }).eq('id', id);
    if (error) { alert(t('drafturi', 'eroarePrefix') + error.message); return; }
    setPostari(prev => prev.map(p => p.id === id ? { ...p, status: 'aprobare_finala' } : p));
    alert(t('drafturi', 'ciornaTrimisa'));
  }

  async function stergeDraft(id) {
    if (!window.confirm(t('drafturi', 'confirmStergeCiorna'))) return;
    const { error } = await supabase.from('postari').delete().eq('id', id);
    if (error) { alert(t('drafturi', 'eroarePrefix') + error.message); return; }
    setPostari(prev => prev.filter(p => p.id !== id));
    alert(t('drafturi', 'ciornaStearsa'));
  }

  return (
    <div className="pagina">
      <div className="pagina-header">
        <div>
          <h1 className="pagina-titlu">{t('drafturi', 'drafturi')}</h1>
          <p className="pagina-subtitlu">{drafturi.length} {t('drafturi', 'cioraneSalvate')}</p>
        </div>
      </div>
      <div className="aprobare-layout">
        <div className="aprobare-lista">
          {drafturi.length === 0 ? (
            <div className="pagina-gol">
              <div className="pagina-gol-icon">📝</div>
              <p>{t('drafturi', 'nicioCiornaSalvata')}</p>
            </div>
          ) : drafturi.map(postare => {
            const r = RETELE.find(x => x.id === postare.retea);
            const si = STATUS_INFO[postare.status];
            return (
              <div key={postare.id} className="card-aprobare">
                <div className="card-aprobare-header">
                  <div className="card-aprobare-client">{postare.client}</div>
                  <div className="aprobare-status-badge" style={{ background: si.bg, color: si.culoare }}>{t('status', postare.status)}</div>
                </div>
                <div className="card-aprobare-meta">
                  <span className="retea-chip" style={{ background: r?.bg, color: r?.culoare }}>
                    <IconRetea id={postare.retea} size={12} /> {r?.label} · {postare.format}
                  </span>
                  <span className="card-aprobare-data">
                    {postare.dataProgramata ? `📅 ${postare.dataProgramata} · ${postare.ora}` : t('drafturi', 'faraDataProgramata')}
                  </span>
                </div>
                {postare.imagineUrl && (
                  <img src={postare.imagineUrl} alt="" loading="lazy" style={{ display: 'block', width: '100%', maxHeight: 320, objectFit: 'cover', borderRadius: 10, margin: '8px 0' }} />
                )}
                <div className="card-aprobare-text">{postare.text}</div>
                {postare.hashtags && <div style={{ color: '#1A6B3C', fontSize: 13, marginTop: 8 }}>{postare.hashtags}</div>}
                <div className="card-aprobare-actiuni">
                  {postare.grupId && setPaginaActiva && (
                    <button className="btn-secundar" style={{ padding: '6px 12px', fontSize: 13 }}
                      onClick={e => { e.stopPropagation(); deschidePostarea(postare, setPaginaActiva, null); }}>
                      {t('drafturi', 'deschideInCompozitor')}
                    </button>
                  )}
                  <button className="btn-aprobare-rapid" onClick={e => { e.stopPropagation(); trimiteAprobare(postare.id); }}>{t('drafturi', 'trimiteSpreAprobare')}</button>
                  <button className="btn-respingere-rapid" onClick={e => { e.stopPropagation(); stergeDraft(postare.id); }}>{t('drafturi', 'sterge')}</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

function Calendar({ postari: toatePostarile, clienti, setPaginaActiva, setPostareEdit, doarPublicateProgramate = false }) {
  // Contul de client vede in calendar doar ce e programat si publicat (cerut de Luminita, 16 sept 2026).
  const postari = doarPublicateProgramate
    ? toatePostarile.filter(p => ['publicat', 'programat'].includes(p.status))
    : toatePostarile;
  const azi = new Date();
  const [vedere, setVedere] = useState('saptamana');
  const [dataStart, setDataStart] = useState(() => { const d = new Date(); const zi = d.getDay() === 0 ? 6 : d.getDay() - 1; d.setDate(d.getDate() - zi); d.setHours(0,0,0,0); return d; });
  const [luna, setLuna] = useState(azi.getMonth());
  const [an, setAn] = useState(azi.getFullYear());
  const [filtruClient, setFiltruClient] = useState('toti');
  const [filtruRetea, setFiltruRetea] = useState('toate');
  const [postareSelectata, setPostareSelectata] = useState(null);
  // Pe telefon, in vederea lunara: ziua apasata, a carei lista se arata sub grila.
  const [ziAleasa, setZiAleasa] = useState(azi.getDate());
  // Pe telefon, in vederea saptamanala: ziua apasata din banda de zile (ca data, AAAA-LL-ZZ).
  const [ziSaptAleasa, setZiSaptAleasa] = useState(null);
  // Pe telefon detaliul postarii apare sub lista, deci se aduce in ecran; altfel apesi si
  // pare ca nu s-a intamplat nimic.
  useEffect(() => {
    if (!postareSelectata || window.innerWidth > 768) return;
    // Se deruleaza DOAR cutia paginii. `scrollIntoView` ar misca si documentul (e cu vreo 130px
    // mai inalt decat ecranul, din cauza subsolului legal) si ar baga titlul sub banda de sus.
    const el = document.querySelector('.calendar-detaliu');
    const cutie = document.querySelector('.continut-principal');
    if (el && cutie) cutie.scrollTo({ top: cutie.scrollTop + el.getBoundingClientRect().top - 70, behavior: 'smooth' });
  }, [postareSelectata]);

  function schimbaLuna(dir) { if (dir === -1 && luna === 0) { setLuna(11); setAn(a => a - 1); } else if (dir === 1 && luna === 11) { setLuna(0); setAn(a => a + 1); } else setLuna(l => l + dir); }
  function schimbaSaptamana(dir) { const d = new Date(dataStart); d.setDate(d.getDate() + dir * 7); setDataStart(d); }
  function zileLuna(m, y) { const primaZi = new Date(y, m, 1).getDay(); const offset = primaZi === 0 ? 6 : primaZi - 1; const total = new Date(y, m + 1, 0).getDate(); const zile = []; for (let i = 0; i < offset; i++) zile.push(null); for (let i = 1; i <= total; i++) zile.push(i); while (zile.length % 7 !== 0) zile.push(null); return zile; }
  function toDateStr(d) { return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`; }

  const zileSapt = Array.from({length: 7}, (_, i) => { const d = new Date(dataStart); d.setDate(d.getDate() + i); return d; });
  const postariFiltrateCalendar = postari.filter(p => p.dataCalendar && (filtruClient === 'toti' || p.clientId === parseInt(filtruClient)) && (filtruRetea === 'toate' || p.retea === filtruRetea));
  const postariLuna = postariFiltrateCalendar.filter(p => { const [py, pm] = p.dataCalendar.split('-').map(Number); return pm - 1 === luna && py === an; });
  function postariPeZiLuna(zi) { return postariLuna.filter(p => parseInt(p.dataCalendar.split('-')[2]) === zi); }
  function postariPeZiSapt(dateStr) { return postariFiltrateCalendar.filter(p => p.dataCalendar === dateStr); }
  const zile = zileLuna(luna, an);
  const esteAziData = (d) => toDateStr(d) === toDateStr(azi);
  const esteAziZi = (zi) => zi === azi.getDate() && luna === azi.getMonth() && an === azi.getFullYear();
  const dataStartStr = dataStart.toLocaleDateString(getLocale(), { day: 'numeric', month: 'long' });
  const dataEndObj = new Date(dataStart); dataEndObj.setDate(dataEndObj.getDate() + 6);
  const dataEndStr = dataEndObj.toLocaleDateString(getLocale(), { day: 'numeric', month: 'long', year: 'numeric' });

  // Calendarul arata o postare O SINGURA DATA (pe telefon si, din 12 octombrie seara, si pe
  // calculator), cu retelele pe care pleaca adunate
  // dedesubt: in baza e cate un rand pe retea, iar pe un ecran ingust aceeasi postare aparea
  // de cinci ori. Se aduna dupa grup; postarile vechi, fara grup, raman fiecare pe randul ei.
  const peGrupuri = (lista) => {
    const grupuri = new Map();
    lista.forEach(p => { const cheie = p.grupId || `fara-${p.id}`; if (!grupuri.has(cheie)) grupuri.set(cheie, []); grupuri.get(cheie).push(p); });
    return [...grupuri.values()].sort((x, y) => String(x[0].oraCalendar || '').localeCompare(String(y[0].oraCalendar || '')));
  };
  // Miniatura unei postari (12 octombrie 2026): poza ei, sau coperta filmului. Un film fara
  // coperta primeste un semn de film, NU un cadru: ca sa arate un cadru, browserul ar descarca
  // o bucata din fiecare film din lista, pe date mobile si din traficul depozitului.
  const pozaDin = (x) => x.imagineUrl || x.copertaUrl || (Array.isArray(x.imaginiUrl) && typeof x.imaginiUrl[0] === 'string' ? x.imaginiUrl[0] : null);
  const miniatura = (lista, clasa = '') => {
    const cuPoza = lista.find(pozaDin);
    const areFilm = lista.some(x => x.videoUrl);
    if (!cuPoza && !areFilm) return null;
    return (
      <div className={`cal-mini ${clasa}`}>
        {cuPoza ? <img src={pozaDin(cuPoza)} alt="" loading="lazy" /> : <IconLinie nume="film" marime={22} />}
        {cuPoza && areFilm && <span className="cal-mini-film"><IconLinie nume="film" marime={12} /></span>}
      </div>
    );
  };
  const reteleGrup = (grup, marime) => grup.map(x => (
    <button key={x.id} type="button" className="cal-retea-icon" title={`${(RETELE.find(r => r.id === x.retea) || {}).label || x.retea}${x.format ? ` · ${x.format}` : ''}`} onClick={e => { e.stopPropagation(); setPostareSelectata(x); }}>
      <IconRetea id={x.retea} size={marime} />
    </button>
  ));
  const randMobil = (grup) => {
    const p = grup[0];
    const si = STATUS_INFO[p.status];
    return (
      <div key={p.id} className="cal-mobil-postare" style={{ borderLeft: `3px solid ${si.culoare}` }} onClick={() => setPostareSelectata(p)}>
        {miniatura(grup)}
        <div className="cal-mobil-postare-sus" style={{ color: si.culoare }}>{p.oraCalendar} · {t('status', p.status)}</div>
        <div className="cal-mobil-postare-jos"><strong>{p.client.split(' ')[0]}</strong> <span>{(grup.find(x => x.text) || p).text}</span></div>
        <div className="cal-mobil-retele">
          {grup.map(x => (
            <button key={x.id} type="button" className="cal-mobil-retea" onClick={e => { e.stopPropagation(); setPostareSelectata(x); }}>
              <IconRetea id={x.retea} size={12} /> {(RETELE.find(r => r.id === x.retea) || {}).label || x.retea}{x.format ? ` · ${x.format}` : ''}
            </button>
          ))}
        </div>
      </div>
    );
  };
  const grupuriZiAleasa = zile.includes(ziAleasa) ? peGrupuri(postariPeZiLuna(ziAleasa)) : [];
  // Banda saptamanii: mereu e o zi aleasa. Cea apasata, daca e in saptamana de pe ecran;
  // altfel azi; altfel prima zi cu postari; altfel luni.
  const zileSaptStr = zileSapt.map(toDateStr);
  const ziSaptEfectiva = zileSaptStr.includes(ziSaptAleasa) ? ziSaptAleasa
    : zileSaptStr.includes(toDateStr(azi)) ? toDateStr(azi)
    : (zileSaptStr.find(z => postariPeZiSapt(z).length > 0) || zileSaptStr[0]);
  const grupuriZiSapt = peGrupuri(postariPeZiSapt(ziSaptEfectiva));

  return (
    <div className="pagina">
      <div className="pagina-header"><div><h1 className="pagina-titlu">{t('calendar', 'calendarEditorial')}</h1><p className="pagina-subtitlu">{vedere === 'saptamana' ? `${dataStartStr} – ${dataEndStr}` : `${postariLuna.length} ${t('calendar', 'postariIn')} ${tArr('luni')[luna]} ${an}`}</p></div><button className="btn-principal" onClick={() => setPaginaActiva('compositor2')}>{t('calendar', 'postareNoua')}</button></div>
      <div className="calendar-controale">
        <div className="calendar-navigare"><button className="btn-nav-cal" onClick={() => vedere === 'saptamana' ? schimbaSaptamana(-1) : schimbaLuna(-1)}>‹</button><span className="calendar-luna-titlu">{vedere === 'saptamana' ? `${t('calendar', 'sapt')}${dataStartStr}` : `${tArr('luni')[luna]} ${an}`}</span><button className="btn-nav-cal" onClick={() => vedere === 'saptamana' ? schimbaSaptamana(1) : schimbaLuna(1)}>›</button></div>
        <div className="calendar-filtre">
          {clienti.length > 1 && (<select className="select-filtru" value={filtruClient} onChange={e => setFiltruClient(e.target.value)}><option value="toti">{t('calendar', 'totiClientii')}</option>{clienti.map(c => <option key={c.id} value={c.id}>{c.nume}</option>)}</select>)}
          <select className="select-filtru" value={filtruRetea} onChange={e => setFiltruRetea(e.target.value)}><option value="toate">{t('calendar', 'toateRetelele')}</option>{RETELE.map(r => <option key={r.id} value={r.id}>{r.label}</option>)}</select>
          <div className="vedere-tabs"><button className={`vedere-tab ${vedere === 'luna' ? 'activ' : ''}`} onClick={() => setVedere('luna')}>{t('calendar', 'lunar')}</button><button className={`vedere-tab ${vedere === 'saptamana' ? 'activ' : ''}`} onClick={() => setVedere('saptamana')}>{t('calendar', 'saptamanal')}</button></div>
        </div>
      </div>
      <div className="calendar-layout">
        {/* Calendarul de telefon (12 octombrie 2026). Grila de calculator are sapte coloane de
            112px, 800px in total: pe telefon incapeau trei zile si jumatate, iar azi ramanea
            ascunsa in dreapta. Aici: saptamana e o banda cu cele sapte zile, luna e o grila
            compacta; amandoua arata numarul de postari pe zi, iar ziua apasata isi arata lista dedesubt.
            Saptamana a fost intai o lista cu toate zilele una sub alta; Luminita a respins-o
            (prea lunga) si a ales banda de zile, ca la luna.
            Peste 768px nu se arata; sub 768px se ascunde grila mare (App.css). */}
        <div className="cal-mobil">
          {vedere === 'saptamana' && (<>
            <div className="cal-mobil-luna">
              {zileSapt.map((d, i) => {
                const ds = toDateStr(d);
                const nr = peGrupuri(postariPeZiSapt(ds)).length;
                return (
                  <button key={ds} type="button" className={`cal-mobil-zi ${esteAziData(d) ? 'azi' : ''} ${ziSaptEfectiva === ds ? 'aleasa' : ''}`} onClick={() => setZiSaptAleasa(ds)}>
                    <em>{tArr('zileScurt')[i]}</em><span>{d.getDate()}</span><small>{nr || ''}</small>
                  </button>
                );
              })}
            </div>
            <div className="cal-mobil-zi-bloc">
              <div className="cal-mobil-zi-titlu">{new Date(ziSaptEfectiva + 'T12:00:00').toLocaleDateString(getLocale(), { weekday: 'long', day: 'numeric', month: 'long' })}{ziSaptEfectiva === toDateStr(azi) ? ` · ${t('calendar', 'azi')}` : ''}</div>
              {grupuriZiSapt.length === 0 ? <div className="cal-mobil-gol">{t('calendar', 'nicioPostare')}</div> : grupuriZiSapt.map(randMobil)}
            </div>
          </>)}
          {vedere === 'luna' && (<>
            <div className="cal-mobil-luna">
              {tArr('zileScurt').map(z => <div key={z} className="cal-mobil-luna-cap">{z}</div>)}
              {zile.map((zi, idx) => zi
                ? <button key={idx} type="button" className={`cal-mobil-zi ${esteAziZi(zi) ? 'azi' : ''} ${ziAleasa === zi ? 'aleasa' : ''}`} onClick={() => setZiAleasa(zi)}><span>{zi}</span><small>{peGrupuri(postariPeZiLuna(zi)).length || ''}</small></button>
                : <div key={idx} />)}
            </div>
            {zile.includes(ziAleasa) && (
              <div className="cal-mobil-zi-bloc">
                <div className="cal-mobil-zi-titlu">{new Date(an, luna, ziAleasa).toLocaleDateString(getLocale(), { weekday: 'long', day: 'numeric', month: 'long' })}</div>
                {grupuriZiAleasa.length === 0 ? <div className="cal-mobil-gol">{t('calendar', 'nicioPostare')}</div> : grupuriZiAleasa.map(randMobil)}
              </div>
            )}
          </>)}
        </div>
        <div className="calendar-grid-wrapper">
          {vedere === 'saptamana' && (<>
            <div className="calendar-header-zile">{zileSapt.map((d, i) => <div key={i} className={`calendar-header-zi ${esteAziData(d) ? 'azi' : ''}`}><div className="cal-sapt-zi-name">{tArr('zileLung')[i]}</div><div className={`cal-sapt-zi-nr ${esteAziData(d) ? 'azi' : ''}`}>{d.getDate()}</div></div>)}</div>
            <div className="calendar-grid-sapt">{zileSapt.map((d, i) => { const dateStr = toDateStr(d); const pZi = postariPeZiSapt(dateStr); return <div key={i} className={`calendar-celula-sapt ${esteAziData(d) ? 'azi' : ''}`}>{pZi.length === 0 ? <div className="cal-sapt-gol">{t('calendar', 'nicioPostare')}</div> : peGrupuri(pZi).map(g => { const p = g[0]; const si = STATUS_INFO[p.status]; return <div key={p.id} className="cal-sapt-postare" style={{ background: si.bg, borderLeft: `3px solid ${si.culoare}` }} onClick={() => setPostareSelectata(p)}>{miniatura(g, 'lat')}<div className="cal-sapt-ora" style={{ color: si.culoare }}>{p.oraCalendar}</div><div className="cal-sapt-retea"><span style={{ color: si.culoare, fontWeight: 600, fontSize: 11 }}>{t('status', p.status)}</span></div><div className="cal-sapt-client">{p.client.split(' ')[0]}</div><div className="cal-sapt-text">{(g.find(x => x.text) || p).text}</div><div className="cal-retele-rand">{reteleGrup(g, 13)}</div></div>; })}</div>; })}</div>
          </>)}
          {vedere === 'luna' && (<>
            <div className="calendar-header-zile">{tArr('zileScurt').map(z => <div key={z} className="calendar-header-zi">{z}</div>)}</div>
            <div className="calendar-grid">{zile.map((zi, idx) => { const postariZi = zi ? peGrupuri(postariPeZiLuna(zi)) : []; return <div key={idx} className={`calendar-celula ${!zi ? 'gol' : ''} ${esteAziZi(zi) ? 'azi' : ''}`}>{zi && (<><div className={`calendar-nr-zi ${esteAziZi(zi) ? 'azi' : ''}`}>{zi}</div><div className="calendar-postari-zi">{postariZi.slice(0, 3).map(g => { const p = g[0]; const si = STATUS_INFO[p.status]; return <div key={p.id} className="calendar-postare-pill" style={{ background: si.bg, color: si.culoare, borderLeft: `3px solid ${si.culoare}` }} onClick={() => setPostareSelectata(p)}>{p.oraCalendar} · {p.client.split(' ')[0]} <span className="cal-retele-rand inline">{reteleGrup(g, 10)}</span></div>; })}{postariZi.length > 3 && <div className="calendar-mai-multe">+{postariZi.length - 3} {t('calendar', 'maiMulte')}</div>}</div></>)}</div>; })}</div>
          </>)}
        </div>
        {postareSelectata && (
          <div className="calendar-detaliu">
            <div className="detaliu-header"><div><div className="detaliu-client">{postareSelectata.client}</div><div className="detaliu-meta"><span className="retea-chip" style={{ background: RETELE.find(r => r.id === postareSelectata.retea)?.bg, color: RETELE.find(r => r.id === postareSelectata.retea)?.culoare }}><IconRetea id={postareSelectata.retea} size={12} /> {RETELE.find(r => r.id === postareSelectata.retea)?.label} · {postareSelectata.format}</span></div></div><button className="btn-inchide" onClick={() => setPostareSelectata(null)}>✕</button></div>
            {/* Filmul se vede aici, cu buton de pornire (pana pe 12 octombrie 2026 calendarul nu arata
                filme deloc). `preload="none"`: nu se descarca nimic pana nu apesi. */}
            {postareSelectata.videoUrl ? (
              <video key={postareSelectata.id} src={postareSelectata.videoUrl} poster={pozaDin(postareSelectata) || undefined} controls playsInline preload="none" style={{ display: 'block', width: '100%', maxHeight: 420, background: 'black', borderRadius: 10, marginBottom: 12 }} />
            ) : pozaDin(postareSelectata) && (
              <img src={pozaDin(postareSelectata)} alt="" loading="lazy" style={{ display: 'block', width: '100%', maxHeight: 280, objectFit: 'cover', borderRadius: 10, marginBottom: 12 }} />
            )}
            <div className="detaliu-text">{postareSelectata.text}</div>
            {postareSelectata.hashtags && <div style={{ color: '#1A6B3C', fontSize: 13, marginTop: 8 }}>{postareSelectata.hashtags}</div>}
            <div className="detaliu-info"><div className="detaliu-info-rand"><span className="detaliu-info-label">{t('calendar', 'data')}</span><span className="detaliu-info-val">{postareSelectata.dataCalendar}</span></div><div className="detaliu-info-rand"><span className="detaliu-info-label">{t('calendar', 'ora')}</span><span className="detaliu-info-val">{postareSelectata.oraCalendar}</span></div><div className="detaliu-info-rand"><span className="detaliu-info-label">{t('calendar', 'status')}</span><span className="aprobare-status-badge" style={{ background: STATUS_INFO[postareSelectata.status].bg, color: STATUS_INFO[postareSelectata.status].culoare }}>{t('status', postareSelectata.status)}</span></div></div>
            {postareSelectata.status !== 'publicat' && (
              <div className="calendar-detaliu-actiuni"><button className="btn-secundar" style={{ width: '100%' }} onClick={() => deschidePostarea(postareSelectata, setPaginaActiva, setPostareEdit)}>{t('calendar', 'editeaza')}</button></div>
            )}
          </div>
        )}
      </div>
      {/* Legenda de stari de sub calendar a iesit pe 12 octombrie 2026, si pe telefon, si pe
          calculator (ceruta de Luminita). Starea e scrisa cu vorbe pe fiecare postare. */}
    </div>
  );
}

// ============================================================
// Interfata contului de client, refacuta (16 septembrie 2026, INTERFATA_CLIENT_PLAN.md,
// repriza 2). Decizia Luminitei: clientul vede ce vede agentia cand da clic pe el,
// fara „Clienti" in meniu, totul pe clientul lui.
//
// - Bifele din fisa ascund intrarile (decizia 1a); „De aprobat" si conturile se vad mereu.
// - Fara profil de voce (2a) si fara „Echipa" (3a).
// - Pornirea e pagina clientului (PaginaClient), ca la agentie. Ecranul vechi „Acasa",
//   cu cifre si butoane, a iesit odata cu tab-urile lui (Aprobare, Publicate, Ciorne).
// - Clic pe o postare deschide grupul in compozitorul nou; postarile vechi, fara grup,
//   nu au unde se deschide aici (compozitorul vechi nu mai e al nimanui).
// ============================================================
function InterfataClient({ nume, clientId, onLogout, postari, setPostari, mesaje, setMesaje, permisiuniClient, clientLogat, sesiune, profilUtilizator }) {
  const [pagina, setPagina] = useState(() => (grupDinAdresa() ? 'compositor2' : 'client'));
  // `n` remonteaza pagina clientului, ca „De aprobat" din meniu sa deschida tab-ul chiar
  // daca pagina e deja pe ecran.
  const [tabPagina, setTabPagina] = useState({ tab: 'toate', n: 0 });
  const [biblioteca, setBiblioteca] = useState({});
  const p = permisiuniClient || {};
  const idClient = Number(clientId);
  const postariClient = postari.filter(x => Number(x.clientId) === idClient);
  // Doua directii, doua numere (20 septembrie 2026): „De aprobat" e ce trebuie sa aprobe
  // clientul, adica ce i-a trimis agentia; „Trimise la aprobare" e ce a trimis el si
  // asteapta la New Mind.
  const nrAprobare = postariClient.filter(x => x.status === 'aprobare_finala').length;
  const nrTrimise = postariClient.filter(x => x.status === 'intern').length;
  const clientiLista = clientLogat ? [clientLogat] : [];

  // Daca bifa unei intrari se scoate, ecranul ei nu mai ramane deschis. Compozitorul se
  // poate deschide si fara „poate crea postari", dar doar pe un grup existent (aprobarea).
  const permise = {
    client: true,
    compositor2: !!p.poate_crea_postari || !!grupDinAdresa(),
    calendar: !!p.vede_calendar,
    inbox: !!p.vede_inbox,
    analize: !!p.vede_analytics_complet,
    biblioteca: !!p.vede_biblioteca_media,
    asistent: true,
    teme: !!p.vede_temele_zilei,
  };
  const paginaPermisa = !!permise[pagina];
  useEffect(() => { if (!paginaPermisa) setPagina('client'); }, [paginaPermisa]);

  function mergi(id) {
    if (id === 'aprobare' || id === 'trimise' || id === 'client' || id === 'conturi') {
      setTabPagina(prev => ({
        tab: id === 'aprobare' ? 'de_aprobat' : id === 'trimise' ? 'trimise' : 'toate',
        n: prev.n + 1,
      }));
      setPagina('client');
      // „Conturi conectate" duce la randul de conturi al paginii (inainte clicul nu facea
      // nimic vizibil cand pagina era deja deschisa).
      if (id === 'conturi') {
        setTimeout(() => {
          const rand = document.querySelector('.conturi-rand');
          if (rand) rand.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 150);
      }
      return;
    }
    setPagina(id);
  }

  function deschideGrup(postare) {
    if (!postare || !postare.grupId) return;
    const adresa = new URL(window.location.href);
    adresa.searchParams.set('grup', postare.grupId);
    window.history.replaceState(window.history.state, '', adresa.pathname + adresa.search + adresa.hash);
    setPagina('compositor2');
  }

  const meniu = [
    // „Acasa" = pagina clientului (cerut de Luminita, 16 sept 2026).
    { id: 'client', label: t('sidebar', 'acasa'), icon: '🏠' },
    p.poate_crea_postari && { id: 'compositor2', label: t('sidebar', 'postareNoua'), icon: '✏️' },
    p.vede_calendar && { id: 'calendar', label: t('sidebar', 'calendar'), icon: '📅' },
    p.vede_inbox && { id: 'inbox', label: t('sidebar', 'inbox'), icon: '💬' },
    { id: 'aprobare', label: t('sidebar', 'deAprobat'), icon: '✅', badge: nrAprobare },
    { id: 'trimise', label: t('sidebar', 'trimiseAprobare'), icon: '📤', badge: nrTrimise },
    p.vede_analytics_complet && { id: 'analize', label: t('sidebar', 'analize'), icon: '📊' },
  ].filter(Boolean);
  const activ = pagina === 'client' && tabPagina.tab === 'de_aprobat' ? 'aprobare'
    : pagina === 'client' && tabPagina.tab === 'trimise' ? 'trimise'
    : pagina;

  const sectiuni = [
    { id: 'conturi', icon: '🔌', label: t('sidebar', 'conturiConectate'), onClick: () => mergi('conturi') },
    p.vede_biblioteca_media && { id: 'biblioteca', icon: '🖼️', label: t('sidebar', 'bibliotecaMedia'), onClick: () => setPagina('biblioteca') },
    // Temele zilei (15 oct 2026): doar cu bifa pusa de super admin; clientul vede, nu alege.
    p.vede_temele_zilei && { id: 'teme', icon: '📰', label: t('sidebar', 'temeleZilei'), onClick: () => setPagina('teme') },
    // Priza clientului (12 oct 2026, PRIZA_CLIENTI_PLAN.md): mereu la indemana; ce poate cheia tine de bifele din fisa.
    { id: 'asistent', icon: '🔑', label: t('sidebar', 'asistent'), onClick: () => setPagina('asistent') },
  ].filter(Boolean);

  return (
    <div className="app">
      <div className="sidebar">
        <div className="logo" style={{ cursor: 'pointer' }} onClick={() => mergi('client')}><div className="logo-nm">NM</div><div className="logo-social">Social</div></div>
        <nav className="nav">
          {meniu.map(item => (
            <button key={item.id} className={`nav-item ${activ === item.id ? 'activ' : ''}`} onClick={() => mergi(item.id)}>
              <span className="nav-icon"><IconMeniu id={item.id} /></span><span>{item.label}</span>
              {item.badge > 0 && <span className="nav-badge">{item.badge}</span>}
            </button>
          ))}
        </nav>
        {/* Fara cartonul cu numele clientului (cerut de Luminita): numele sta sus, pe pagina. */}
        <div className="bloc-client">
          <div className="bloc-client-sectiuni">
            {sectiuni.map(s => (
              <button key={s.id} className="bloc-client-sectiune" onClick={s.onClick}>
                <span className="bloc-client-sectiune-icon"><IconMeniu id={s.id} marime={16} /></span>
                <span>{s.label}</span>
              </button>
            ))}
          </div>
        </div>
        <div className="user-info">
          <div className="user-avatar">{(nume || '?').charAt(0)}</div>
          <div style={{ flex: 1 }}><div className="user-nume">{nume}</div><div className="user-rol">{t('sidebar', 'client')}</div></div>
          <button onClick={onLogout} title={t('sidebar', 'iesiDinCont')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#4B5563', display: 'flex', padding: 4 }}><IconLinie nume="iesire" marime={18} /></button>
        </div>
        <div style={{ padding: '0 16px 12px', fontSize: 11, color: '#9CA3AF', textAlign: 'center', lineHeight: 1.5 }}>
          <a href={legal('confidentialitate')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{t('sidebar', 'confidentialitate')}</a>
          {' · '}
          <a href={legal('termeni')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{t('sidebar', 'termeniConditii')}</a>
          {' · '}
          <a href={legal('stergere')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{t('sidebar', 'stergereaDatelor')}</a>
          {' · '}
          <a href={legal('cookies')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{t('sidebar', 'cookies')}</a>
        </div>
      </div>
      <div className="continut-principal">
        {/* Numele clientului sus pe fiecare ecran din meniu; pagina clientului il are in antet. */}
        {pagina !== 'client' && clientLogat && (
          <div style={{ padding: '18px 40px 0', fontFamily: "'DM Serif Display', serif", fontSize: 22, color: '#0F3D22' }}>
            {clientLogat.nume}
            {clientLogat.functie && (
              <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: '#4B5563', marginLeft: 10 }}>
                {[clientLogat.functie, clientLogat.localitate].filter(Boolean).join(' · ')}
              </span>
            )}
          </div>
        )}
        {pagina === 'client' && clientLogat && (
          <PaginaClient
            key={tabPagina.n}
            tabInitial={tabPagina.tab}
            client={clientLogat}
            esteClient
            inapoiLaClienti={null}
            iconRetea={(id, size) => <IconRetea id={id} size={size} />}
            postari={postari}
            statusInfo={STATUS_INFO}
            retele={RETELE}
            deschideGrup={deschideGrup}
            setPostari={setPostari}
          />
        )}
        {pagina === 'compositor2' && (
          <CompozitorV2 clienti={clientiLista} clientPreSelectat={clientLogat ? clientLogat.id : null} sesiune={sesiune} profilUtilizator={profilUtilizator} setPostari={setPostari} normalizeaza={normalizeazaPostare} permisiuniClient={permisiuniClient} />
        )}
        {pagina === 'calendar' && (
          <Calendar postari={postariClient} clienti={clientiLista} doarPublicateProgramate setPaginaActiva={(x) => { if (x === 'compositor2') setPagina('compositor2'); }} setPostareEdit={() => {}} />
        )}
        {pagina === 'inbox' && (
          // Clientul a ramas pe Inboxul vechi pana pe 20 septembrie 2026, desi agentia trecuse pe
          // V3 din 18: doua ecrane diferite, cu doua socoteli diferite ale necititelor (vechiul
          // `mesaje.citit`, noul `inbox_vizite`). Gasit de Luminita, intrand cu contul de recenzor.
          <InboxV3
            clientPreSelectat={clientLogat ? clientLogat.id : null}
            sesiune={sesiune}
            rol="client"
            poateRaspunde={!!p.raspunde_inbox}
            poateBot={!!p.raspunde_inbox && !!p.poate_bot_comentarii}
            poateAnunturi={!!p.raspunde_inbox && !!p.poate_anunturi_abonati}
            poateDescarca={!!p.raspunde_inbox && !!p.poate_descarca_lista}
          />
        )}
        {pagina === 'analize' && <Analize clienti={clientiLista} />}
        {pagina === 'biblioteca' && <Biblioteca clienti={clientiLista} biblioteca={biblioteca} setBiblioteca={setBiblioteca} />}
        {pagina === 'asistent' && <CheiPriza rol="client" clienti={clientiLista} permisiuni={p} />}
        {pagina === 'teme' && clientLogat && <TemeleZilei client={clientLogat} rol="client" />}
      </div>
      <BaraSusMobil onClick={() => mergi('client')} />
      {/* Pe telefon (11 octombrie 2026): in bara raman Acasa, De aprobat, Postare (daca are voie)
          si Trimise; Calendar, Inbox, Analize si blocul de sectiuni urca in foaia „Mai mult",
          impreuna cu iesirea din cont, care pana azi nu exista deloc pe telefon. */}
      <BaraJosMobil
        intrari={['client', 'aprobare', 'compositor2', 'trimise']
          .map(id => meniu.find(i => i.id === id)).filter(Boolean)
          .map(i => ({ id: i.id, label: i.id === 'compositor2' ? t('sidebar', 'postare') : i.id === 'trimise' ? t('sidebar', 'trimise') : i.label, icon: { client: 'acasa', aprobare: 'aprobari', compositor2: 'plus', trimise: 'trimise' }[i.id], central: i.id === 'compositor2', badge: i.badge, activ: activ === i.id, onClick: () => mergi(i.id) }))}
        restul={[
          ...meniu.filter(i => ['calendar', 'inbox', 'analize'].includes(i.id)).map(i => ({ id: i.id, label: i.label, icon: i.id, activ: activ === i.id, onClick: () => mergi(i.id) })),
          ...sectiuni.map(sc => ({ id: sc.id, label: sc.label, icon: sc.id, activ: pagina === sc.id, onClick: sc.onClick })),
        ]}
        onLogout={onLogout}
      />
    </div>
  );
}

function Echipa({ clienti, clientFiltru = null }) {
  const [manageri, setManageri] = useState([]);
  const [asignari, setAsignari] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInvita, setShowInvita] = useState(false);
  const [managerSelectat, setManagerSelectat] = useState(null);
  const [emailInvitatie, setEmailInvitatie] = useState('');
  const [numeInvitatie, setNumeInvitatie] = useState('');
  const [trimitereInvitatie, setTrimitereInvitatie] = useState(false);
  const [eroare, setEroare] = useState('');
  const [succes, setSucces] = useState('');
 
  useEffect(() => {
    incarcaEchipa();
  }, []);
  // Pe un client ales: doar managerii lui (decizia 2a, 16 sept 2026).
  const manageriAfisati = clientFiltru
    ? manageri.filter(m => asignari.some(a => a.manager_id === m.user_id && a.client_id === clientFiltru.id))
    : manageri;
 
  async function incarcaEchipa() {
    setLoading(true);
    try {
      // Încărcăm toți utilizatorii cu rol manager
      const { data: profiluri, error: errP } = await supabase
        .from('profiluri')
        .select('user_id, nume, email')
        .eq('rol', 'manager');
      if (errP) throw errP;
 
      // Încărcăm asignările
      const { data: asignariDB, error: errA } = await supabase
        .from('manager_clienti')
        .select('*');
      if (errA) throw errA;
 
      setManageri(profiluri || []);
      setAsignari(asignariDB || []);
    } catch (err) {
      console.error('Eroare încărcare echipă:', err);
    } finally {
      setLoading(false);
    }
  }
 
  async function invitaManager() {
  if (!emailInvitatie || !numeInvitatie) return;
  setTrimitereInvitatie(true);
  setEroare('');
  setSucces('');
  try {
    // Contul si profilul se fac pe server (`invita-cont`, 9 octombrie 2026).
    const invitatie = await invitaCont({ email: emailInvitatie.trim().toLowerCase(), nume: numeInvitatie, rol: 'manager' });
    if (!invitatie.ok) { setEroare(invitatie.mesaj); return; }

    setSucces(t('echipa', 'invitatieTrimisa', { email: emailInvitatie }));
    await incarcaEchipa();
    setEmailInvitatie('');
    setNumeInvitatie('');
    setShowInvita(false);
  } catch (err) {
    setEroare(t('echipa', 'eroarePrefix') + err.message);
  } finally {
    setTrimitereInvitatie(false);
  }
}
 
  async function toggleAsignare(managerId, clientId) {
    const existaAsignare = asignari.find(a => a.manager_id === managerId && a.client_id === clientId);
    try {
      if (existaAsignare) {
        // Dezasignăm
        const { error } = await supabase
          .from('manager_clienti')
          .delete()
          .eq('manager_id', managerId)
          .eq('client_id', clientId);
        if (error) throw error;
        setAsignari(prev => prev.filter(a => !(a.manager_id === managerId && a.client_id === clientId)));
      } else {
        // Asignăm
        const { data, error } = await supabase
          .from('manager_clienti')
          .insert({ manager_id: managerId, client_id: clientId })
          .select()
          .single();
        if (error) throw error;
        setAsignari(prev => [...prev, data]);
      }
    } catch (err) {
      alert(t('echipa', 'eroarePrefix') + err.message);
    }
  }
 
  function clientiManager(managerId) {
    return asignari
      .filter(a => a.manager_id === managerId)
      .map(a => clienti.find(c => c.id === a.client_id))
      .filter(Boolean);
  }
 
  if (loading) return (
    <div className="pagina">
      <div className="pagina-gol"><div className="pagina-gol-icon">⏳</div><p>{t('echipa', 'seIncarcaEchipa')}</p></div>
    </div>
  );
 
  return (
    <div className="pagina">
      <div className="pagina-header">
        <div>
          <h1 className="pagina-titlu">{t('echipa', 'echipa')}</h1>
          <p className="pagina-subtitlu">{manageriAfisati.length} {t('echipa', 'manageriActivi')}</p>
        </div>
        <button className="btn-principal" onClick={() => setShowInvita(true)}>{t('echipa', 'invitaManager')}</button>
      </div>
 
      {succes && (
        <div style={{ background: '#D4EDE0', color: '#1A6B3C', borderRadius: 10, padding: '12px 16px', marginBottom: 20, fontSize: 14 }}>
          {succes}
        </div>
      )}
 
      {manageriAfisati.length === 0 ? (
        <div className="pagina-gol">
          <div className="pagina-gol-icon">👥</div>
          <p>{t('echipa', 'niciunManager')}</p>
        </div>
      ) : (
        <div className="lista-manageri">
          {manageriAfisati.map(manager => {
            const clientiAsignati = clientiManager(manager.user_id);
            const esteSelectat = managerSelectat === manager.user_id;
            return (
              <div key={manager.user_id} className="card-manager">
                <div className="card-manager-header" onClick={() => setManagerSelectat(esteSelectat ? null : manager.user_id)}>
                  <div className="manager-avatar">{(manager.nume || manager.email || 'M').charAt(0).toUpperCase()}</div>
                  <div className="manager-info">
                    <div className="manager-nume">{manager.nume || t('echipa', 'faraNume')}</div>
                    <div className="manager-email">{manager.email || '—'}</div>
                  </div>
                  <div className="manager-clienti-nr">
                    <span className="badge-clienti">{clientiAsignati.length} {t('echipa', 'clienti')}</span>
                  </div>
                  <div className="manager-expand">{esteSelectat ? '▲' : '▼'}</div>
                </div>
 
                {clientiAsignati.length > 0 && !esteSelectat && (
                  <div className="manager-clienti-preview">
                    {clientiAsignati.map(c => (
                      <span key={c.id} className="retea-chip" style={{ background: '#F2F8F4', color: '#1A6B3C' }}>
                        {c.nume}
                      </span>
                    ))}
                  </div>
                )}
 
                {esteSelectat && (
                  <div className="manager-asignare">
                    <div className="manager-asignare-titlu">{t('echipa', 'asigneazaClienti')}</div>
                    <div className="manager-clienti-lista">
                      {clienti.filter(c => c.status === 'activ').map(client => {
                        const asignat = asignari.some(a => a.manager_id === manager.user_id && a.client_id === client.id);
                        return (
                          <div key={client.id} className="manager-client-row" onClick={() => toggleAsignare(manager.user_id, client.id)}>
                            <div className={`manager-client-check ${asignat ? 'activ' : ''}`}>
                              {asignat ? '✓' : ''}
                            </div>
                            <div className="manager-client-avatar">{client.nume.charAt(0)}</div>
                            <div>
                              <div className="manager-client-nume">{client.nume}</div>
                              <div className="manager-client-functie">{client.functie} · {client.localitate}</div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
 
      {showInvita && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <div className="modal-titlu">{t('echipa', 'invitaManagerNou')}</div>
              <button className="btn-inchide" onClick={() => { setShowInvita(false); setEroare(''); }}>✕</button>
            </div>
            <div className="modal-sectiune">
              <div className="modal-camp">
                <label className="label">{t('echipa', 'numeComplet')}</label>
                <input type="text" className="select-input" placeholder={t('echipa', 'numePlaceholder')} value={numeInvitatie} onChange={e => setNumeInvitatie(e.target.value)} />
              </div>
              <div className="modal-camp">
                <label className="label">{t('echipa', 'email')}</label>
                <input type="email" className="select-input" placeholder={t('echipa', 'emailPlaceholder')} value={emailInvitatie} onChange={e => setEmailInvitatie(e.target.value)} />
              </div>
              {eroare && <div style={{ color: '#DC2626', fontSize: 13, marginTop: 8 }}>{eroare}</div>}
            </div>
            <div className="modal-actiuni">
              <button className="btn-principal" onClick={invitaManager} disabled={trimitereInvitatie || !emailInvitatie || !numeInvitatie}>
                {trimitereInvitatie ? t('echipa', 'seTrimite') : t('echipa', 'trimiteInvitatie')}
              </button>
              <button className="btn-secundar" onClick={() => setShowInvita(false)}>{t('echipa', 'anuleaza')}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
// ============================================================
// ADAUGĂ această funcție în App.js înainte de export default App
// ============================================================

function InterfataManager({ sesiune, profilUtilizator, onLogout, postari, setPostari, mesaje, setMesaje, biblioteca, setBiblioteca }) {
  const [clientiManager, setClientiManager] = useState([]);
  const [loading, setLoading] = useState(true);
  // Un grup din compozitorul nou in adresa (?grup=) redeschide compozitorul dupa F5.
  const [paginaActiva, setPaginaActiva] = useState(() => (grupDinAdresa() ? 'compositor2' : 'acasa'));
  const [clientPagina, setClientPagina] = useState(null);
  const [postareEdit, setPostareEdit] = useState(null);
  const [profiluri] = useState({});
  // Clientul ales, ca la super_admin, dar numai dintre clientii managerului, tinut
  // minte separat pentru fiecare utilizator. Aici sesiunea e deja cunoscuta.
  const [clientAlesId, setClientAlesIdStare] = useState(() => clientAlesDinBrowser(sesiune?.user?.id));
  function setClientAles(id) { setClientAlesIdStare(id); scrieClientAles(sesiune?.user?.id, id); }
  // Cu ce tab se deschide pagina clientului, cand se intra din blocul din meniu.
  const [, setTabClient] = useState('postari');

  useEffect(() => {
    incarcaClientiManager();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function incarcaClientiManager() {
    setLoading(true);
    try {
      const { data: asignari, error } = await supabase
        .from('manager_clienti')
        .select('client_id')
        .eq('manager_id', sesiune.user.id);
      if (error) throw error;

      const clientIds = (asignari || []).map(a => a.client_id);
      if (clientIds.length === 0) { setClientiManager([]); return; }

      const { data: clientiReali, error: errClienti } = await supabase
        .from('clienti')
        .select('*')
        .in('id', clientIds)
        .order('created_at', { ascending: false });
      if (errClienti) throw errClienti;

      setClientiManager(clientiReali || []);
    } catch (err) {
      console.error('Eroare încărcare clienți manager:', err);
      setClientiManager([]);
    } finally {
      setLoading(false);
    }
  }

  // Clic pe un client îl face clientul ales și îi deschide pagina (decizia 5a).
  function deschideClient(client) { setClientAles(client.id); setTabClient('postari'); setClientPagina(client); setPaginaActiva('profil_client'); }
  function inapoiLaClienti() { setClientPagina(null); setPaginaActiva('clienti'); }
  // Acelasi drum din meniu pentru sidebar si pentru bara de jos de pe telefon.
  function mergiDinMeniuM(id) { setClientPagina(null); setPostareEdit(null); if (id === 'acasa') setClientAles(null); setPaginaActiva(id); }

  // Clopotelul managerului: alertele clientilor lui (aprobarea prin link, pasul 6).
  const [cheieCompozitor, setCheieCompozitor] = useState(0);
  const alerte = useAlerte(true);
  const clopotel = mobil => (
    <ClopotelAlerte alerte={alerte} mobil={mobil}
      onDeschide={(g, p) => { setClientPagina(null); setPostareEdit(null); deschideGrupul(g, setPaginaActiva, setCheieCompozitor, p); }} />
  );

  // Un manager vede doar clienții lui: clientul ales se ia din lista LUI, deci
  // un id rămas în browser de la alt cont nu-i deschide nimic strein.
  const clientAlesObiect = clientiManager.find(c => c.id === clientAlesId) || null;
  const clientiVizibili = clientAlesObiect ? [clientAlesObiect] : clientiManager;
  const alClientilor = (lista) => lista.filter(x => clientiVizibili.some(c => c.id === x.clientId));
  const postariVizibile = alClientilor(postari);
  const postariManager = postari.filter(p => clientiManager.some(c => c.id === p.clientId));

  const nrAprobare = postariVizibile.filter(p =>
    ['aprobare_finala', 'intern'].includes(p.status)
  ).length;

  // Meniul nou (pasul 5), la fel ca la super_admin: „Bibliotecă media" coboară în
  // blocul clientului, „Aprobare" devine „De aprobat".
  const meniu = [
    { id: 'acasa',      label: t('sidebar', 'acasa'),             icon: '🏠' },
    // Faza 7: compozitorul nou, ca la super_admin.
    { id: 'compositor2', label: t('sidebar', 'postareNoua'),      icon: '✏️' },
    { id: 'clienti',    label: t('sidebar', 'clientiiMei'),     icon: '👥' },
    { id: 'calendar',   label: t('sidebar', 'calendar'),          icon: '📅' },
    { id: 'inbox',      label: t('sidebar', 'inbox'),             icon: '💬' },
    { id: 'aprobare',   label: t('sidebar', 'deAprobat'),         icon: '✅', badge: nrAprobare },
    { id: 'aprobate',   label: t('sidebar', 'aprobate'),          icon: '👍', badge: postariVizibile.filter(p => p.status === 'aprobat').length },
    clientAlesObiect && { id: 'analize',    label: t('sidebar', 'analize'),           icon: '📊' },
  ].filter(Boolean);

  const paginaCereClientM = paginaActiva === 'analize' || paginaActiva === 'voce' || paginaActiva === 'teme';
  useEffect(() => {
    if (paginaCereClientM && !clientAlesObiect && clientiManager.length) setPaginaActiva('acasa');
  }, [paginaCereClientM, clientAlesObiect, clientiManager.length]);

  const numeContM = (profilUtilizator && profilUtilizator.nume) || 'Manager';

  // Managerul n-are „Echipă”; restul, la fel ca la super_admin. Aceeasi lista hraneste si
  // foaia „Mai mult” de pe telefon.
  const sectiuniManager = [
    { id: 'conturi',    icon: '🔌', label: t('sidebar', 'conturiConectate'), cereClient: true, onClick: () => { if (clientAlesObiect) { setTabClient('postari'); setClientPagina(clientAlesObiect); setPaginaActiva('profil_client'); } } },
    { id: 'voce',       icon: '🗣️', label: t('sidebar', 'profilDeVoce'),     cereClient: true, onClick: () => { if (clientAlesObiect) { setClientPagina(null); setPaginaActiva('voce'); } } },
    { id: 'teme',       icon: '📰', label: t('sidebar', 'temeleZilei'),      cereClient: true, onClick: () => { if (clientAlesObiect) { setClientPagina(null); setPaginaActiva('teme'); } } },
    { id: 'biblioteca', icon: '🖼️', label: t('sidebar', 'bibliotecaMedia'),  onClick: () => { setClientPagina(null); setPaginaActiva('biblioteca'); } },
    // Priza managerului (12 oct 2026, PRIZA_CLIENTI_PLAN.md): isi face singur cheia, pe clientii lui.
    { id: 'asistent',   icon: '🔑', label: t('sidebar', 'asistent'),         onClick: () => { setClientPagina(null); setPaginaActiva('asistent'); } },
  ];

  if (loading) return <EcranAsteptare text={t('stare', 'seIncarca')} />;

  return (
    <div className="app">
      <BaraSusMobil onClick={() => mergiDinMeniuM('acasa')} nume={numeContM} rol={t('sidebar', 'managerCont')} clopotel={clopotel(true)} />
      {/* Sidebar manager — identic cu admin dar fără Echipă */}
      <div className="sidebar">
        <div className="logo" style={{ display: 'flex', alignItems: 'center' }}>
          <div className="logo-nm">NM</div><div className="logo-social">Social</div>
          <div style={{ marginLeft: 'auto' }}>{clopotel(false)}</div>
        </div>
        <nav className="nav">
          {meniu.map(item => (
            <button key={item.id} className={`nav-item ${paginaActiva === item.id ? 'activ' : ''}`}
              onClick={() => mergiDinMeniuM(item.id)}>
              <span className="nav-icon"><IconMeniu id={item.id} /></span>
              <span>{item.label}</span>
              {item.badge > 0 && <span className="nav-badge">{item.badge}</span>}
            </button>
          ))}
        </nav>
        <BlocClient
          fix
          onDeschide={() => clientAlesObiect && deschideClient(clientAlesObiect)}
          clienti={clientiManager}
          clientAles={clientAlesObiect}
          setClientAles={setClientAles}
          postari={postariManager}
          sectiuni={sectiuniManager}
        />
        <div className="user-info">
          <div className="user-avatar">{String(numeContM || 'M').trim().charAt(0).toUpperCase()}</div>
          <div style={{ flex: 1 }}>
            <div className="user-nume">{numeContM}</div>
            <div className="user-rol">{t('sidebar', 'managerCont')}</div>
          </div>
          <button onClick={onLogout} title={t('sidebar', 'iesiDinCont')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#4B5563', display: 'flex', padding: 4 }}><IconLinie nume="iesire" marime={18} /></button>
        </div>
        <div style={{ padding: '0 16px 12px', fontSize: 11, color: '#9CA3AF', textAlign: 'center', lineHeight: 1.5 }}>
          <a href={legal('confidentialitate')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{t('sidebar', 'confidentialitate')}</a>
          {' · '}
          <a href={legal('termeni')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{t('sidebar', 'termeniConditii')}</a>
          {' · '}
          <a href={legal('stergere')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{t('sidebar', 'stergereaDatelor')}</a>
          {' · '}
          <a href={legal('cookies')} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>{t('sidebar', 'cookies')}</a>
        </div>
      </div>

      {/* Pana pe 19 septembrie 2026 managerul n-avea nicio bara pe telefon: sidebar-ul
          e ascuns sub 768px, iar aici nu se randa nimic in locul lui. */}
      <MobileNavbar paginaActiva={paginaActiva} setPaginaActiva={mergiDinMeniuM} postari={postariVizibile} sectiuni={sectiuniManager} clientAles={clientAlesObiect} onLogout={onLogout} />

      <div className="continut-principal">
        <div className="antet-sus">
          <AntetClientAles client={clientAlesObiect} pagina={paginaActiva} />
          <SemnCont nume={numeContM} rol={t('sidebar', 'managerCont')} />
        </div>
        {paginaActiva === 'acasa' && (
          <PaginaAcasa clienti={clientiManager} postari={postari} onStergeGrup={(grup) => stergeGrupPostari(grup, setPostari)} retele={RETELE} statusInfo={STATUS_INFO} iconRetea={(id, size) => <IconRetea id={id} size={size} />} deschideGrup={(p) => deschidePostarea(p, setPaginaActiva, setPostareEdit)} deschideClient={deschideClient} />
        )}
        {paginaActiva === 'voce' && clientAlesObiect && <ProfilVoce client={clientAlesObiect} />}
        {paginaActiva === 'teme' && clientAlesObiect && <TemeleZilei client={clientAlesObiect} rol="manager" />}
        {paginaActiva === 'clienti' && (
          <div className="pagina">
            <div className="pagina-header">
              <div>
                <h1 className="pagina-titlu">{t('clientiManager', 'clientiiMei')}</h1>
                <p className="pagina-subtitlu">{t('clientiManager', 'clientiActivi', { n: clientiManager.filter(c => c.status === 'activ').length })}</p>
              </div>
            </div>
            {clientiManager.length === 0 ? (
              <div className="pagina-gol">
                <div className="pagina-gol-icon">👥</div>
                <p>{t('clientiManager', 'niciunClient')}</p>
              </div>
            ) : (
              <div className="lista-clienti">
                {clientiManager.map(client => (
                  <div key={client.id} className="card-client" onClick={() => deschideClient(client)}>
                    <div className="card-client-header">
                      <AvatarClient clientId={client.id} nume={client.nume} />
                      <div className="client-info">
                        <div className="client-nume">{client.nume}</div>
                        <div className="client-functie">{client.functie} · {client.localitate}</div>
                      </div>
                      <div className="card-client-dreapta">
                        {postari.filter(p => p.clientId === client.id && ['aprobare_finala', 'intern'].includes(p.status)).length > 0 && (
                          <div className="card-client-aprobat">
                            {t('sidebar', 'deAprobatN', { n: postari.filter(p => p.clientId === client.id && ['aprobare_finala', 'intern'].includes(p.status)).length })}
                          </div>
                        )}
                        <div className={`status-badge ${client.status}`}>{client.status === 'activ' ? 'Activ' : 'Inactiv'}</div>
                        {profiluri[client.id] && <div className="profil-badge">📄 {t('clientiManager', 'profilIncarcat')}</div>}
                      </div>
                    </div>
                    <div className="card-client-footer">
                      <div className="retele">
                        {(client.retele || []).map(r => { const retea = RETELE.find(x => x.id === r); return <span key={r} className="retea-icon-wrap" style={{ background: retea?.bg }}><IconRetea id={r} size={14} /></span>; })}
                      </div>
                      <div className="postari-info"><span className="postari-numar">{cifrePostariClient(postari, client.id).luna}</span> {t('clientiManager', 'postariLunaAceasta')}</div>
                      <div className="ultima-postare">{t('clienti', 'ultima')}{cifrePostariClient(postari, client.id).ultima}</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {paginaActiva === 'profil_client' && clientPagina && (
          <PaginaClient
            client={clientPagina}
            inapoiLaClienti={inapoiLaClienti}
            iconRetea={(id, size) => <IconRetea id={id} size={size} />}
            postari={postari}
            statusInfo={STATUS_INFO}
            retele={RETELE}
            deschideGrup={(p) => deschidePostarea(p, setPaginaActiva, setPostareEdit)}
            setPostari={setPostari}
            onStergeGrup={(grup) => stergeGrupPostari(grup, setPostari)}
            onDrepturiSalvate={(perm) => {
              setClientiManager(prev => prev.map(c => (c.id === clientPagina.id ? { ...c, permisiuni_client: perm } : c)));
              setClientPagina(prev => (prev ? { ...prev, permisiuni_client: perm } : prev));
            }}
          />
        )}

        {paginaActiva === 'compositor' && (
          <Compositor
            clienti={clientiManager}
            profiluri={profiluri}
            clientPreSelectat={clientPagina || clientAlesObiect}
            biblioteca={biblioteca}
            setPostari={setPostari}
            sesiune={sesiune}
            profilUtilizator={profilUtilizator}
            postareEdit={postareEdit}
            setPostareEdit={setPostareEdit}
            setPaginaActiva={setPaginaActiva}
          />
        )}

        {/* Intrarea din meniu exista din 15 septembrie, dar pagina lipsea: managerul
            dadea peste un ecran gol. */}
        {paginaActiva === 'compositor2' && compozitorV2Vizibil && (
          <CompozitorV2
            key={cheieCompozitor}
            clienti={clientiManager}
            clientPreSelectat={clientAlesObiect ? clientAlesObiect.id : null}
            sesiune={sesiune}
            profilUtilizator={profilUtilizator}
            setPostari={setPostari}
            normalizeaza={normalizeazaPostare}
          />
        )}

        {paginaActiva === 'calendar' && (
          <Calendar postari={postariVizibile} clienti={clientiVizibili} setPaginaActiva={setPaginaActiva} setPostareEdit={setPostareEdit} />
        )}

        {paginaActiva === 'inbox' && inboxV3Vizibil && (
          <InboxV3
            clientPreSelectat={clientAlesObiect ? clientAlesObiect.id : null}
            sesiune={sesiune}
            rol={profilUtilizator ? profilUtilizator.rol : null}
          />
        )}

        {paginaActiva === 'aprobare' && (
          <Aprobare
            postari={postariVizibile}
            setPostari={setPostari}
          />
        )}

        {paginaActiva === 'aprobate' && (
          <PostariAprobate postari={postariVizibile} retele={RETELE} statusInfo={STATUS_INFO} iconRetea={(id, size) => <IconRetea id={id} size={size} />} deschideGrup={(p) => deschidePostarea(p, setPaginaActiva, setPostareEdit)} />
        )}

        {paginaActiva === 'analize' && <Analize clienti={clientiVizibili} />}

        {paginaActiva === 'biblioteca' && (
          <Biblioteca clienti={clientiVizibili} biblioteca={biblioteca} setBiblioteca={setBiblioteca} />
        )}
        {paginaActiva === 'asistent' && <CheiPriza rol="manager" clienti={clientiManager} />}
      </div>
    </div>
  );
}
export default App;

